import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** Mongo ObjectId scalar type */
  ObjectId: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AddDealItemsToStorageUnitArgs = {
  dealId: Scalars['ObjectId'];
  itemIds: Array<Scalars['ObjectId']>;
  note?: InputMaybe<Scalars['String']>;
  setDealToPayedAndStored?: InputMaybe<Scalars['Boolean']>;
  storageDate?: InputMaybe<Scalars['DateTime']>;
  storageFacilityId: Scalars['ObjectId'];
  storageUnits: ItemStorageUnitsArgs;
};

export type AddItemToStorageUnitArgs = {
  itemId: Scalars['ObjectId'];
  note?: InputMaybe<Scalars['String']>;
  setDealToPayedAndStored?: InputMaybe<Scalars['Boolean']>;
  storageDate?: InputMaybe<Scalars['DateTime']>;
  storageFacilityId: Scalars['ObjectId'];
  storageUnits: ItemStorageUnitsArgs;
};

export type AdditionalInfoShippingLabel = {
  amount?: InputMaybe<Scalars['Float']>;
  bankInfo?: InputMaybe<Scalars['String']>;
  paymentReference?: InputMaybe<Scalars['String']>;
};

export type AdditionalInformationForCarPawn = {
  __typename?: 'AdditionalInformationForCarPawn';
  appearSerious?: Maybe<Scalars['Boolean']>;
  citizenship?: Maybe<ECountry>;
  employed?: Maybe<Scalars['Boolean']>;
  hasCarPawnRelationshipWithCashy?: Maybe<Scalars['Boolean']>;
  hasSeizureEvident?: Maybe<Scalars['Boolean']>;
  inInsolvencyDatabaseIn3Years?: Maybe<Scalars['Boolean']>;
  lastResidentialAddressSince?: Maybe<Scalars['DateTime']>;
  paySlipsPresented?: Maybe<Scalars['Boolean']>;
  registeredInAustriaSince?: Maybe<Scalars['DateTime']>;
};

export type AdditionalInformationForCarPawnArgs = {
  appearSerious?: InputMaybe<Scalars['Boolean']>;
  citizenship?: InputMaybe<ECountry>;
  employed?: InputMaybe<Scalars['Boolean']>;
  hasCarPawnRelationshipWithCashy?: InputMaybe<Scalars['Boolean']>;
  hasSeizureEvident?: InputMaybe<Scalars['Boolean']>;
  inInsolvencyDatabaseIn3Years?: InputMaybe<Scalars['Boolean']>;
  lastResidentialAddressSince?: InputMaybe<Scalars['DateTime']>;
  paySlipsPresented?: InputMaybe<Scalars['Boolean']>;
  registeredInAustriaSince?: InputMaybe<Scalars['DateTime']>;
};

export type AmountForCategoryArgs = {
  amount: Scalars['Float'];
  categoryId: Scalars['ObjectId'];
};

/** Union of wrappers around EManualPaymentType and EAutomaticPaymentType */
export type AnyPaymentType = AutomaticPaymentWrapper | ManualPaymentWrapper;

export type AppraisalAnswerInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AppraisalCheckoutPayload = {
  __typename?: 'AppraisalCheckoutPayload';
  algoliaReference?: Maybe<Scalars['String']>;
  answers: Array<ItemAnswer>;
  durationInDays: Scalars['Int'];
  existingCurrentMarketValue?: Maybe<Scalars['Float']>;
  existingPredictedMarketValue?: Maybe<Scalars['Float']>;
  isInvestmentGold?: Maybe<Scalars['Boolean']>;
  itemCategoryId: Scalars['ObjectId'];
  kind: EAppraisalCheckoutKind;
  material?: Maybe<Scalars['String']>;
  useOldValuesOfPrediction?: Maybe<Scalars['Boolean']>;
};

export type AppraisalHandoffResult = {
  __typename?: 'AppraisalHandoffResult';
  message: Scalars['String'];
  target: EAppraisalHandoffTarget;
  vehicle?: Maybe<AppraisalVehicleHandoff>;
};

export type AppraisalQuestion = {
  __typename?: 'AppraisalQuestion';
  hint?: Maybe<Scalars['String']>;
  inputType: EAppraisalQuestionInputType;
  key: Scalars['String'];
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  optionDescriptions?: Maybe<Array<Scalars['String']>>;
  optional?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Scalars['String']>>;
  placeholder?: Maybe<Scalars['String']>;
  prefill?: Maybe<Scalars['String']>;
  skippable?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
};

export type AppraisalQuestionsStep = {
  __typename?: 'AppraisalQuestionsStep';
  context: Scalars['String'];
  isFinalStep: Scalars['Boolean'];
  productName: Scalars['String'];
  questions: Array<AppraisalQuestion>;
};

export type AppraisalRejectionResult = {
  __typename?: 'AppraisalRejectionResult';
  message: Scalars['String'];
  reason: EAppraisalRejectionReason;
};

export type AppraisalRequestResult = {
  __typename?: 'AppraisalRequestResult';
  answers: Array<ItemAnswer>;
  itemCategoryId: Scalars['ObjectId'];
  maxAmount: Scalars['Int'];
  message: Scalars['String'];
  minAmount: Scalars['Int'];
  path: EAppraisalPath;
  productName: Scalars['String'];
  suggestedAmount: Scalars['Int'];
};

export type AppraisalSeedStats = {
  __typename?: 'AppraisalSeedStats';
  pricedProducts: Scalars['Int'];
  recognitionOnlyProducts: Scalars['Int'];
  variants: Scalars['Int'];
};

export type AppraisalStepResult = AppraisalHandoffResult | AppraisalQuestionsStep | AppraisalRejectionResult | AppraisalRequestResult | AppraisalValuationResult;

export type AppraisalValuationResult = {
  __typename?: 'AppraisalValuationResult';
  adjustQuestions?: Maybe<Array<AppraisalQuestion>>;
  checkout?: Maybe<AppraisalCheckoutPayload>;
  context?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  isAiGenerated: Scalars['Boolean'];
  marketValue?: Maybe<Scalars['Float']>;
  path: EAppraisalPath;
  payoutAmount: Scalars['Float'];
  productName: Scalars['String'];
};

export type AppraisalVehicleHandoff = {
  __typename?: 'AppraisalVehicleHandoff';
  desiredAmount?: Maybe<Scalars['Int']>;
  fuel?: Maybe<Scalars['String']>;
  horsePower?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  mileageKm?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  registrationYear?: Maybe<Scalars['Int']>;
};

export type Auction = {
  __typename?: 'Auction';
  _id: Scalars['ObjectId'];
  auctionAnnouncementLink?: Maybe<FileMetadata>;
  auctionDate: Scalars['DateTime'];
  auctionElements: Array<AuctionElement>;
  closeError?: Maybe<AuctionCloseError>;
  company: Company;
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  creationType: EAuctionCreationType;
  internalAuctionAnnouncementLink?: Maybe<FileMetadata>;
  items?: Maybe<Array<AuctionItem>>;
  shopId: Scalars['ObjectId'];
  status: EAuctionStatus;
  withdrawnDeals?: Maybe<Array<WithdrawnDeal>>;
};

export type AuctionCloseError = {
  __typename?: 'AuctionCloseError';
  data?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type AuctionCreateArgs = {
  auctionDate: Scalars['DateTime'];
  auctionElementCreateArgs: Array<AuctionElementCreateArgs>;
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  creationType: EAuctionCreationType;
  shopId: Scalars['ObjectId'];
};

export type AuctionDeleteArgs = {
  auctionId: Scalars['ObjectId'];
};

export type AuctionElement = {
  __typename?: 'AuctionElement';
  addedToAuctionAt: Scalars['DateTime'];
  addedToAuctionType: EAuctionCreationType;
  bookingNumber: Scalars['Float'];
  dealId: Scalars['ObjectId'];
};

export type AuctionElementCreateArgs = {
  addedToAuctionAt: Scalars['DateTime'];
  addedToAuctionType: EAuctionCreationType;
  bookingNumber: Scalars['Float'];
  dealId: Scalars['ObjectId'];
};

export type AuctionItem = {
  __typename?: 'AuctionItem';
  buyer?: Maybe<AuctionItemBuyer>;
  buyerName?: Maybe<Scalars['String']>;
  dealId: Scalars['ObjectId'];
  finalPrice?: Maybe<Scalars['Float']>;
  item?: Maybe<Item>;
  itemId: Scalars['ObjectId'];
  note?: Maybe<Scalars['String']>;
  notedBy?: Maybe<Scalars['ObjectId']>;
  paymentMethod?: Maybe<EManualPaymentType>;
  startPrice: Scalars['Float'];
  status: EAuctionItemStatus;
  surchargeConfirmationLink?: Maybe<FileMetadata>;
};

export type AuctionItemAnonyBuyer = AuctionItemBuyerBase & {
  __typename?: 'AuctionItemAnonyBuyer';
  type: EAuctionBuyerType;
};

export type AuctionItemArgs = {
  auctionId: Scalars['ObjectId'];
  buyer?: InputMaybe<AuctionItemBuyerArgs>;
  buyerName?: InputMaybe<Scalars['String']>;
  finalPrice?: InputMaybe<Scalars['Float']>;
  itemId: Scalars['ObjectId'];
  note?: InputMaybe<Scalars['String']>;
  notedBy?: InputMaybe<Scalars['ObjectId']>;
  paymentMethod?: InputMaybe<EManualPaymentType>;
  shouldBeRemovedFromStorage?: InputMaybe<Scalars['Boolean']>;
};

export type AuctionItemBuyer = AuctionItemAnonyBuyer | AuctionItemExistingCustomer | AuctionItemNewCustomer;

export type AuctionItemBuyerArgs = {
  address?: InputMaybe<IAddress>;
  createCashyAccount?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  type: EAuctionBuyerType;
};

export type AuctionItemBuyerBase = {
  type: EAuctionBuyerType;
};

export type AuctionItemExistingCustomer = AuctionItemBuyerBase & {
  __typename?: 'AuctionItemExistingCustomer';
  customer?: Maybe<Customer>;
  customerId: Scalars['ObjectId'];
  type: EAuctionBuyerType;
};

export type AuctionItemNewCustomer = AuctionItemBuyerBase & {
  __typename?: 'AuctionItemNewCustomer';
  address: OAddress;
  cashyAccountCreated?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  newCustomer?: Maybe<Customer>;
  newCustomerId?: Maybe<Scalars['ObjectId']>;
  phoneNumber?: Maybe<Scalars['String']>;
  type: EAuctionBuyerType;
};

export type AuctionUpdateArgs = {
  _id: Scalars['ObjectId'];
  auctionDate?: InputMaybe<Scalars['DateTime']>;
  auctionElementCreateArgs?: InputMaybe<Array<AuctionElementCreateArgs>>;
  companyId: Scalars['ObjectId'];
  note?: InputMaybe<Scalars['String']>;
  shopId: Scalars['ObjectId'];
  status?: InputMaybe<EAuctionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AuctionsFiltersArgs = {
  auctionStatus?: InputMaybe<EAuctionStatus>;
  companyId?: InputMaybe<Scalars['ObjectId']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']>;
};

export type AutomaticPaymentWrapper = {
  __typename?: 'AutomaticPaymentWrapper';
  value: EAutomaticPaymentType;
};

export type AvailablePropertyBooleanOption = {
  __typename?: 'AvailablePropertyBooleanOption';
  booleanValue: Scalars['Boolean'];
};

export type AvailablePropertyNumberOption = {
  __typename?: 'AvailablePropertyNumberOption';
  numberValue: Scalars['Float'];
};

export type AvailablePropertyTextOption = {
  __typename?: 'AvailablePropertyTextOption';
  id: Scalars['ObjectId'];
  translation: TranslatedString;
};

export type AvailablePropertyTextOptionArgs = {
  id?: InputMaybe<Scalars['ObjectId']>;
  translation: Array<MultipleLanguageTextArgs>;
};

export type AvailablePropertyValues = ProductAvailableBooleanProperty | ProductAvailableNumberProperty | ProductAvailableTextProperty;

export type BaseCustomDealFormQuestion = {
  _id: Scalars['ObjectId'];
  info: TranslatedString;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type BaseDealEvent = {
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type BlacklistInformation = {
  __typename?: 'BlacklistInformation';
  hasCashyAccount?: Maybe<Scalars['Boolean']>;
  isAddedToBlacklist: Scalars['Boolean'];
};

export type BooleanCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'BooleanCustomDealFormQuestion';
  _id: Scalars['ObjectId'];
  info: TranslatedString;
  initialBooleanAnswer?: Maybe<Scalars['Boolean']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type BooleanFilter = {
  condition?: InputMaybe<EBooleanFilterConditions>;
  value: Scalars['Boolean'];
};

export type BuyBackData = {
  __typename?: 'BuyBackData';
  grossProfit?: Maybe<Scalars['Float']>;
  isPawnAgain?: Maybe<Scalars['Boolean']>;
  partialRepayment?: Maybe<Scalars['Float']>;
  repurchaseFee?: Maybe<Scalars['Float']>;
  totalRepurchaseFee?: Maybe<Scalars['Float']>;
};

export type BuyerBillingAddress = {
  __typename?: 'BuyerBillingAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  coordinates?: Maybe<OCoordinates>;
  /** @deprecated Use `countryCode`. */
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<ECountry>;
  door?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  stairway?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type BuyerBillingAddressArgs = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<ICoordinates>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<ECountry>;
  door?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  stairway?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type BuyerData = {
  __typename?: 'BuyerData';
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['ObjectId']>;
};

export type BuyerDataArgs = {
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ObjectId']>;
};

export type CalculatedFeeDefinition = {
  __typename?: 'CalculatedFeeDefinition';
  appliedGrossAmount: Scalars['Float'];
  appliedNetAmount: Scalars['Float'];
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  finalGrossAmount: Scalars['Float'];
  finalNetAmount: Scalars['Float'];
  isManual: Scalars['Boolean'];
  storedFeeDefinition: StoredFeeDefinition;
  ust: Scalars['Float'];
};

export type CalculationBase = {
  __typename?: 'CalculationBase';
  loanToValuesEntryId: Scalars['ObjectId'];
  setOfFeesIds: Array<Scalars['ObjectId']>;
};

export type CarDealCalculation = IDealCalculation & {
  __typename?: 'CarDealCalculation';
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  competitiveVehiclesForSale?: Maybe<Scalars['Float']>;
  date: Scalars['DateTime'];
  dealCalculationId: Scalars['ObjectId'];
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  loanToValuesEntryId: Scalars['ObjectId'];
  noValuation?: Maybe<Scalars['Boolean']>;
  valuation?: Maybe<ViviValuationResponse>;
};

export type CarDealCalculationArgs = {
  answers: Array<ItemAnswerArgs>;
  companyId: Scalars['ObjectId'];
  condition?: InputMaybe<Scalars['Float']>;
  durationInDays: Scalars['Int'];
  href: Scalars['String'];
  itemCategoryId?: InputMaybe<Scalars['ObjectId']>;
  odometer?: InputMaybe<Scalars['Float']>;
  overwrittenPayoutAmount?: InputMaybe<Scalars['Float']>;
  shouldOverwritePayoutAmount?: InputMaybe<Scalars['Boolean']>;
};

export type CarInspectionArgs = {
  currentMileage: Scalars['Float'];
  dealId: Scalars['ObjectId'];
  finalMaxPawnDate: Scalars['DateTime'];
  has57aGutachtenDue: Scalars['DateTime'];
  itemId: Scalars['ObjectId'];
};

export type CarMakeModelsArgs = {
  make: Scalars['String'];
};

export type CashBookCashFlow = {
  __typename?: 'CashBookCashFlow';
  _id: Scalars['ObjectId'];
  accumulatedBalance: Scalars['Float'];
  attachment?: Maybe<FileMetadata>;
  canceledBy?: Maybe<CashBookCashFlow>;
  canceledById?: Maybe<Scalars['ObjectId']>;
  cancels?: Maybe<CashBookCashFlow>;
  cancelsId?: Maybe<Scalars['ObjectId']>;
  cashBookType: ECashBookType;
  cashFlowNumber: Scalars['Float'];
  closedFeesTotalAmount?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['ObjectId']>;
  createdBy?: Maybe<CashFlowCreator>;
  date: Scalars['DateTime'];
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['ObjectId']>;
  employeeId?: Maybe<Scalars['ObjectId']>;
  inflow?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['ObjectId']>;
  note?: Maybe<Scalars['String']>;
  outflow?: Maybe<Scalars['Float']>;
  paymentReference: ECashBookPaymentReference;
  paymentType: AnyPaymentType;
  ready2OrderInvoices?: Maybe<Array<CashBookCashFlowReady2OrderInvoice>>;
  shopId?: Maybe<Scalars['ObjectId']>;
  storageLabel?: Maybe<Scalars['String']>;
  valorizationEntryId?: Maybe<Scalars['ObjectId']>;
};

export type CashBookCashFlowArgs = {
  attachmentArgs?: InputMaybe<FileTusMetadataArgs>;
  billNumber?: InputMaybe<Scalars['String']>;
  bookingNumber?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['ObjectId']>;
  customerNumber?: InputMaybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  inflow?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  outflow?: InputMaybe<Scalars['Float']>;
  paymentReference: ECashBookPaymentReference;
  paymentType: EManualPaymentType;
  shopId?: InputMaybe<Scalars['ObjectId']>;
  storageLabel?: InputMaybe<Scalars['String']>;
  valorizationEntryId?: InputMaybe<Scalars['ObjectId']>;
};

export type CashBookCashFlowCancel = {
  __typename?: 'CashBookCashFlowCancel';
  canceled: CashBookCashFlow;
  cancels: CashBookCashFlow;
};

export type CashBookCashFlowEdge = {
  __typename?: 'CashBookCashFlowEdge';
  cursor: Scalars['String'];
  node: CashBookCashFlow;
};

export type CashBookCashFlowFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  cashBookType?: InputMaybe<ECashBookType>;
  cashFlowNumber?: InputMaybe<Scalars['Float']>;
  companyId?: InputMaybe<IdFilter>;
  date?: InputMaybe<DateFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  paymentType?: InputMaybe<EManualPaymentType>;
  shopId?: InputMaybe<IdFilter>;
  valorizationEntryId?: InputMaybe<Scalars['ObjectId']>;
};

export type CashBookCashFlowLatestBalanceFilterArgs = {
  date: DateFilter;
  paymentType: EManualPaymentType;
  shopId: IdFilter;
};

export type CashBookCashFlowOpts = {
  filter?: InputMaybe<CashBookCashFlowFilterArgs>;
  order?: InputMaybe<CashBookCashFlowOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CashBookCashFlowOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  cashFlowNumber?: InputMaybe<EOrderBy>;
};

export type CashBookCashFlowPaymentReferenceHelper = {
  __typename?: 'CashBookCashFlowPaymentReferenceHelper';
  value: ECashBookPaymentReference;
};

export type CashBookCashFlowReady2OrderInvoice = {
  __typename?: 'CashBookCashFlowReady2OrderInvoice';
  numberFull: Scalars['String'];
};

export type CashBookCount = {
  __typename?: 'CashBookCount';
  _id: Scalars['ObjectId'];
  cashBoxEntries: Array<CashBookCountCashBoxEntry>;
  date: Scalars['DateTime'];
  employee: Employee;
  employeeId: Scalars['ObjectId'];
  paymentType: EManualPaymentType;
  shopId: Scalars['ObjectId'];
  temporary?: Maybe<Scalars['Boolean']>;
};

export type CashBookCountArgs = {
  cashBoxEntries: Array<CashBookCountCashBoxEntryArgs>;
  date: Scalars['DateTime'];
  employeeId: Scalars['ObjectId'];
  paymentType: EManualPaymentType;
  shopId: Scalars['ObjectId'];
  temporary?: InputMaybe<Scalars['Boolean']>;
};

export type CashBookCountCashBoxEntry = {
  __typename?: 'CashBookCountCashBoxEntry';
  cashBoxName: Scalars['String'];
  counts: CashBookCountCounts;
};

export type CashBookCountCashBoxEntryArgs = {
  cashBoxName: Scalars['String'];
  counts: CashBookCountCountsArgs;
};

export type CashBookCountCounts = {
  __typename?: 'CashBookCountCounts';
  EURO_1: Scalars['Float'];
  EURO_2: Scalars['Float'];
  EURO_5: Scalars['Float'];
  EURO_10: Scalars['Float'];
  EURO_20: Scalars['Float'];
  EURO_50: Scalars['Float'];
  EURO_100: Scalars['Float'];
  EURO_200: Scalars['Float'];
  EURO_500: Scalars['Float'];
  EURO_CENT_1: Scalars['Float'];
  EURO_CENT_2: Scalars['Float'];
  EURO_CENT_5: Scalars['Float'];
  EURO_CENT_10: Scalars['Float'];
  EURO_CENT_20: Scalars['Float'];
  EURO_CENT_50: Scalars['Float'];
};

export type CashBookCountCountsArgs = {
  EURO_1: Scalars['Float'];
  EURO_2: Scalars['Float'];
  EURO_5: Scalars['Float'];
  EURO_10: Scalars['Float'];
  EURO_20: Scalars['Float'];
  EURO_50: Scalars['Float'];
  EURO_100: Scalars['Float'];
  EURO_200: Scalars['Float'];
  EURO_500: Scalars['Float'];
  EURO_CENT_1: Scalars['Float'];
  EURO_CENT_2: Scalars['Float'];
  EURO_CENT_5: Scalars['Float'];
  EURO_CENT_10: Scalars['Float'];
  EURO_CENT_20: Scalars['Float'];
  EURO_CENT_50: Scalars['Float'];
};

export type CashBookCountEuroDenominationHelper = {
  __typename?: 'CashBookCountEuroDenominationHelper';
  value: EEuroDenomination;
};

export type CashBookCountFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  date?: InputMaybe<DateFilter>;
  employeeId?: InputMaybe<IdFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  paymentType?: InputMaybe<EManualPaymentType>;
  shopId?: InputMaybe<IdFilter>;
  temporary?: InputMaybe<BooleanFilter>;
};

export type CashBookCountOpts = {
  filter?: InputMaybe<CashBookCountFilterArgs>;
  order?: InputMaybe<CashBookCountOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CashBookCountOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  date?: InputMaybe<EOrderBy>;
};

export type CashBookCountUpdateArgs = {
  _id: Scalars['ObjectId'];
  cashBoxEntries?: InputMaybe<Array<CashBookCountCashBoxEntryArgs>>;
  employeeId?: InputMaybe<Scalars['ObjectId']>;
  temporary?: InputMaybe<Scalars['Boolean']>;
};

/** Employee | SystemOperation | UnzerTransaction */
export type CashFlowCreator = Employee | SystemOperation | UnzerTransaction;

export type CategorizedUploadedFile = {
  __typename?: 'CategorizedUploadedFile';
  fileCategoryName: Scalars['String'];
  uploadedFiles: Array<FileMetadata>;
};

export type CategoryCountrySpecific = {
  __typename?: 'CategoryCountrySpecific';
  _id: Scalars['ObjectId'];
  bulletComponents: Array<ContentComponent>;
  bulletTitle: Scalars['String'];
  country: EStrapiContentCountry;
  headerComponents: Array<ContentComponent>;
};

export type CategoryPage = {
  __typename?: 'CategoryPage';
  _id: Scalars['ObjectId'];
  categoryImage?: Maybe<UploadFile>;
  categoryImageId?: Maybe<Scalars['ObjectId']>;
  categoryLabel: Scalars['String'];
  countrySpecific?: Maybe<CategoryCountrySpecific>;
  countrySpecificComponents: Array<ContentComponent>;
  customMaxLoanToValue?: Maybe<Scalars['Float']>;
  customRequestLvl0Category?: Maybe<Scalars['String']>;
  fallbackImage?: Maybe<UploadFile>;
  fallbackImageId?: Maybe<Scalars['ObjectId']>;
  faqsIds: Array<Scalars['ObjectId']>;
  inNumbersComponent: Array<ContentComponent>;
  introDescription?: Maybe<Scalars['String']>;
  introTitle?: Maybe<Scalars['String']>;
  isLeaveCategory?: Maybe<Scalars['Boolean']>;
  isSpecialPage?: Maybe<Scalars['Boolean']>;
  itemCategory?: Maybe<ItemCategory>;
  language: Scalars['String'];
  lvl0ContentCategory: Scalars['String'];
  lvl1ContentCategory?: Maybe<Scalars['String']>;
  lvl2ContentCategory?: Maybe<Scalars['String']>;
  lvl3ContentCategory?: Maybe<Scalars['String']>;
  maxLoanToValue?: Maybe<Scalars['Float']>;
  metaDescription: Scalars['String'];
  order: Scalars['Float'];
  pageFaqsComponents: Array<ContentComponent>;
  pageTitle: Scalars['String'];
  path: Scalars['String'];
  published_at?: Maybe<Scalars['DateTime']>;
  selectorHeading: Scalars['String'];
  telephone?: Maybe<Scalars['String']>;
  visibleOnDomain?: Maybe<EVisibleOnDomain>;
  whatsAppDescription?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
};


export type CategoryPageCountrySpecificArgs = {
  country?: InputMaybe<EStrapiContentCountry>;
};

export type CategoryPageContent = {
  __typename?: 'CategoryPageContent';
  availableRegions?: Maybe<Array<ERegionCode>>;
  childPages: Array<CategoryPage>;
  page: CategoryPage;
  parentPages: CategoryPageParents;
};


export type CategoryPageContentChildPagesArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
  visibleOnDomain?: InputMaybe<EStrapiContentCountry>;
};


export type CategoryPageContentParentPagesArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryPageFilterArgs = {
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  isSpecialPage?: InputMaybe<BooleanFilter>;
  language?: InputMaybe<Scalars['String']>;
  lvl0ContentCategory?: InputMaybe<StringFilter>;
  lvl0ContentCategoryExists?: InputMaybe<Scalars['Boolean']>;
  lvl1ContentCategory?: InputMaybe<StringFilter>;
  lvl1ContentCategoryExists?: InputMaybe<Scalars['Boolean']>;
  lvl2ContentCategory?: InputMaybe<StringFilter>;
  lvl2ContentCategoryExists?: InputMaybe<Scalars['Boolean']>;
  lvl3ContentCategory?: InputMaybe<StringFilter>;
  lvl3ContentCategoryExists?: InputMaybe<Scalars['Boolean']>;
  path?: InputMaybe<StringFilter>;
  visibleOnDomain?: InputMaybe<EStrapiContentCountry>;
};

export type CategoryPageOpts = {
  filter?: InputMaybe<CategoryPageFilterArgs>;
  order?: InputMaybe<CategoryPageOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CategoryPageOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  categoryLabel?: InputMaybe<EOrderBy>;
  maxLoanToValue?: InputMaybe<EOrderBy>;
  order?: InputMaybe<EOrderBy>;
};

export type CategoryPageParents = {
  __typename?: 'CategoryPageParents';
  lvl0?: Maybe<CategoryPage>;
  lvl1?: Maybe<CategoryPage>;
  lvl2?: Maybe<CategoryPage>;
};

export type CategoryPages = {
  __typename?: 'CategoryPages';
  lvl0?: Maybe<CategoryPage>;
  lvl1?: Maybe<CategoryPage>;
  lvl2?: Maybe<CategoryPage>;
  lvl3?: Maybe<CategoryPage>;
};

export type Company = {
  __typename?: 'Company';
  _id: Scalars['ObjectId'];
  accountOwner?: Maybe<Scalars['String']>;
  automotivesOnly?: Maybe<Scalars['Boolean']>;
  bic?: Maybe<Scalars['String']>;
  carPawnSettings?: Maybe<CompanyCarPawnSettings>;
  companyCounter?: Maybe<CompanyCounter>;
  companyCounterId?: Maybe<Scalars['ObjectId']>;
  configuration: CompanyConfiguration;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  dpdAccountInfo?: Maybe<DpdAccountInfo>;
  email?: Maybe<Scalars['String']>;
  fibuNumber: Scalars['String'];
  headquarter?: Maybe<OAddress>;
  iban?: Maybe<Scalars['String']>;
  isDeactivated?: Maybe<Scalars['Boolean']>;
  jurisdiction?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paypalEmail?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  predecessionCompany?: Maybe<Company>;
  primaryShopLocationId: Scalars['ObjectId'];
  saleSupportEmail?: Maybe<Scalars['String']>;
  salesConfiguration: CompanySalesConfiguration;
  successionCompany?: Maybe<Company>;
  successionCompanyId?: Maybe<Scalars['ObjectId']>;
  supportEmail?: Maybe<Scalars['String']>;
  uid: Scalars['String'];
  unzerConfiguration?: Maybe<CompanyUnzerConfiguration>;
  website?: Maybe<Scalars['String']>;
  whatsappNumber?: Maybe<Scalars['String']>;
};

export type CompanyCarPawnSettings = {
  __typename?: 'CompanyCarPawnSettings';
  includeLicensePlate?: Maybe<Scalars['Boolean']>;
  includeSpareTireCount?: Maybe<Scalars['Boolean']>;
};

export type CompanyConfiguration = {
  __typename?: 'CompanyConfiguration';
  differenceTaxRate: Scalars['Float'];
  gracePeriod: Scalars['Int'];
  insuranceFactor: Scalars['Float'];
  liquidationFee: Scalars['Float'];
  minimumPawnDuration: Scalars['Int'];
  payoutConfigurations?: Maybe<OPayoutConfiguration>;
  valorizationFeeRate: Scalars['Float'];
  valueAddedTaxRate: Scalars['Float'];
};

export type CompanyConfigurationArgs = {
  differenceTaxRate: Scalars['Float'];
  gracePeriod: Scalars['Int'];
  insuranceFactor: Scalars['Float'];
  liquidationFee: Scalars['Float'];
  minimumPawnDuration: Scalars['Int'];
  payoutConfigurations?: InputMaybe<PayoutConfigurationsInput>;
  valorizationFeeRate: Scalars['Float'];
  valueAddedTaxRate: Scalars['Float'];
};

export type CompanyCounter = {
  __typename?: 'CompanyCounter';
  billNumbers: Array<YearlyCompanyCounterEntry>;
  bookingNumber?: Maybe<Scalars['Int']>;
  customDealNumber?: Maybe<Scalars['Int']>;
  employeeNumber?: Maybe<Scalars['Int']>;
  isGlobalCounter?: Maybe<Scalars['Boolean']>;
  marketingCreditNoteNumbers: Array<YearlyCompanyCounterEntry>;
  pawnNumber?: Maybe<Scalars['Int']>;
  receiptNumbers: Array<YearlyCompanyCounterEntry>;
  valorizationBillNumbers: Array<YearlyCompanyCounterEntry>;
  valorizationCreditNoteNumbers: Array<YearlyCompanyCounterEntry>;
};

export type CompanyCreateArgs = {
  accountOwner?: InputMaybe<Scalars['String']>;
  bic?: InputMaybe<Scalars['String']>;
  companyCounterId?: InputMaybe<Scalars['ObjectId']>;
  configuration: CompanyConfigurationArgs;
  dpdConfiguration?: InputMaybe<DpdConfigurationArgs>;
  email?: InputMaybe<Scalars['String']>;
  fibuNumber: Scalars['String'];
  headquarter?: InputMaybe<IAddress>;
  iban?: InputMaybe<Scalars['String']>;
  jurisdiction?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  paypalEmail?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  primaryShopLocation: PrimaryShopLocationArgs;
  saleSupportEmail?: InputMaybe<Scalars['String']>;
  salesConfiguration: CompanySalesConfigurationArgs;
  successionCompanyId?: InputMaybe<Scalars['ObjectId']>;
  supportEmail?: InputMaybe<Scalars['String']>;
  uid: Scalars['String'];
  unzerConfiguration?: InputMaybe<CompanyUnzerConfigurationArgs>;
  website?: InputMaybe<Scalars['String']>;
  whatsappNumber?: InputMaybe<Scalars['String']>;
};

export type CompanyFeesEvaluation = {
  __typename?: 'CompanyFeesEvaluation';
  feeEvaluationItemCategories: Array<FeeEvaluationItemCategory>;
  generalFeesEvaluation: FeeDefinitionEvaluation;
};

export type CompanyFilterArgs = {
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  isDeactivated?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<Scalars['String']>;
};

export type CompanyOpts = {
  filter?: InputMaybe<CompanyFilterArgs>;
  order?: InputMaybe<CompanyOrderArgs>;
};

export type CompanyOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type CompanyRefurbedStaggeredMarginArgs = {
  expectedMargin: Scalars['Float'];
  from: Scalars['Float'];
  minimumMargin: Scalars['Float'];
};

export type CompanySalesConfiguration = {
  __typename?: 'CompanySalesConfiguration';
  refurbedCommission: Scalars['Float'];
  refurbedStaggeredMargins: Array<RefurbedStaggeredMargin>;
};

export type CompanySalesConfigurationArgs = {
  refurbedCommission: Scalars['Float'];
  refurbedStaggeredMargins: Array<CompanyRefurbedStaggeredMarginArgs>;
};

export type CompanyUnzerConfiguration = {
  __typename?: 'CompanyUnzerConfiguration';
  companyCode?: Maybe<Scalars['String']>;
  privateKeyStored?: Maybe<Scalars['Boolean']>;
  publicKey?: Maybe<Scalars['String']>;
  webhookId?: Maybe<Scalars['String']>;
};

export type CompanyUnzerConfigurationArgs = {
  companyCode?: InputMaybe<Scalars['String']>;
  privateKey?: InputMaybe<Scalars['String']>;
  publicKey?: InputMaybe<Scalars['String']>;
};

export type ConditionMaxMarketValues = {
  __typename?: 'ConditionMaxMarketValues';
  excellent: Scalars['Float'];
  good: Scalars['Float'];
  poor: Scalars['Float'];
};

export type ConditionMaxMarketValuesArgs = {
  excellent: Scalars['Float'];
  good: Scalars['Float'];
  poor: Scalars['Float'];
};

export type ConfirmExtensionArgs = {
  dealExtensionCalculationId: Scalars['ObjectId'];
  dealId: Scalars['ObjectId'];
  isChildOverwrittenFees: Scalars['Boolean'];
  isOnlineExtensionPrevented: Scalars['Boolean'];
  onlineExtensionBanNote?: InputMaybe<Scalars['String']>;
  paymentType: EManualPaymentType;
  shopId?: InputMaybe<Scalars['ObjectId']>;
};

export type ConfirmPaybackArgs = {
  dealId: Scalars['ObjectId'];
  dealPaybackCalculationId: Scalars['ObjectId'];
  paymentType: EManualPaymentType;
  removeItemsFromStorage: Scalars['Boolean'];
  shopId?: InputMaybe<Scalars['ObjectId']>;
};

export type ContentCategories = {
  __typename?: 'ContentCategories';
  lvl0: Scalars['String'];
  lvl1?: Maybe<Scalars['String']>;
  lvl2?: Maybe<Scalars['String']>;
  lvl3?: Maybe<Scalars['String']>;
};

export type ContentCategoriesArgs = {
  lvl0: Scalars['String'];
  lvl1?: InputMaybe<Scalars['String']>;
  lvl2?: InputMaybe<Scalars['String']>;
  lvl3?: InputMaybe<Scalars['String']>;
};

export type ContentComponent = {
  __typename?: 'ContentComponent';
  _id: Scalars['ObjectId'];
  kind: Scalars['String'];
  ref: Scalars['ObjectId'];
};

export type CreateOrUpdateReady2OrderApiKeyArgs = {
  ready2OrderApiKey: Scalars['String'];
  shopId: Scalars['ObjectId'];
};

export type CreateProduct = {
  ean?: InputMaybe<Scalars['String']>;
  gewicht?: InputMaybe<Scalars['Float']>;
  isInactive?: InputMaybe<Scalars['Boolean']>;
  isTaxFree?: InputMaybe<Scalars['Boolean']>;
  karat?: InputMaybe<Scalars['Float']>;
  lvl0Category: Scalars['String'];
  lvl0ContentCategory?: InputMaybe<Scalars['String']>;
  lvl1Category?: InputMaybe<Scalars['String']>;
  lvl1ContentCategory?: InputMaybe<Scalars['String']>;
  lvl2Category?: InputMaybe<Scalars['String']>;
  lvl2ContentCategory?: InputMaybe<Scalars['String']>;
  lvl3ContentCategory?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  objectID: Scalars['String'];
  pictureFilename?: InputMaybe<Scalars['String']>;
  productTags?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type CreditcardPaymentArgs = {
  paymentId: Scalars['String'];
};

export type CustomDeal = {
  __typename?: 'CustomDeal';
  _id: Scalars['ObjectId'];
  acceptedBy?: Maybe<Employee>;
  availableTransportModes: Array<ETransportMode>;
  company: Company;
  companyId: Scalars['ObjectId'];
  contactData: CustomDealContactData;
  createdAt: Scalars['DateTime'];
  customDealItemsIds: Array<Scalars['ObjectId']>;
  customDealNumber: Scalars['Float'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ObjectId']>;
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['ObjectId']>;
  dealType: EDealType;
  deletedAt?: Maybe<Scalars['DateTime']>;
  durationInDays: Scalars['Float'];
  employeeId?: Maybe<Scalars['ObjectId']>;
  employeeResponse?: Maybe<CustomDealEmployeeResponse>;
  events: Array<CustomDealEvent>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPayoutOverwritten?: Maybe<Scalars['Boolean']>;
  isReversedFeeCalculation?: Maybe<Scalars['Boolean']>;
  issuanceCertificate?: Maybe<FileMetadata>;
  items: Array<CustomDealItemDataEntry>;
  link?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Note>>;
  overridePayoutAmount: Scalars['Float'];
  pawnCalculation?: Maybe<CustomDealCalculation>;
  payoutApproverId?: Maybe<Scalars['ObjectId']>;
  pickupTransportMode?: Maybe<ETransportMode>;
  policeNumber?: Maybe<Scalars['String']>;
  purchaseCalculation?: Maybe<CustomDealCalculation>;
  qualified?: Maybe<CustomDealQualification>;
  status?: Maybe<ECustomDealStatusType>;
  updatedAt: Scalars['DateTime'];
};

export type CustomDealCalculation = {
  __typename?: 'CustomDealCalculation';
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  date: Scalars['DateTime'];
  dealType: EDealType;
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  payoutAmount: Scalars['Float'];
  token: Scalars['String'];
};

export type CustomDealCalculationArgs = {
  calculationItems: Array<CustomDealCalculationItem>;
  companyId: Scalars['ObjectId'];
  date?: InputMaybe<Scalars['DateTime']>;
  durationInDays: Scalars['Float'];
  isReversedFeeCalculation: Scalars['Boolean'];
  pickupTransportMode?: InputMaybe<ETransportMode>;
};

export type CustomDealCalculationItem = {
  algoliaReference?: InputMaybe<Scalars['String']>;
  answers: Array<ItemAnswerArgs>;
  customPayoutAmount?: InputMaybe<Scalars['Float']>;
  existingCurrentMarketValue?: InputMaybe<Scalars['Float']>;
  existingPredictedMarketValue?: InputMaybe<Scalars['Float']>;
  foundComparableOffersPrices?: InputMaybe<Array<Scalars['Float']>>;
  foundOffersEvaluationFactor?: InputMaybe<Scalars['Float']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']>;
  itemCategoryId: Scalars['ObjectId'];
  material?: InputMaybe<Scalars['String']>;
  overwrittenItemValue?: InputMaybe<Scalars['Float']>;
  overwrittenPawnPayoutAmount?: InputMaybe<Scalars['Float']>;
  overwrittenPurchasePayoutAmount?: InputMaybe<Scalars['Float']>;
  payoutAmount?: InputMaybe<Scalars['Float']>;
  skipPredictionTags?: InputMaybe<Scalars['Boolean']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  useOldValuesOfPrediction?: InputMaybe<Scalars['Boolean']>;
  variantId?: InputMaybe<Scalars['ObjectId']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type CustomDealContactData = {
  __typename?: 'CustomDealContactData';
  blacklistInformation?: Maybe<BlacklistInformation>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CustomDealContactDataArgs = {
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CustomDealCreateArgs = {
  companyId: Scalars['ObjectId'];
  contactData: CustomDealContactDataArgs;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  date?: InputMaybe<Scalars['DateTime']>;
  dealType: EDealType;
  durationInDays: Scalars['Float'];
  employeeId?: InputMaybe<Scalars['ObjectId']>;
  isItemEvaluationMissing?: InputMaybe<Scalars['Boolean']>;
  items: Array<CustomDealItemCreateArgs>;
  notes?: InputMaybe<Array<NoteCreateArgs>>;
  payoutApprover?: InputMaybe<Scalars['Boolean']>;
  pickupTransportMode?: InputMaybe<ETransportMode>;
};

export type CustomDealCustomerFilterArgs = {
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  lastname?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
};

export type CustomDealEmployeeResponse = {
  __typename?: 'CustomDealEmployeeResponse';
  closingText: Scalars['String'];
  editableText: Scalars['String'];
  name: Scalars['String'];
  openingText: Scalars['String'];
  subject: Scalars['String'];
};

export type CustomDealEmployeeResponseArgs = {
  closingText: Scalars['String'];
  editableText: Scalars['String'];
  name: Scalars['String'];
  openingText: Scalars['String'];
  subject: Scalars['String'];
};

export type CustomDealEvent = {
  __typename?: 'CustomDealEvent';
  createdAt: Scalars['DateTime'];
  creatorId?: Maybe<Scalars['ObjectId']>;
  event: ECustomDealStatusType;
  sentReminderEmailToCustomer?: Maybe<Scalars['Boolean']>;
  timestamp: Scalars['DateTime'];
};

export type CustomDealFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  companyId?: InputMaybe<IdFilter>;
  customDealItem?: InputMaybe<CustomDealItemFilterArgs>;
  customer?: InputMaybe<CustomDealCustomerFilterArgs>;
  customerId?: InputMaybe<IdFilter>;
  customerIds?: InputMaybe<IDsFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  includeClosed?: InputMaybe<BooleanFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  itemIds?: InputMaybe<IDsFilter>;
  status?: InputMaybe<StringFilter>;
};

export type CustomDealForm = {
  __typename?: 'CustomDealForm';
  _id: Scalars['ObjectId'];
  categoryId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  isUsedForCommissionSale: Scalars['Boolean'];
  questions: Array<CustomDealFormQuestion>;
  updatedAt: Scalars['DateTime'];
};

export type CustomDealFormCreateArgs = {
  categoryId: Scalars['ObjectId'];
  isUsedForCommissionSale: Scalars['Boolean'];
  questions: Array<CustomDealFormQuestionCreateArgs>;
};

export type CustomDealFormOption = {
  __typename?: 'CustomDealFormOption';
  default: Scalars['Boolean'];
  label: TranslatedString;
};

export type CustomDealFormOptionArgs = {
  default: Scalars['Boolean'];
  description?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  label: Array<MultipleLanguageTextArgs>;
};

export type CustomDealFormQuestion = BooleanCustomDealFormQuestion | FileUploadCustomDealFormQuestion | NumberDefaultCustomDealFormQuestion | NumberOptionsCustomDealFormQuestion | TextDefaultCustomDealFormQuestion | TextMultilineCustomDealFormQuestion | TextOptionsCustomDealFormQuestion;

export type CustomDealFormQuestionByCategory = {
  __typename?: 'CustomDealFormQuestionByCategory';
  isAllowedPurchase: Scalars['Boolean'];
  isUsedForCommissionSale: Scalars['Boolean'];
  questions: Array<CustomDealFormQuestion>;
};

export type CustomDealFormQuestionCreateArgs = {
  allowEnterAnswer?: InputMaybe<Scalars['Boolean']>;
  info: Array<MultipleLanguageTextArgs>;
  initialAnswerArgs?: InputMaybe<CustomDealFormQuestionInitialAnswerArgs>;
  label: Array<MultipleLanguageTextArgs>;
  optional?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<CustomDealFormOptionArgs>>;
  restrictions?: InputMaybe<Array<CustomDealQuestionNumberRestrictionArgs>>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: InputMaybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type CustomDealFormQuestionInitialAnswerArgs = {
  booleanAnswer?: InputMaybe<Scalars['Boolean']>;
  numberAnswer?: InputMaybe<Scalars['Float']>;
  optionNumberAnswer?: InputMaybe<Scalars['Float']>;
  optionTextAnswer?: InputMaybe<Scalars['String']>;
  textAnswer?: InputMaybe<Scalars['String']>;
};

export type CustomDealFormQuestionUpdateArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  allowEnterAnswer?: InputMaybe<Scalars['Boolean']>;
  info: Array<MultipleLanguageTextArgs>;
  initialAnswerArgs?: InputMaybe<CustomDealFormQuestionInitialAnswerArgs>;
  label: Array<MultipleLanguageTextArgs>;
  optional?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<CustomDealFormOptionArgs>>;
  restrictions?: InputMaybe<Array<CustomDealQuestionNumberRestrictionArgs>>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: InputMaybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type CustomDealFormTextOption = {
  __typename?: 'CustomDealFormTextOption';
  default: Scalars['Boolean'];
  description?: Maybe<TranslatedString>;
  label: TranslatedString;
};

export type CustomDealFormUpdateArgs = {
  _id: Scalars['ObjectId'];
  categoryId: Scalars['ObjectId'];
  isUsedForCommissionSale: Scalars['Boolean'];
  questions: Array<CustomDealFormQuestionUpdateArgs>;
};

export type CustomDealItemCreateArgs = {
  algoliaReference?: InputMaybe<Scalars['String']>;
  answers: Array<ItemAnswerArgs>;
  condition?: InputMaybe<ECustomDealItemCondition>;
  counterofferPayoutAmount?: InputMaybe<Scalars['Float']>;
  ean?: InputMaybe<Scalars['String']>;
  formAnswers?: InputMaybe<Array<FormAnswerArgs>>;
  foundComparableOffers?: InputMaybe<ECustomItemFoundComparableOffers>;
  foundOffersEvaluationFactor?: InputMaybe<Scalars['Float']>;
  itemCategoryId: Scalars['ObjectId'];
  material?: InputMaybe<Scalars['String']>;
  mediaUploads?: InputMaybe<Array<FileTusMetadataArgs>>;
  note?: InputMaybe<Scalars['String']>;
  overwrittenItemValue?: InputMaybe<Scalars['Float']>;
  overwrittenPawnPayoutAmount?: InputMaybe<Scalars['Float']>;
  overwrittenPurchasePayoutAmount?: InputMaybe<Scalars['Float']>;
  pawnPayoutAmount: Scalars['Float'];
  policeNumber?: InputMaybe<Scalars['String']>;
  priceFindings?: InputMaybe<Array<PriceFindingArgs>>;
  purchasePayoutAmount: Scalars['Float'];
  title: Scalars['String'];
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  variantId?: InputMaybe<Scalars['ObjectId']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type CustomDealItemDataEntry = {
  __typename?: 'CustomDealItemDataEntry';
  _id: Scalars['ObjectId'];
  algoliaReference?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<ItemAnswer>>;
  counterofferPayoutAmount?: Maybe<Scalars['Float']>;
  ean?: Maybe<Scalars['String']>;
  formAnswers?: Maybe<Array<FormAnswer>>;
  foundComparableOffers?: Maybe<ECustomItemFoundComparableOffers>;
  foundOffersEvaluationFactor?: Maybe<Scalars['Float']>;
  itemCategory: ItemCategory;
  itemCategoryId: Scalars['ObjectId'];
  itemPawnValueEntry?: Maybe<ItemValuesEntry>;
  itemPurchaseValueEntry?: Maybe<ItemValuesEntry>;
  material?: Maybe<Scalars['String']>;
  media?: Maybe<Array<FileMetadata>>;
  note?: Maybe<Scalars['String']>;
  overwrittenItemValue?: Maybe<Scalars['Float']>;
  overwrittenPawnPayoutAmount?: Maybe<Scalars['Float']>;
  overwrittenPurchasePayoutAmount?: Maybe<Scalars['Float']>;
  pawnPayoutAmount: Scalars['Float'];
  policeNumber?: Maybe<Scalars['String']>;
  priceFindings?: Maybe<Array<PriceFinding>>;
  productVariant?: Maybe<ProductVariant>;
  purchasePayoutAmount: Scalars['Float'];
  title: Scalars['String'];
  unconfirmedPropertyIds?: Maybe<Array<Scalars['ObjectId']>>;
  variantId?: Maybe<Scalars['ObjectId']>;
  vehicleData?: Maybe<VehicleData>;
};

export type CustomDealItemFilterArgs = {
  title?: InputMaybe<StringFilter>;
};

export type CustomDealItemUpdateArgs = {
  _id: Scalars['ObjectId'];
  algoliaReference?: InputMaybe<Scalars['String']>;
  answers?: InputMaybe<Array<ItemAnswerArgs>>;
  condition?: InputMaybe<ECustomDealItemCondition>;
  counterofferPayoutAmount?: InputMaybe<Scalars['Float']>;
  ean?: InputMaybe<Scalars['String']>;
  formAnswers?: InputMaybe<Array<FormAnswerArgs>>;
  foundComparableOffers?: InputMaybe<ECustomItemFoundComparableOffers>;
  foundOffersEvaluationFactor?: InputMaybe<Scalars['Float']>;
  itemCategoryId: Scalars['ObjectId'];
  material?: InputMaybe<Scalars['String']>;
  mediaUploads?: InputMaybe<Array<FileTusMetadataArgs>>;
  note?: InputMaybe<Scalars['String']>;
  overwrittenItemValue?: InputMaybe<Scalars['Float']>;
  overwrittenPawnPayoutAmount?: InputMaybe<Scalars['Float']>;
  overwrittenPurchasePayoutAmount?: InputMaybe<Scalars['Float']>;
  pawnPayoutAmount: Scalars['Float'];
  policeNumber?: InputMaybe<Scalars['String']>;
  priceFindings?: InputMaybe<Array<PriceFindingArgs>>;
  purchasePayoutAmount: Scalars['Float'];
  title: Scalars['String'];
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  variantId?: InputMaybe<Scalars['ObjectId']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type CustomDealOpts = {
  filter?: InputMaybe<CustomDealFilterArgs>;
  order?: InputMaybe<CustomDealOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CustomDealOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  createdAt?: InputMaybe<EOrderBy>;
};

export type CustomDealPawnPurchaseCalculations = {
  __typename?: 'CustomDealPawnPurchaseCalculations';
  pawnCalculation: CustomDealCalculation;
  purchaseCalculation?: Maybe<CustomDealCalculation>;
};

export type CustomDealQualification = {
  __typename?: 'CustomDealQualification';
  at: Scalars['DateTime'];
  by: Employee;
  value: Scalars['Float'];
};

export type CustomDealQuestionNumberRestriction = {
  __typename?: 'CustomDealQuestionNumberRestriction';
  conditionOperator: ENumberFilterConditions;
  conditionValue: Scalars['Float'];
  errorMessage: TranslatedString;
};

export type CustomDealQuestionNumberRestrictionArgs = {
  conditionOperator: ENumberFilterConditions;
  conditionValue: Scalars['Float'];
  errorMessage: Array<MultipleLanguageTextArgs>;
};

export type CustomDealRemoveItemArgs = {
  customDealId: Scalars['ObjectId'];
  customDealItemId: Scalars['ObjectId'];
};

export type CustomDealUpdateArgs = {
  _id: Scalars['ObjectId'];
  companyId?: InputMaybe<Scalars['ObjectId']>;
  contactData?: InputMaybe<CustomDealContactDataArgs>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  dealType?: InputMaybe<EDealType>;
  durationInDays?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['ObjectId']>;
  employeeResponse?: InputMaybe<CustomDealEmployeeResponseArgs>;
  payoutApproverId?: InputMaybe<Scalars['ObjectId']>;
  pickupTransportMode?: InputMaybe<ETransportMode>;
  priceFindings?: InputMaybe<Array<PriceFindingArgs>>;
  shopId?: InputMaybe<Scalars['ObjectId']>;
  status?: InputMaybe<ECustomDealStatusType>;
};

export type CustomDealsFilterStatus = {
  from?: InputMaybe<Scalars['DateTime']>;
  mode: EDateFilterMode;
  names: Array<ECustomDealStatusType>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type CustomDealsFiltersArgs = {
  categoryIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  companyId?: InputMaybe<Scalars['ObjectId']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  dealBusinessUnit?: InputMaybe<EBusinessUnit>;
  employeeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  includeClosedCustomDeals?: InputMaybe<Scalars['Boolean']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CustomDealsFilterStatus>;
  type?: InputMaybe<EDealType>;
};

export type CustomDealsWithPagination = {
  __typename?: 'CustomDealsWithPagination';
  records: Array<CustomDeal>;
  totalCount: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type CustomRequest = {
  __typename?: 'CustomRequest';
  _id: Scalars['ObjectId'];
  acceptedBy?: Maybe<Scalars['String']>;
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  calculationBase: CalculationBase;
  createdAt: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['ObjectId'];
  dealData: CustomRequestDealData;
  declinedBy?: Maybe<Scalars['String']>;
  events: Array<CustomRequestEvent>;
  itemsData: Array<CustomRequestItemData>;
  note?: Maybe<Scalars['String']>;
  noteToCustomer?: Maybe<Scalars['Boolean']>;
  pawnContinueUsing?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type CustomRequestDealData = {
  __typename?: 'CustomRequestDealData';
  selected: CustomRequestDealDataEntry;
  verified: CustomRequestDealDataEntry;
};

export type CustomRequestDealDataEntry = {
  __typename?: 'CustomRequestDealDataEntry';
  dealFeesIds: Array<Scalars['ObjectId']>;
  durationInDays: Scalars['Float'];
  payoutAmount: Scalars['Float'];
};

export type CustomRequestEvent = {
  __typename?: 'CustomRequestEvent';
  createdAt: Scalars['DateTime'];
  event: ECustomRequestEvent;
  responsibleAdminId?: Maybe<Scalars['ObjectId']>;
  timestamp: Scalars['DateTime'];
};

export type CustomRequestFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  createdAt?: InputMaybe<DateFilter>;
  customerId?: InputMaybe<IdFilter>;
  customerIds?: InputMaybe<IdFilter>;
  firstnameOrLastNameOrEmail?: InputMaybe<StringFilter>;
  hasEvents?: InputMaybe<Array<ECustomRequestEvent>>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  itemTitle?: InputMaybe<StringFilter>;
  notHasEvents?: InputMaybe<Array<ECustomRequestEvent>>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type CustomRequestItemData = {
  __typename?: 'CustomRequestItemData';
  selected: CustomRequestItemDataEntry;
  verified: CustomRequestItemDataEntry;
};

export type CustomRequestItemDataEntry = {
  __typename?: 'CustomRequestItemDataEntry';
  condition: ECustomRequestCondition;
  isBulkyGood?: Maybe<Scalars['Boolean']>;
  itemCategory?: Maybe<ItemCategory>;
  itemCategoryId: Scalars['ObjectId'];
  itemFeesIds: Array<Scalars['ObjectId']>;
  itemValuesEntry: ItemValuesEntry;
  media?: Maybe<Array<FileMetadata>>;
  note?: Maybe<Scalars['String']>;
  policeNumber?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  vehicleData?: Maybe<VehicleData>;
};

export type CustomRequestOpts = {
  filter?: InputMaybe<CustomRequestFilterArgs>;
  order?: InputMaybe<CustomRequestOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CustomRequestOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  createdAt?: InputMaybe<EOrderBy>;
  updatedAt?: InputMaybe<EOrderBy>;
};

export type Customer = {
  __typename?: 'Customer';
  _id: Scalars['ObjectId'];
  acquiredBy?: Maybe<Scalars['String']>;
  activeDeals: Array<Deal>;
  additionalInformationForCarPawn?: Maybe<AdditionalInformationForCarPawn>;
  addresses?: Maybe<Array<OCustomerAddress>>;
  blacklistInformation?: Maybe<BlacklistInformation>;
  closedDeals: Array<Deal>;
  createdAt: Scalars['DateTime'];
  customDeals: Array<CustomDeal>;
  customRequests: Array<CustomRequest>;
  customerNumber: Scalars['Float'];
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  deactivated?: Maybe<Scalars['Boolean']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  dealHistory: CustomerDealHistory;
  deals: Array<Deal>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  guestEmail?: Maybe<Scalars['String']>;
  hasAlreadyDeals: Scalars['Boolean'];
  iban?: Maybe<Scalars['String']>;
  identityNumber?: Maybe<Scalars['String']>;
  identityType?: Maybe<ECustomerIdentityType>;
  identityUploadLinks?: Maybe<Array<FileMetadata>>;
  identityUploads?: Maybe<Array<Scalars['Upload']>>;
  identityVerifiedAt?: Maybe<Scalars['DateTime']>;
  identityVerifiedBy?: Maybe<Scalars['ObjectId']>;
  identityVerifiedByEmployee?: Maybe<Employee>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isNotePopup?: Maybe<Scalars['Boolean']>;
  isTestUser?: Maybe<Scalars['Boolean']>;
  lastReminderIdentitySentAt?: Maybe<Scalars['DateTime']>;
  lastname: Scalars['String'];
  mergedCustomers?: Maybe<Array<Maybe<MergedCustomer>>>;
  note?: Maybe<Scalars['String']>;
  paypalAddress?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  registrationCertificate?: Maybe<FileMetadata>;
  roles: Array<ERoles>;
  sex?: Maybe<ESex>;
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uploadedFiles?: Maybe<Array<FileMetadata>>;
  userPermission?: Maybe<UserPermission>;
  userPermissionId: Scalars['ObjectId'];
};


export type CustomerActiveDealsArgs = {
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type CustomerClosedDealsArgs = {
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type CustomerCustomRequestsArgs = {
  opts?: InputMaybe<CustomRequestOpts>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type CustomerDealsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};

export type CustomerBlacklist = {
  __typename?: 'CustomerBlacklist';
  _id: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  customers?: Maybe<Array<Customer>>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  employee?: Maybe<Employee>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  reason: Scalars['String'];
};

export type CustomerBlacklistCreateArgs = {
  customerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ObjectId'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  reason: Scalars['String'];
};

export type CustomerBlacklistDeleteArgs = {
  id: Scalars['ObjectId'];
  reason: Scalars['String'];
};

export type CustomerBlacklistFiltersArgs = {
  customerId?: InputMaybe<Scalars['ObjectId']>;
  dateOfBirth?: InputMaybe<DateFilter>;
  email?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type CustomerBlacklistUpdateArgs = {
  customerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ObjectId'];
  firstname: Scalars['String'];
  id: Scalars['ObjectId'];
  lastname: Scalars['String'];
  reason: Scalars['String'];
};

export type CustomerBlacklistsFiltersArgs = {
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']>;
};

export type CustomerByPersonalDataArgs = {
  dateOfBirth: Scalars['DateTime'];
  email: Scalars['String'];
};

export type CustomerCallRequestArgs = {
  companyId: Scalars['ObjectId'];
  customerEmail: Scalars['String'];
  customerFirstName: Scalars['String'];
  customerTelephoneNumber: Scalars['String'];
};

export type CustomerCategoryArgs = {
  customerCategory: ECustomerCategory;
  dealId: Scalars['ObjectId'];
};

export type CustomerDealHistory = {
  __typename?: 'CustomerDealHistory';
  carPawn: CustomerDealHistoryData;
  normalPawn: CustomerDealHistoryData;
};

export type CustomerDealHistoryData = {
  __typename?: 'CustomerDealHistoryData';
  auctionedDealsCount: Scalars['Float'];
  bookedDealsCount: Scalars['Float'];
  extendedDealsCount: Scalars['Float'];
  paidBackDealsCount: Scalars['Float'];
  verifiedDealsCount: Scalars['Float'];
};

export type CustomerFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  acquiredBy?: InputMaybe<StringFilter>;
  customerNumber?: InputMaybe<NumberFilter>;
  dateOfBirth?: InputMaybe<DateFilter>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  firstnameOrLastNameOrEmail?: InputMaybe<StringFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  isDeleted?: InputMaybe<BooleanFilter>;
  isTestUser?: InputMaybe<BooleanFilter>;
  lastname?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
};

export type CustomerOpts = {
  filter?: InputMaybe<CustomerFilterArgs>;
  order?: InputMaybe<CustomerOrderArgs>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CustomerOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  customerNumber?: InputMaybe<EOrderBy>;
  firstname?: InputMaybe<EOrderBy>;
  lastname?: InputMaybe<EOrderBy>;
};

export type CustomerSearchOpts = {
  customerNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
};

export type CustomersFiltersArgs = {
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']>;
};

export type DpdAccountInfo = {
  __typename?: 'DPDAccountInfo';
  apiEndpoint: Scalars['String'];
  isPasswordStored: Scalars['Boolean'];
  subAccountsInfo?: Maybe<Array<DpdSubAccountInfo>>;
  username?: Maybe<Scalars['String']>;
};

export type DpdConfigurationArgs = {
  accountName: Scalars['String'];
  accountToken?: InputMaybe<Scalars['String']>;
  shopSubAccounts?: InputMaybe<Array<DpdSubAccountArgs>>;
};

export type DpdSubAccountArgs = {
  shopId: Scalars['ObjectId'];
  userId: Scalars['String'];
  userToken?: InputMaybe<Scalars['String']>;
};

export type DpdSubAccountInfo = {
  __typename?: 'DPDSubAccountInfo';
  isPasswordStored: Scalars['Boolean'];
  shopId: Scalars['ObjectId'];
  username: Scalars['String'];
};

export type DateFilter = {
  betweenValues?: InputMaybe<DateFilterBetween>;
  condition?: InputMaybe<EDateFilterConditions>;
  value?: InputMaybe<Scalars['DateTime']>;
};

export type DateFilterBetween = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type DateFilterBetweenType = {
  __typename?: 'DateFilterBetweenType';
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type DateFilterType = {
  __typename?: 'DateFilterType';
  betweenValues?: Maybe<DateFilterBetweenType>;
  condition?: Maybe<EDateFilterConditions>;
  value?: Maybe<Scalars['DateTime']>;
};

export type Deal = {
  __typename?: 'Deal';
  _id: Scalars['ObjectId'];
  acceptingWithdrawalFeeTermsRequired: Scalars['Boolean'];
  auctionDealCalculation: DealCalculation;
  auctioningSettings?: Maybe<DealAuctioningSettings>;
  bookingNumber: Scalars['Int'];
  businessUnit: EBusinessUnit;
  canDealOnSellBeExtendedOrPaidBack: Scalars['Boolean'];
  chainNotes?: Maybe<Array<Note>>;
  closedBy?: Maybe<Scalars['String']>;
  company: Company;
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  customDealId?: Maybe<Scalars['ObjectId']>;
  customer: DealCustomer;
  customerCategory?: Maybe<ECustomerCategory>;
  dealChain?: Maybe<Array<DealChain>>;
  dealFinalValues: DealFinalValues;
  dealPartnerData?: Maybe<ODealPartnerData>;
  dealStartDate: Scalars['DateTime'];
  dealType: EDealType;
  dealValorizationCalculation?: Maybe<DealValorizationCalculation>;
  dropoffData?: Maybe<TransportData>;
  employeeDeclarations?: Maybe<Array<Scalars['String']>>;
  events: Array<DealEvent>;
  extendedBy?: Maybe<Scalars['String']>;
  extensionChain?: Maybe<ExtensionChain>;
  hasCompletedPayment: Scalars['Boolean'];
  initialShopId?: Maybe<Scalars['ObjectId']>;
  insuranceFactor: Scalars['Float'];
  insuredAmount: Scalars['Float'];
  isExtensionPaymentOngoing: Scalars['Boolean'];
  isInOpenAuction?: Maybe<Scalars['Boolean']>;
  isNewCustomer?: Maybe<Scalars['Boolean']>;
  isPaybackPaymentOngoing: Scalars['Boolean'];
  items: Array<DealItem>;
  itemsIds: Array<Scalars['ObjectId']>;
  latestOngoingPaymentRequestedAt?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Array<Note>>;
  pawnData?: Maybe<PawnData>;
  payoutData: PaymentData;
  persistedExtensionCalculation?: Maybe<PersistedDealExtensionCalculation>;
  persistedPaybackCalculation?: Maybe<PersistedDealPaybackCalculation>;
  pickupData?: Maybe<TransportData>;
  purchaseData?: Maybe<PurchaseData>;
  requestedItems: Array<DealItem>;
  requestedItemsIds: Array<Scalars['ObjectId']>;
  secondaryCustomers?: Maybe<Array<Customer>>;
  secondaryCustomersIds?: Maybe<Array<Scalars['ObjectId']>>;
  secondaryPayoutData?: Maybe<SecondaryPaymentData>;
  shippingLabelPageId?: Maybe<Scalars['String']>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  shop?: Maybe<Shop>;
  status?: Maybe<EDealStatusType>;
  surplusPaymentsData?: Maybe<Array<SurplusPaymentData>>;
  updatedAt: Scalars['DateTime'];
  uploadedFiles?: Maybe<Array<FileMetadata>>;
  verifiedBy?: Maybe<Scalars['String']>;
};


export type DealAuctionDealCalculationArgs = {
  auctionDate?: InputMaybe<Scalars['DateTime']>;
};


export type DealItemsArgs = {
  omitItemQuestions?: InputMaybe<Scalars['Boolean']>;
  omitItemValorizationCalculation?: InputMaybe<Scalars['Boolean']>;
};


export type DealPersistedExtensionCalculationArgs = {
  args: DealExtensionCalculationArgs;
};


export type DealPersistedPaybackCalculationArgs = {
  args: DealPaybackCalculationArgs;
};

export type DealAuctioningSettings = {
  __typename?: 'DealAuctioningSettings';
  at: Scalars['DateTime'];
  auctioningAllowed: Scalars['Boolean'];
  by: Employee;
};

export type DealBookedEvent = BaseDealEvent & {
  __typename?: 'DealBookedEvent';
  createdAt: Scalars['DateTime'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealCalculation = IDealCalculation & {
  __typename?: 'DealCalculation';
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  date: Scalars['DateTime'];
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  loanToValuesEntryId: Scalars['ObjectId'];
};

export type DealCanceledEvent = BaseDealEvent & {
  __typename?: 'DealCanceledEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealChain = {
  __typename?: 'DealChain';
  bookingNumber: Scalars['Float'];
  chainType: EDealChainType;
  dealId: Scalars['ObjectId'];
};

export type DealClosedEvent = BaseDealEvent & {
  __typename?: 'DealClosedEvent';
  createdAt: Scalars['DateTime'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String'];
  isClosedByAuctionId?: Maybe<Scalars['ObjectId']>;
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
  valorizationFeeGross?: Maybe<Scalars['Float']>;
  valorizationFeeNet?: Maybe<Scalars['Float']>;
};

export type DealCollectedEvent = BaseDealEvent & {
  __typename?: 'DealCollectedEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealCreateArgs = {
  companyId: Scalars['ObjectId'];
  creatorId?: InputMaybe<Scalars['ObjectId']>;
  customDealId?: InputMaybe<Scalars['ObjectId']>;
  dealCalculationId: Scalars['ObjectId'];
  dealItemsCreateArgs: Array<DealItemCreateArgs>;
  dealPartnerData?: InputMaybe<DealPartnerDataArgs>;
  employeeDeclarations?: InputMaybe<Array<Scalars['String']>>;
  guestCustomerDataArgs?: InputMaybe<GuestCustomerDataArgs>;
  iban?: InputMaybe<Scalars['String']>;
  initialShopId?: InputMaybe<Scalars['ObjectId']>;
  payoutType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']>;
  pickupData?: InputMaybe<TransportDataArgs>;
  registeredCustomerId?: InputMaybe<Scalars['ObjectId']>;
};

/** Customer | GuestCustomerData */
export type DealCustomer = Customer | GuestCustomerData;

export type DealCustomerInCreditEvent = BaseDealEvent & {
  __typename?: 'DealCustomerInCreditEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealCustomerInDebtEvent = BaseDealEvent & {
  __typename?: 'DealCustomerInDebtEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealDeclinedEvent = BaseDealEvent & {
  __typename?: 'DealDeclinedEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealDerecognizedEvent = BaseDealEvent & {
  __typename?: 'DealDerecognizedEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealEvent = DealBookedEvent | DealCanceledEvent | DealClosedEvent | DealCollectedEvent | DealCustomerInCreditEvent | DealCustomerInDebtEvent | DealDeclinedEvent | DealDerecognizedEvent | DealExcessAmountPayedEvent | DealExtensionConfirmedEvent | DealItemReceivedIdMissingEvent | DealLoanDueEvent | DealLoanDueNotifiedEvent | DealOnSellEvent | DealPaybackConfirmedEvent | DealPayedAndStoredEvent | DealPayedShipmentPendingEvent | DealPickedUpEvent | DealPickedUpUnsuccessfulEvent | DealReviewingEvent | DealSoldExternEvent | DealSoldInternEvent | DealVerifiedEvent;

export type DealEventFilter = {
  event: EDealStatusType;
  when?: InputMaybe<DateFilter>;
};

export type DealEventFilterType = {
  __typename?: 'DealEventFilterType';
  event: EDealStatusType;
  when?: Maybe<DateFilterType>;
};

export type DealExcessAmountPayedEvent = BaseDealEvent & {
  __typename?: 'DealExcessAmountPayedEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealExtensionCalculation = {
  __typename?: 'DealExtensionCalculation';
  childDealCalculation: DealCalculation;
  dealId: Scalars['ObjectId'];
  dueAmount: Scalars['Float'];
  itemsExtensionAnswers: Array<ItemExtensionAnswers>;
  overwrittenPartialRedemptionAmount?: Maybe<Scalars['Float']>;
  parentDealCalculation: DealCalculation;
  partialRedemptionAmount: Scalars['Float'];
};

export type DealExtensionCalculationArgs = {
  childManualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  childShouldOverwriteManualFees: Scalars['Boolean'];
  durationInDays?: InputMaybe<Scalars['Int']>;
  extensionDate?: InputMaybe<Scalars['DateTime']>;
  itemsExtensionAnswersArgs: Array<ItemExtensionAnswersArgs>;
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  overwrittenPartialRedemptionAmount?: InputMaybe<Scalars['Float']>;
  shouldOverwriteItemAnswers: Scalars['Boolean'];
  shouldOverwriteManualFees: Scalars['Boolean'];
};

export type DealExtensionConfirmedEvent = BaseDealEvent & {
  __typename?: 'DealExtensionConfirmedEvent';
  childCalculation: DealCalculation;
  createdAt: Scalars['DateTime'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String'];
  dueAmount: Scalars['Float'];
  itemsExtensionAnswers?: Maybe<Array<ItemExtensionAnswers>>;
  overwrittenPartialRedemptionAmount?: Maybe<Scalars['Float']>;
  partialRedemptionAmount: Scalars['Float'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  bookingNumber?: InputMaybe<NumberFilter>;
  bookingNumbers?: InputMaybe<Array<Scalars['Int']>>;
  businessUnit?: InputMaybe<EBusinessUnit>;
  companyId?: InputMaybe<IdFilter>;
  customerId?: InputMaybe<IdFilter>;
  customerIds?: InputMaybe<IdFilter>;
  dealEventFilter?: InputMaybe<DealEventFilter>;
  dealType?: InputMaybe<EDealType>;
  firstnameOrLastNameOrEmail?: InputMaybe<StringFilter>;
  hasBuyBackData?: InputMaybe<Scalars['Boolean']>;
  hasEvents?: InputMaybe<Array<EDealStatusType>>;
  hasExtension?: InputMaybe<Scalars['Boolean']>;
  hasOrIsExtension?: InputMaybe<Scalars['Boolean']>;
  hasOrIsExtensionBuyBack?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  initialShopId?: InputMaybe<IdFilter>;
  initialShopIds?: InputMaybe<IdFilter>;
  isExtension?: InputMaybe<Scalars['Boolean']>;
  itemsIds?: InputMaybe<IdFilter>;
  noShop?: InputMaybe<Scalars['Boolean']>;
  notHasEvents?: InputMaybe<Array<EDealStatusType>>;
  shopName?: InputMaybe<StringFilter>;
};

export type DealFinalValues = {
  __typename?: 'DealFinalValues';
  dealType: EDealType;
  durationInDays: Scalars['Float'];
  isOnlineExtensionPrevented?: Maybe<Scalars['Boolean']>;
  minPartialRedemptionAmount?: Maybe<Scalars['Float']>;
  partialRedemptionIntervalsCount?: Maybe<Scalars['Float']>;
  partialRedemptionSetUpBy: DealFinalValuesEntryCreator;
  payoutAmount: Scalars['Float'];
  shouldOverwritePayoutAmount: Scalars['Boolean'];
};

export type DealFinalValuesArgs = {
  dealType: EDealType;
  durationInDays: Scalars['Float'];
  payoutAmount: Scalars['Float'];
  shouldOverwritePayoutAmount: Scalars['Boolean'];
};

/** Employee | SystemOperation */
export type DealFinalValuesEntryCreator = Employee | SystemOperation;

export type DealInOpenAuctionArgs = {
  __typename?: 'DealInOpenAuctionArgs';
  auction?: Maybe<Auction>;
  auctionDate?: Maybe<Scalars['DateTime']>;
  isDealExistsInAnOpenAuctions: Scalars['Boolean'];
};

export type DealItem = {
  __typename?: 'DealItem';
  _id: Scalars['ObjectId'];
  _oldItemId?: Maybe<Scalars['String']>;
  algoliaReference?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<ItemAnswer>>;
  categorizedUploadedFiles?: Maybe<Array<CategorizedUploadedFile>>;
  checkedAfterAuction?: Maybe<Scalars['Boolean']>;
  checkedAt?: Maybe<Scalars['DateTime']>;
  checkedBy?: Maybe<Scalars['String']>;
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  customDealId?: Maybe<Scalars['ObjectId']>;
  customRequestId?: Maybe<Scalars['ObjectId']>;
  damageCasePeriods?: Maybe<Array<TimePeriod>>;
  dealsHistory?: Maybe<Array<ItemDealsHistoryEntry>>;
  ean?: Maybe<Scalars['String']>;
  entrupyCertificateUrl?: Maybe<Scalars['String']>;
  events?: Maybe<Array<ItemEvent>>;
  formAnswers?: Maybe<Array<FormAnswer>>;
  imei?: Maybe<Scalars['String']>;
  internalSaleData?: Maybe<InternalSaleData>;
  isBulkyItem: Scalars['Boolean'];
  isContinueUsing: Scalars['Boolean'];
  isDamageCase?: Maybe<Scalars['Boolean']>;
  isForPersonalUse?: Maybe<Scalars['Boolean']>;
  isInvestmentGold?: Maybe<Scalars['Boolean']>;
  itemCategory: ItemCategory;
  itemCategoryId: Scalars['ObjectId'];
  itemSpecification?: Maybe<Scalars['String']>;
  itemValorizationCalculation?: Maybe<ItemValorizationCalculation>;
  lastBookingNumber?: Maybe<Scalars['String']>;
  loanToValuesEntryId: Scalars['ObjectId'];
  manualTest?: Maybe<PiceaTest>;
  material?: Maybe<Scalars['String']>;
  media?: Maybe<Array<FileMetadata>>;
  note?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Note>>;
  personalUsePeriods?: Maybe<Array<TimePeriod>>;
  piceaTest?: Maybe<PiceaTest>;
  piceaUpload?: Maybe<Scalars['Upload']>;
  piceaUploadLink?: Maybe<FileMetadata>;
  policeNumber?: Maybe<Scalars['String']>;
  product?: Maybe<ProductLegacy>;
  productLegacy?: Maybe<ProductLegacy>;
  productVariant?: Maybe<ProductVariant>;
  questionIds?: Maybe<Array<Scalars['ObjectId']>>;
  questions?: Maybe<Array<ItemQuestion>>;
  serialNumber?: Maybe<Scalars['String']>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  status?: Maybe<EItemStatusType>;
  storageFacility?: Maybe<StorageFacility>;
  storageFacilityId?: Maybe<Scalars['ObjectId']>;
  storageHistory?: Maybe<Array<ItemStorageHistoryEntry>>;
  storageLabel?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  unconfirmedPropertyIds?: Maybe<Array<Scalars['ObjectId']>>;
  updatedAt: Scalars['DateTime'];
  uploadedFiles?: Maybe<Array<FileMetadata>>;
  usedGrade?: Maybe<EUsedGrade>;
  valorizationHistoryIds?: Maybe<Array<Scalars['ObjectId']>>;
  values: ItemValues;
  variantId?: Maybe<Scalars['ObjectId']>;
  vehicleData?: Maybe<VehicleData>;
};

export type DealItemCalculationArgs = {
  algoliaReference?: InputMaybe<Scalars['String']>;
  answers: Array<ItemAnswerArgs>;
  customPayoutAmount?: InputMaybe<Scalars['Float']>;
  existingCurrentMarketValue?: InputMaybe<Scalars['Float']>;
  existingPredictedMarketValue?: InputMaybe<Scalars['Float']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']>;
  itemCategoryId: Scalars['ObjectId'];
  material?: InputMaybe<Scalars['String']>;
  skipPredictionTags?: InputMaybe<Scalars['Boolean']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  useOldValuesOfPrediction?: InputMaybe<Scalars['Boolean']>;
  variantId?: InputMaybe<Scalars['ObjectId']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type DealItemCategorizedUploadFiles = {
  fileCategoryName: Scalars['String'];
  uploads: Array<FileTusMetadataArgs>;
};

export type DealItemCreateArgs = {
  algoliaReference?: InputMaybe<Scalars['String']>;
  answers: Array<ItemAnswerArgs>;
  categorizedUploads?: InputMaybe<Array<DealItemCategorizedUploadFiles>>;
  customPayoutAmount?: InputMaybe<Scalars['Float']>;
  ean?: InputMaybe<Scalars['String']>;
  existingCurrentMarketValue?: InputMaybe<Scalars['Float']>;
  existingPredictedMarketValue?: InputMaybe<Scalars['Float']>;
  formAnswers?: InputMaybe<Array<DealItemFormAnswer>>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']>;
  itemCategoryId: Scalars['ObjectId'];
  material?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<FileMetadataArgs>>;
  note?: InputMaybe<Scalars['String']>;
  policeNumber?: InputMaybe<Scalars['String']>;
  skipPredictionTags?: InputMaybe<Scalars['Boolean']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']>;
  title: Scalars['String'];
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  uploads?: InputMaybe<Array<FileTusMetadataArgs>>;
  useOldValuesOfPrediction?: InputMaybe<Scalars['Boolean']>;
  variantId?: InputMaybe<Scalars['ObjectId']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type DealItemFormAnswer = {
  questionId: Scalars['ObjectId'];
  value: DealItemFormAnswerValue;
};

export type DealItemFormAnswerValue = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  numberValue?: InputMaybe<Scalars['Float']>;
  stringValue?: InputMaybe<Scalars['String']>;
};

export type DealItemReceivedIdMissingEvent = BaseDealEvent & {
  __typename?: 'DealItemReceivedIdMissingEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealItemUpdateArgs = {
  _id: Scalars['ObjectId'];
  checkedAfterAuction?: InputMaybe<Scalars['Boolean']>;
  checkedAt?: InputMaybe<Scalars['DateTime']>;
  checkedBy?: InputMaybe<Scalars['String']>;
  disableCheckPiceaTest?: InputMaybe<Scalars['Boolean']>;
  entrupyCertificateUrl?: InputMaybe<Scalars['String']>;
  formAnswers?: InputMaybe<Array<UpdateFormAnswerArgs>>;
  imei?: InputMaybe<Scalars['String']>;
  isBulkyGood?: InputMaybe<Scalars['Boolean']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']>;
  itemSpecification?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']>;
  title?: InputMaybe<Scalars['String']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  usedGrade?: InputMaybe<EUsedGrade>;
  variantId?: InputMaybe<Scalars['ObjectId']>;
  vehicleData?: InputMaybe<UpdateVehicleDataArgs>;
};

export type DealLoanDueEvent = BaseDealEvent & {
  __typename?: 'DealLoanDueEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealLoanDueNotifiedEvent = BaseDealEvent & {
  __typename?: 'DealLoanDueNotifiedEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealOnSellEvent = BaseDealEvent & {
  __typename?: 'DealOnSellEvent';
  createdAt: Scalars['DateTime'];
  differenceTaxRate: Scalars['Float'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
  valorizationFeeRate: Scalars['Float'];
  valueAddedTaxRate: Scalars['Float'];
};

export type DealOpts = {
  filter?: InputMaybe<DealFilterArgs>;
  order?: InputMaybe<DealOrderArgs>;
  query?: InputMaybe<Array<QueryFieldFilter>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type DealOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  bookingNumber?: InputMaybe<EOrderBy>;
  createdAt?: InputMaybe<EOrderBy>;
};

export type DealPartnerDataArgs = {
  knp?: InputMaybe<DealPartnerDataKnpArgs>;
  type: EDealPartnerType;
};

export type DealPartnerDataKnpArgs = {
  debtAmount?: InputMaybe<Scalars['Float']>;
  fileReferenceNumber?: InputMaybe<Scalars['String']>;
};

export type DealPawnDurationsArgs = {
  companyId: Scalars['ObjectId'];
  itemCategoryIds: Array<Scalars['ObjectId']>;
};

export type DealPaybackCalculationArgs = {
  dropoffData?: InputMaybe<TransportDataArgs>;
  durationInDays?: InputMaybe<Scalars['Int']>;
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  shouldOverwriteManualFees: Scalars['Boolean'];
};

export type DealPaybackConfirmedEvent = BaseDealEvent & {
  __typename?: 'DealPaybackConfirmedEvent';
  createdAt: Scalars['DateTime'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealPayedAndStoredEvent = BaseDealEvent & {
  __typename?: 'DealPayedAndStoredEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealPayedShipmentPendingEvent = BaseDealEvent & {
  __typename?: 'DealPayedShipmentPendingEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealPickedUpEvent = BaseDealEvent & {
  __typename?: 'DealPickedUpEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealPickedUpUnsuccessfulEvent = BaseDealEvent & {
  __typename?: 'DealPickedUpUnsuccessfulEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealReviewingEvent = BaseDealEvent & {
  __typename?: 'DealReviewingEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  issuanceCertificate: FileMetadata;
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealSoldExternEvent = BaseDealEvent & {
  __typename?: 'DealSoldExternEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealSoldInternEvent = BaseDealEvent & {
  __typename?: 'DealSoldInternEvent';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealSurplusPaymentArgs = {
  amount: Scalars['Float'];
  createNewCashbook: Scalars['Boolean'];
  dealId: Scalars['ObjectId'];
  existingCashbookId?: InputMaybe<Scalars['ObjectId']>;
  paymentDate: Scalars['DateTime'];
  paymentType: EManualPaymentType;
  shopId?: InputMaybe<Scalars['ObjectId']>;
};

export type DealTransportUpdateArgs = {
  dealId: Scalars['ObjectId'];
  notifyCustomer: Scalars['Boolean'];
  shippingLabelCreateArgs?: InputMaybe<ShippingLabelCreateArgs>;
  transportMode: ETransportMode;
  transportType: ETransportType;
};

export type DealValorizationCalculation = {
  __typename?: 'DealValorizationCalculation';
  auctionRevenues: Array<ItemAuctionRevenue>;
  customerDebt: Scalars['Float'];
  paybackCosts: Array<DealValorizationCalculationPaybackCost>;
  payoutAmount: Scalars['Float'];
  surplusAmount: Scalars['Float'];
  valorizationFeeGross: Scalars['Float'];
  valorizationFeeNet: Scalars['Float'];
  valorizationFeeRate: Scalars['Float'];
};

export type DealValorizationCalculationPaybackCost = {
  __typename?: 'DealValorizationCalculationPaybackCost';
  description?: Maybe<Scalars['String']>;
  grossAmount: Scalars['Float'];
  netAmount: Scalars['Float'];
  title: Scalars['String'];
};

export type DealValuesEntry = {
  __typename?: 'DealValuesEntry';
  calculationPaybackAmount: Scalars['Float'];
  calculationPayoutAmount: Scalars['Float'];
  durationInDays: Scalars['Float'];
  overwrittenPayoutAmount: Scalars['Float'];
  paybackAmount: Scalars['Float'];
  payoutAmount: Scalars['Float'];
  shouldOverwritePayoutAmount: Scalars['Boolean'];
};

export type DealVerifiedEvent = BaseDealEvent & {
  __typename?: 'DealVerifiedEvent';
  createdAt: Scalars['DateTime'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String'];
  isOverwrittenFees?: Maybe<Scalars['Boolean']>;
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime'];
};

export type DealsFilterStatus = {
  from?: InputMaybe<Scalars['DateTime']>;
  mode: EDateFilterMode;
  names: Array<EDealStatusType>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type DealsFiltersArgs = {
  businessUnit?: InputMaybe<EBusinessUnit>;
  companyId?: InputMaybe<Scalars['ObjectId']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  initialShopId?: InputMaybe<Scalars['ObjectId']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DealsFilterStatus>;
  transportType?: InputMaybe<ETransportMode>;
  type?: InputMaybe<EDealType>;
};

export enum EAppraisalCheckoutKind {
  CustomDealRequest = 'CUSTOM_DEAL_REQUEST',
  DirectCheckout = 'DIRECT_CHECKOUT'
}

export enum EAppraisalHandoffTarget {
  Car = 'CAR',
  Motorcycle = 'MOTORCYCLE',
  RealEstate = 'REAL_ESTATE'
}

export enum EAppraisalPath {
  CustomItem = 'CUSTOM_ITEM',
  Gold = 'GOLD',
  GroundedProduct = 'GROUNDED_PRODUCT',
  KnownProduct = 'KNOWN_PRODUCT',
  LuxuryBag = 'LUXURY_BAG',
  LuxuryWatch = 'LUXURY_WATCH'
}

export enum EAppraisalQuestionInputType {
  Choice = 'CHOICE',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export enum EAppraisalRejectionReason {
  BelowMinimum = 'BELOW_MINIMUM',
  NotFunctional = 'NOT_FUNCTIONAL',
  NoControllers = 'NO_CONTROLLERS',
  UnsupportedItem = 'UNSUPPORTED_ITEM'
}

export enum EAuctionBuyerType {
  Anonym = 'ANONYM',
  ExistingCustomer = 'EXISTING_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  OtherRevenue = 'OTHER_REVENUE',
  SurplusPayout = 'SURPLUS_PAYOUT'
}

export enum EAuctionCreationType {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export enum EAuctionItemStatus {
  ReadyForAuction = 'READY_FOR_AUCTION',
  Sold = 'SOLD'
}

export enum EAuctionStatus {
  Closed = 'CLOSED',
  CloseError = 'CLOSE_ERROR',
  ClosingInProgress = 'CLOSING_IN_PROGRESS',
  Open = 'OPEN',
  Started = 'STARTED'
}

export enum EAutomaticPaymentType {
  CreditcardAutomatic = 'CREDITCARD_AUTOMATIC',
  EpsAutomatic = 'EPS_AUTOMATIC',
  /** @deprecated Discontinued */
  GiropayAutomatic = 'GIROPAY_AUTOMATIC',
  PaypalAutomatic = 'PAYPAL_AUTOMATIC',
  /** @deprecated Discontinued by Klarna */
  SofortAutomatic = 'SOFORT_AUTOMATIC',
  UnzerDirectBankTransferAutomatic = 'UNZER_DIRECT_BANK_TRANSFER_AUTOMATIC'
}

export enum EBillingPeriodType {
  Day = 'DAY',
  HalfMonth = 'HALF_MONTH',
  Month = 'MONTH',
  OneTime = 'ONE_TIME'
}

export enum EBooleanFilterConditions {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export enum EBusinessUnit {
  Car = 'CAR',
  General = 'GENERAL'
}

export enum ECashBookPaymentReference {
  AuctionProceeds = 'AUCTION_PROCEEDS',
  BankWithdrawal = 'BANK_WITHDRAWAL',
  Bill = 'BILL',
  Extension = 'EXTENSION',
  ExtensionPayout = 'EXTENSION_PAYOUT',
  MarketingCreditNote = 'MARKETING_CREDIT_NOTE',
  MiscellaneousBooking = 'MISCELLANEOUS_BOOKING',
  OtherRevenue = 'OTHER_REVENUE',
  Payback = 'PAYBACK',
  Payout = 'PAYOUT',
  PrivateSale = 'PRIVATE_SALE',
  SurplusPayout = 'SURPLUS_PAYOUT',
  Tipico = 'TIPICO',
  ValorizationCreditNote = 'VALORIZATION_CREDIT_NOTE',
  ValorizationSale = 'VALORIZATION_SALE'
}

export enum ECashBookType {
  Bank = 'BANK',
  Card = 'CARD',
  Cash = 'CASH',
  Paypal = 'PAYPAL',
  Unzer = 'UNZER'
}

export enum ECountry {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export enum ECurrencyCode {
  Eur = 'EUR'
}

export enum ECustomDealFormQuestionTitleKey {
  AdditionalInfo = 'ADDITIONAL_INFO',
  Condition = 'CONDITION',
  Price = 'PRICE',
  ProductName = 'PRODUCT_NAME'
}

export enum ECustomDealFormQuestionType {
  Boolean = 'Boolean',
  FileUpload = 'FileUpload',
  NumberDefault = 'NumberDefault',
  NumberOptions = 'NumberOptions',
  TextDefault = 'TextDefault',
  TextMultiline = 'TextMultiline',
  TextOptions = 'TextOptions'
}

export enum ECustomDealItemCondition {
  Good = 'GOOD',
  LikeNew = 'LIKE_NEW',
  New = 'NEW',
  Used = 'USED'
}

export enum ECustomDealStatusType {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Counteroffer = 'COUNTEROFFER',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  Reviewing = 'REVIEWING'
}

export enum ECustomItemFoundComparableOffers {
  LessThanTen = 'LESS_THAN_TEN',
  MoreThanTen = 'MORE_THAN_TEN',
  NoOffersFound = 'NO_OFFERS_FOUND',
  OneOrTwo = 'ONE_OR_TWO'
}

export enum ECustomRequestCondition {
  Good = 'GOOD',
  LikeNew = 'LIKE_NEW',
  New = 'NEW',
  Used = 'USED'
}

export enum ECustomRequestEvent {
  Accepted = 'ACCEPTED',
  Counteroffer = 'COUNTEROFFER',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  Requested = 'REQUESTED'
}

export enum ECustomerCategory {
  A = 'A',
  B = 'B',
  C = 'C'
}

export enum ECustomerIdentityType {
  DrivingLicense = 'DRIVING_LICENSE',
  IdentityCard = 'IDENTITY_CARD',
  Passport = 'PASSPORT'
}

export enum EDateFilterConditions {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEquals = 'NOT_EQUALS'
}

export enum EDateFilterMode {
  Current = 'CURRENT',
  Was = 'WAS'
}

export enum EDealChainType {
  Buyback = 'BUYBACK',
  Extension = 'EXTENSION',
  None = 'NONE'
}

export enum EDealItemCondition {
  Good = 'GOOD',
  LikeNew = 'LIKE_NEW',
  New = 'NEW',
  Used = 'USED'
}

export enum EDealPartnerType {
  Knp = 'KNP'
}

export enum EDealStatusType {
  Booked = 'BOOKED',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Collected = 'COLLECTED',
  CustomerInCredit = 'CUSTOMER_IN_CREDIT',
  CustomerInDebt = 'CUSTOMER_IN_DEBT',
  Declined = 'DECLINED',
  Derecognized = 'DERECOGNIZED',
  ExcessAmountPayed = 'EXCESS_AMOUNT_PAYED',
  ExtensionConfirmed = 'EXTENSION_CONFIRMED',
  ItemReceivedIdMissing = 'ITEM_RECEIVED_ID_MISSING',
  LoanDue = 'LOAN_DUE',
  LoanDueNotified = 'LOAN_DUE_NOTIFIED',
  OnSell = 'ON_SELL',
  PaybackConfirmed = 'PAYBACK_CONFIRMED',
  PayedAndStored = 'PAYED_AND_STORED',
  PayedShipmentPending = 'PAYED_SHIPMENT_PENDING',
  PickedUp = 'PICKED_UP',
  PickupUnsuccessful = 'PICKUP_UNSUCCESSFUL',
  Reviewing = 'REVIEWING',
  SoldExtern = 'SOLD_EXTERN',
  SoldIntern = 'SOLD_INTERN',
  Verified = 'VERIFIED'
}

export enum EDealType {
  Pawn = 'PAWN',
  Purchase = 'PURCHASE'
}

export enum EElectronicsAppraisalCatalogCategory {
  GameConsole = 'GAME_CONSOLE',
  Macbook = 'MACBOOK',
  Smartphone = 'SMARTPHONE',
  Smartwatch = 'SMARTWATCH',
  Tablet = 'TABLET'
}

export enum EEuroDenomination {
  Euro_1 = 'EURO_1',
  Euro_2 = 'EURO_2',
  Euro_5 = 'EURO_5',
  Euro_10 = 'EURO_10',
  Euro_20 = 'EURO_20',
  Euro_50 = 'EURO_50',
  Euro_100 = 'EURO_100',
  Euro_200 = 'EURO_200',
  Euro_500 = 'EURO_500',
  EuroCent_1 = 'EURO_CENT_1',
  EuroCent_2 = 'EURO_CENT_2',
  EuroCent_5 = 'EURO_CENT_5',
  EuroCent_10 = 'EURO_CENT_10',
  EuroCent_20 = 'EURO_CENT_20',
  EuroCent_50 = 'EURO_CENT_50'
}

export enum EFeeIntervalType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum EFeeLevel {
  Deal = 'DEAL',
  Item = 'ITEM',
  Valorization = 'VALORIZATION'
}

export enum EFeeMode {
  Constant = 'CONSTANT',
  Custome = 'CUSTOME',
  MultiplierPayout = 'MULTIPLIER_PAYOUT',
  TaxRate = 'TAX_RATE'
}

export enum EFeeType {
  CashExpenditures = 'CASH_EXPENDITURES',
  Cleaning = 'CLEANING',
  Discount = 'DISCOUNT',
  DiscountFirstMonth = 'DISCOUNT_FIRST_MONTH',
  DropoffTransport = 'DROPOFF_TRANSPORT',
  Initial = 'INITIAL',
  InitialStaggered = 'INITIAL_STAGGERED',
  Interest = 'INTEREST',
  LiquidationFee = 'LIQUIDATION_FEE',
  Manipulation = 'MANIPULATION',
  Other = 'OTHER',
  PickupTransport = 'PICKUP_TRANSPORT',
  Storage = 'STORAGE',
  ThirdPartyCosts = 'THIRD_PARTY_COSTS',
  Verification = 'VERIFICATION',
  Withdrawal = 'WITHDRAWAL'
}

export enum EIdFilterConditions {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export enum EItemCategorySearchIcon {
  Car = 'CAR',
  Pawn = 'PAWN',
  Purchase = 'PURCHASE'
}

export enum EItemDerecognizedReason {
  Damage = 'DAMAGE',
  Fraud = 'FRAUD',
  Valuation = 'VALUATION'
}

export enum EItemManualTestAssessment {
  Audio = 'AUDIO',
  Camera = 'CAMERA',
  Touchscreen = 'TOUCHSCREEN',
  Video = 'VIDEO'
}

export enum EItemNotSellablePermanentlyReason {
  DamageCase = 'DAMAGE_CASE',
  ItemLost = 'ITEM_LOST',
  PersonalUse = 'PERSONAL_USE'
}

export enum EItemNotSellableTemporaryReason {
  Repairing = 'REPAIRING',
  Seasonal = 'SEASONAL'
}

export enum EItemNotSellableType {
  Permanently = 'PERMANENTLY',
  Temporary = 'TEMPORARY'
}

export enum EItemNotification {
  TemporaryNotSellableRepairingDue = 'TEMPORARY_NOT_SELLABLE_REPAIRING_DUE',
  TemporaryNotSellableSeasonalDue = 'TEMPORARY_NOT_SELLABLE_SEASONAL_DUE'
}

export enum EItemReturnType {
  ReturnedInShop = 'RETURNED_IN_SHOP',
  ReturnedViaShipment = 'RETURNED_VIA_SHIPMENT'
}

export enum EItemSituation {
  InconsistentData = 'INCONSISTENT_DATA',
  ItemInStore = 'ITEM_IN_STORE',
  ItemNotInStore = 'ITEM_NOT_IN_STORE'
}

export enum EItemStatusType {
  Auctioned = 'AUCTIONED',
  CarCollected = 'CAR_COLLECTED',
  CarSold = 'CAR_SOLD',
  CollectCar = 'COLLECT_CAR',
  Derecognized = 'DERECOGNIZED',
  InLiquidation = 'IN_LIQUIDATION',
  NotRelevant = 'NOT_RELEVANT',
  NotSellable = 'NOT_SELLABLE',
  OfferedKg = 'OFFERED_KG',
  OfferedPawned = 'OFFERED_PAWNED',
  OfferedToSell = 'OFFERED_TO_SELL',
  PaidAndCollected = 'PAID_AND_COLLECTED',
  PaidAndShipped = 'PAID_AND_SHIPPED',
  Pawned = 'PAWNED',
  PrivateSale = 'PRIVATE_SALE',
  ReadyToSell = 'READY_TO_SELL',
  Returned = 'RETURNED',
  ReturnArrived = 'RETURN_ARRIVED',
  ReturnRequested = 'RETURN_REQUESTED',
  Securing = 'SECURING',
  ShipBetweenShops = 'SHIP_BETWEEN_SHOPS',
  Sold = 'SOLD',
  VoluntarySelfDelivery = 'VOLUNTARY_SELF_DELIVERY'
}

export enum EksvRequestType {
  AddAsset = 'ADD_ASSET',
  ChangeAsset = 'CHANGE_ASSET',
  FindAssets = 'FIND_ASSETS',
  RemoveAsset = 'REMOVE_ASSET'
}

export enum ELanguageCode {
  De = 'de',
  En = 'en',
  Ro = 'ro',
  Sr = 'sr',
  Tr = 'tr'
}

export enum ELogisticsPartnerType {
  Cashy = 'CASHY',
  Logsta = 'LOGSTA'
}

export enum ELuxuryAppraisalCategory {
  Bag = 'BAG',
  Watch = 'WATCH'
}

export enum EManualPaymentType {
  Bank = 'BANK',
  Card = 'CARD',
  Cash = 'CASH',
  CashOnDelivery = 'CASH_ON_DELIVERY',
  Dummy = 'DUMMY',
  Paypal = 'PAYPAL'
}

export enum EMaximumPawnDuration {
  Inherited = 'INHERITED',
  In_30Days = 'IN_30_DAYS',
  In_60Days = 'IN_60_DAYS',
  In_90Days = 'IN_90_DAYS'
}

export enum EMergingCustomerReason {
  Duplicated = 'DUPLICATED',
  Request = 'REQUEST'
}

export enum ENumberFilterConditions {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEquals = 'NOT_EQUALS'
}

export enum EOrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum EPrivateSaleCreationType {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export enum EProductImageMode {
  ImagePerVariant = 'IMAGE_PER_VARIANT',
  OneImageForAllProducts = 'ONE_IMAGE_FOR_ALL_PRODUCTS'
}

export enum EProductMaterial {
  Gold = 'GOLD',
  Platin = 'PLATIN',
  Silver = 'SILVER'
}

export enum EProductPriceAdjustmentType {
  AbsoluteMarkup = 'ABSOLUTE_MARKUP',
  FixedPrice = 'FIXED_PRICE',
  PercentageMarkup = 'PERCENTAGE_MARKUP'
}

export enum EProductPriceMode {
  Crawled = 'CRAWLED',
  ManualPreciousMetal = 'MANUAL_PRECIOUS_METAL',
  ManualProperty = 'MANUAL_PROPERTY',
  ManualVariant = 'MANUAL_VARIANT'
}

export enum EProductPropertyType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Translation = 'TRANSLATION'
}

export enum EQuestionConditionValue {
  Excellent = 'excellent',
  Good = 'good',
  Poor = 'poor'
}

export enum EQuestionPredictionTag {
  Alloy = 'alloy',
  Condition = 'condition',
  Weight = 'weight'
}

export enum EQuestionType {
  Range = 'RANGE',
  SingleChoice = 'SINGLE_CHOICE'
}

export enum EQuestionValueMode {
  Constant = 'CONSTANT',
  Percentage = 'PERCENTAGE',
  UnitPriceMultiplier = 'UNIT_PRICE_MULTIPLIER'
}

export enum ERefurbedBuyBoxState {
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE',
  ShouldWin = 'SHOULD_WIN',
  Won = 'WON',
  WonElsewhere = 'WON_ELSEWHERE'
}

export enum ERefurbedProductsImportStatus {
  Completed = 'COMPLETED',
  Running = 'RUNNING'
}

export enum ERefurbedTaxation {
  Gross = 'GROSS',
  Marginal = 'MARGINAL'
}

export enum ERegionCode {
  At = 'AT',
  De = 'DE'
}

export enum ERemindUploadIdType {
  InvalidId = 'INVALID_ID',
  MissingId = 'MISSING_ID'
}

export enum EReturnReasons {
  AccountLock = 'ACCOUNT_LOCK',
  Cancelled = 'CANCELLED',
  Fake = 'FAKE',
  OpticalError = 'OPTICAL_ERROR',
  Other = 'OTHER',
  ReturnForNoReason = 'RETURN_FOR_NO_REASON',
  TechnicalError = 'TECHNICAL_ERROR',
  WrongProduct = 'WRONG_PRODUCT'
}

export enum ERoles {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Guest = 'GUEST',
  Locationadmin = 'LOCATIONADMIN',
  Locationstaff = 'LOCATIONSTAFF',
  Superadmin = 'SUPERADMIN'
}

export enum ESalesPartnerType {
  Baggyluxe = 'BAGGYLUXE',
  BlitzMobile = 'BLITZ_MOBILE',
  Cashy = 'CASHY',
  Chrono24 = 'CHRONO24',
  Ebay = 'EBAY',
  EbayKleinanzeigen = 'EBAY_KLEINANZEIGEN',
  Others = 'OTHERS',
  Rebelle = 'REBELLE',
  Refurbed = 'REFURBED',
  VestiaireCollective = 'VESTIAIRE_COLLECTIVE',
  Willhaben = 'WILLHABEN'
}

export enum ESex {
  Diverse = 'DIVERSE',
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum EShippingLabelDirection {
  Receive = 'RECEIVE',
  Send = 'SEND'
}

export enum EShippingLabelEntity {
  Deal = 'DEAL',
  Item = 'ITEM'
}

export enum EShippingLabelFileSource {
  Generate = 'GENERATE',
  History = 'HISTORY',
  Upload = 'UPLOAD'
}

export enum EStandardShipmentType {
  Cashy = 'CASHY',
  Dhl = 'DHL',
  DpdStandard = 'DPD_STANDARD',
  Post = 'POST'
}

export enum EStatusFilterType {
  Contain = 'CONTAIN',
  Latest = 'LATEST'
}

export enum EStorageStatus {
  AddedToStorage = 'ADDED_TO_STORAGE',
  RemovedFromStorage = 'REMOVED_FROM_STORAGE'
}

export enum EStrapiContentCountry {
  All = 'ALL',
  At = 'AT',
  De = 'DE'
}

export enum EStringFilterConditions {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS',
  StartsWith = 'STARTS_WITH'
}

export enum ETransactionType {
  CashExpenditures = 'CASH_EXPENDITURES',
  CustomerPaymentAfterSale = 'CUSTOMER_PAYMENT_AFTER_SALE',
  Derecognization = 'DERECOGNIZATION',
  LiquidationFee = 'LIQUIDATION_FEE',
  OtherFees = 'OTHER_FEES',
  PaybackFees = 'PAYBACK_FEES',
  Payout = 'PAYOUT',
  PayoutExcessAmount = 'PAYOUT_EXCESS_AMOUNT',
  SellingCar = 'SELLING_CAR',
  ThirdPartyCosts = 'THIRD_PARTY_COSTS'
}

export enum ETransportMode {
  Auction = 'AUCTION',
  Courier = 'COURIER',
  Extension = 'EXTENSION',
  ExtensionAuction = 'EXTENSION_AUCTION',
  PremiumShipment = 'PREMIUM_SHIPMENT',
  PrivateSale = 'PRIVATE_SALE',
  Shop = 'SHOP',
  StandardShipment = 'STANDARD_SHIPMENT',
  Storebox = 'STOREBOX'
}

export enum ETransportType {
  Dropoff = 'DROPOFF',
  Pickup = 'PICKUP'
}

export enum EUnzerFailedPaymentErrorCode {
  MaxLimitExceeded = 'MAX_LIMIT_EXCEEDED',
  Unknown = 'UNKNOWN'
}

export enum EUsedGrade {
  Grade_01 = 'GRADE_01',
  Grade_02 = 'GRADE_02',
  Grade_03 = 'GRADE_03'
}

export enum EVisibleOnDomain {
  All = 'ALL',
  At = 'AT',
  De = 'DE',
  None = 'NONE'
}

export type ElectronicsAppraisalCatalogAnchor = {
  __typename?: 'ElectronicsAppraisalCatalogAnchor';
  date: Scalars['DateTime'];
  note?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  setAt: Scalars['DateTime'];
  setBy?: Maybe<Scalars['ObjectId']>;
};

export type ElectronicsAppraisalCatalogAnchorHistoryEntry = {
  __typename?: 'ElectronicsAppraisalCatalogAnchorHistoryEntry';
  date: Scalars['DateTime'];
  note?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  replacedAt: Scalars['DateTime'];
  setAt: Scalars['DateTime'];
  setBy?: Maybe<Scalars['ObjectId']>;
};

export type ElectronicsAppraisalCatalogConfiguration = {
  __typename?: 'ElectronicsAppraisalCatalogConfiguration';
  caseSize?: Maybe<Scalars['String']>;
  casingMaterial?: Maybe<Scalars['String']>;
  chip?: Maybe<Scalars['String']>;
  connectivity?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  ram?: Maybe<Scalars['String']>;
  screenSize?: Maybe<Scalars['String']>;
  storage?: Maybe<Scalars['String']>;
  wristbandMaterial?: Maybe<Scalars['String']>;
};

export type ElectronicsAppraisalCatalogProduct = {
  __typename?: 'ElectronicsAppraisalCatalogProduct';
  _id: Scalars['ObjectId'];
  aliases: Array<Scalars['String']>;
  brand: Scalars['String'];
  category: EElectronicsAppraisalCatalogCategory;
  createdAt: Scalars['DateTime'];
  curveKey: Scalars['String'];
  excludedQuestionTitleKeys?: Maybe<Array<Scalars['String']>>;
  family: Scalars['String'];
  itemCategoryId: Scalars['ObjectId'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variants: Array<ElectronicsAppraisalCatalogVariant>;
};

export type ElectronicsAppraisalCatalogSeedStats = {
  __typename?: 'ElectronicsAppraisalCatalogSeedStats';
  anchorsSkipped: Scalars['Float'];
  anchorsWritten: Scalars['Float'];
  curvesUpserted: Scalars['Float'];
  productsInserted: Scalars['Float'];
  productsUpdated: Scalars['Float'];
  variantsInserted: Scalars['Float'];
  variantsUpdated: Scalars['Float'];
};

export type ElectronicsAppraisalCatalogVariant = {
  __typename?: 'ElectronicsAppraisalCatalogVariant';
  _id: Scalars['ObjectId'];
  anchor?: Maybe<ElectronicsAppraisalCatalogAnchor>;
  anchorHistory: Array<ElectronicsAppraisalCatalogAnchorHistoryEntry>;
  configuration: ElectronicsAppraisalCatalogConfiguration;
  configurationKey: Scalars['String'];
  createdAt: Scalars['DateTime'];
  productId: Scalars['ObjectId'];
  releaseDate: Scalars['DateTime'];
  releasePrice: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type Employee = {
  __typename?: 'Employee';
  _id: Scalars['ObjectId'];
  company: Company;
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  employeeNumber: Scalars['Int'];
  firstname: Scalars['String'];
  isDeactivated?: Maybe<Scalars['Boolean']>;
  isNotePopup?: Maybe<Scalars['Boolean']>;
  lastname: Scalars['String'];
  locations?: Maybe<Array<Shop>>;
  note?: Maybe<Scalars['String']>;
  payoutConfigurations?: Maybe<OPayoutConfiguration>;
  phone: Scalars['String'];
  preferences?: Maybe<EmployeePreferences>;
  roles: Array<ERoles>;
  scheduledDeactivationAt?: Maybe<Scalars['DateTime']>;
  sex?: Maybe<ESex>;
  shopIds?: Maybe<Array<Scalars['ObjectId']>>;
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userPermission?: Maybe<UserPermission>;
  userPermissionId: Scalars['ObjectId'];
};

export type EmployeeActivationArgs = {
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

export type EmployeeFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  companyId?: InputMaybe<IdFilter>;
  defaultShopId?: InputMaybe<IdFilter>;
  firstname?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  isDeactivated?: InputMaybe<BooleanFilter>;
  lastname?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<ERoles>;
};

export type EmployeeOpts = {
  filter?: InputMaybe<EmployeeFilterArgs>;
  order?: InputMaybe<EmployeeOrderArgs>;
};

export type EmployeeOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  firstname?: InputMaybe<EOrderBy>;
  lastname?: InputMaybe<EOrderBy>;
};

export type EmployeePreferences = {
  __typename?: 'EmployeePreferences';
  defaultShopId?: Maybe<Scalars['ObjectId']>;
};

export type EmployeePreferencesInput = {
  defaultShopId?: InputMaybe<Scalars['ObjectId']>;
};

export type ExportHistoryFilter = {
  __typename?: 'ExportHistoryFilter';
  companyId?: Maybe<Scalars['ObjectId']>;
  date?: Maybe<DateFilterType>;
  dealEventFilter?: Maybe<DealEventFilterType>;
  exportName?: Maybe<Scalars['String']>;
  includeTestUsers?: Maybe<Scalars['Boolean']>;
  shopId?: Maybe<Scalars['ObjectId']>;
};

export type ExtensionChain = {
  __typename?: 'ExtensionChain';
  extensionBookingNumbers: Array<Scalars['Float']>;
  extensionDealIds: Array<Scalars['ObjectId']>;
};

export type FailedPayment = {
  __typename?: 'FailedPayment';
  errors: Array<FailedPaymentError>;
  id: Scalars['String'];
};

export type FailedPaymentError = {
  __typename?: 'FailedPaymentError';
  code: EUnzerFailedPaymentErrorCode;
  message: Scalars['String'];
};

export type FeeAmountForCategory = {
  __typename?: 'FeeAmountForCategory';
  amount: Scalars['Float'];
  categoryId: Scalars['ObjectId'];
};

export type FeeCreateArgs = {
  amount: Scalars['Float'];
  amountForCategories?: InputMaybe<Array<AmountForCategoryArgs>>;
  billingPeriodType: EBillingPeriodType;
  businessUnit: EBusinessUnit;
  companyId: Scalars['ObjectId'];
  dealTypes: Array<EDealType>;
  feeIntervals?: InputMaybe<Array<FeeIntervalArgs>>;
  feeType: EFeeType;
  includedOnExtensions: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  itemQuestionTitle?: InputMaybe<Scalars['String']>;
  itemQuestionValidAnswer?: InputMaybe<Scalars['String']>;
  level: EFeeLevel;
  mode: EFeeMode;
  onlyWhenInAuction?: InputMaybe<Scalars['Boolean']>;
  priority: Scalars['Float'];
  restrictToCategories?: InputMaybe<Array<Scalars['ObjectId']>>;
  restrictToItemQuestion?: InputMaybe<Scalars['ObjectId']>;
  transportMode?: InputMaybe<ETransportMode>;
  withdrawalFeeIntervals?: InputMaybe<Array<WithdrawalFeeIntervalArgs>>;
};

export type FeeDefinition = {
  __typename?: 'FeeDefinition';
  _id: Scalars['ObjectId'];
  amount: Scalars['Float'];
  amountForCategories?: Maybe<Array<FeeAmountForCategory>>;
  billingPeriodType: EBillingPeriodType;
  businessUnit: EBusinessUnit;
  company?: Maybe<Company>;
  companyId: Scalars['ObjectId'];
  dealTypes: Array<EDealType>;
  feeIntervals?: Maybe<Array<FeeInterval>>;
  feeType: EFeeType;
  includedOnExtensions: Scalars['Boolean'];
  intervalSelectedIndex?: Maybe<Scalars['Float']>;
  isActive: Scalars['Boolean'];
  itemQuestionTitle?: Maybe<Scalars['String']>;
  itemQuestionValidAnswer?: Maybe<Scalars['String']>;
  level: EFeeLevel;
  mode: EFeeMode;
  onlyWhenInAuction?: Maybe<Scalars['Boolean']>;
  priority: Scalars['Float'];
  restrictToCategories?: Maybe<Array<Scalars['ObjectId']>>;
  restrictToItemQuestion?: Maybe<Scalars['ObjectId']>;
  transportMode?: Maybe<ETransportMode>;
  withdrawalFeeIntervals?: Maybe<Array<WithdrawalFeeInterval>>;
};

export type FeeDefinitionEvaluation = {
  __typename?: 'FeeDefinitionEvaluation';
  dailyPawnFeeEvaluation: Array<FeeDefinition>;
  dailyPurchaseFeeEvaluation: Array<FeeDefinition>;
  fullMonthPawnFeeEvaluation: Array<FeeDefinition>;
  fullMonthPurchaseFeeEvaluation: Array<FeeDefinition>;
  halfMonthPawnFeeEvaluation: Array<FeeDefinition>;
  halfMonthPurchaseFeeEvaluation: Array<FeeDefinition>;
  oneTimePawnFeeEvaluation: Array<FeeDefinition>;
  oneTimePurchaseFeeEvaluation: Array<FeeDefinition>;
};

export type FeeEvaluationItemCategory = {
  __typename?: 'FeeEvaluationItemCategory';
  feeDefinitionEvaluations: FeeDefinitionEvaluation;
  itemCategoryId: Scalars['ObjectId'];
};

export type FeeFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  businessUnit?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<IdFilter>;
  dealType?: InputMaybe<StringFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  includedOnExtensions?: InputMaybe<BooleanFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  level?: InputMaybe<StringFilter>;
};

export type FeeInterval = {
  __typename?: 'FeeInterval';
  diffAmount: Scalars['Float'];
  finalGrossAmount: Scalars['Float'];
  finalNetAmount: Scalars['Float'];
  from: Scalars['Float'];
  type: EFeeIntervalType;
};

export type FeeIntervalArgs = {
  diffAmount: Scalars['Float'];
  from: Scalars['Float'];
  type: EFeeIntervalType;
};

export type FeeOpts = {
  filter?: InputMaybe<FeeFilterArgs>;
  order?: InputMaybe<FeeOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type FeeOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  amount?: InputMaybe<EOrderBy>;
  billingPeriodType?: InputMaybe<EOrderBy>;
  feeType?: InputMaybe<EOrderBy>;
  level?: InputMaybe<EOrderBy>;
  mode?: InputMaybe<EOrderBy>;
};

export type FeeUpdateArgs = {
  _id: Scalars['ObjectId'];
  amount: Scalars['Float'];
  amountForCategories?: InputMaybe<Array<AmountForCategoryArgs>>;
  billingPeriodType: EBillingPeriodType;
  businessUnit: EBusinessUnit;
  companyId: Scalars['ObjectId'];
  dealTypes: Array<EDealType>;
  feeIntervals?: InputMaybe<Array<FeeIntervalArgs>>;
  feeType: EFeeType;
  includedOnExtensions: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  itemQuestionTitle?: InputMaybe<Scalars['String']>;
  itemQuestionValidAnswer?: InputMaybe<Scalars['String']>;
  level: EFeeLevel;
  mode: EFeeMode;
  onlyWhenInAuction?: InputMaybe<Scalars['Boolean']>;
  priority: Scalars['Float'];
  restrictToCategories?: InputMaybe<Array<Scalars['ObjectId']>>;
  restrictToItemQuestion?: InputMaybe<Scalars['ObjectId']>;
  transportMode?: InputMaybe<ETransportMode>;
  withdrawalFeeIntervals?: InputMaybe<Array<WithdrawalFeeIntervalArgs>>;
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filename?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url: Scalars['String'];
};

export type FileMetadataArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  filename?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type FileTusMetadataArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileId?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type FileUploadCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'FileUploadCustomDealFormQuestion';
  _id: Scalars['ObjectId'];
  info: TranslatedString;
  initialFileUploadAnswer?: Maybe<Scalars['String']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type FindItemCategoryArgs = {
  name: Scalars['String'];
  parentId?: InputMaybe<IdFilter>;
  visibleOnDomain?: InputMaybe<EVisibleOnDomain>;
};

export type FormAnswer = FormBooleanAnswer | FormFileUploadAnswer | FormMultilineTextAnswer | FormNumberAnswer | FormOptionNumberAnswer | FormOptionTextAnswer | FormTextAnswer;

export type FormAnswerArgs = {
  booleanAnswer?: InputMaybe<Scalars['Boolean']>;
  numberAnswer?: InputMaybe<Scalars['Float']>;
  optionNumberAnswer?: InputMaybe<Scalars['Float']>;
  optionTextAnswer?: InputMaybe<Scalars['String']>;
  question: CustomDealFormQuestionUpdateArgs;
  textAnswer?: InputMaybe<Scalars['String']>;
  textMultilineAnswer?: InputMaybe<Scalars['String']>;
};

export type FormAnswerBase = {
  question: CustomDealFormQuestion;
};

export type FormBooleanAnswer = FormAnswerBase & {
  __typename?: 'FormBooleanAnswer';
  booleanAnswer?: Maybe<Scalars['Boolean']>;
  question: BooleanCustomDealFormQuestion;
};

export type FormFileUploadAnswer = FormAnswerBase & {
  __typename?: 'FormFileUploadAnswer';
  question: FileUploadCustomDealFormQuestion;
};

export type FormMultilineTextAnswer = FormAnswerBase & {
  __typename?: 'FormMultilineTextAnswer';
  question: TextMultilineCustomDealFormQuestion;
  textMultilineAnswer?: Maybe<Scalars['String']>;
};

export type FormNumberAnswer = FormAnswerBase & {
  __typename?: 'FormNumberAnswer';
  numberAnswer?: Maybe<Scalars['Float']>;
  question: NumberDefaultCustomDealFormQuestion;
};

export type FormOptionNumberAnswer = FormAnswerBase & {
  __typename?: 'FormOptionNumberAnswer';
  optionNumberAnswer?: Maybe<Scalars['Float']>;
  question: NumberOptionsCustomDealFormQuestion;
};

export type FormOptionTextAnswer = FormAnswerBase & {
  __typename?: 'FormOptionTextAnswer';
  optionTextAnswer?: Maybe<Scalars['String']>;
  question: TextOptionsCustomDealFormQuestion;
};

export type FormTextAnswer = FormAnswerBase & {
  __typename?: 'FormTextAnswer';
  question: TextDefaultCustomDealFormQuestion;
  textAnswer?: Maybe<Scalars['String']>;
};

export type ForwardPaginationSkipLimitArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type GeneratePowerOfAttorneyArgs = {
  customerId: Scalars['ObjectId'];
  dealId: Scalars['ObjectId'];
  shopId: Scalars['ObjectId'];
};

export type GenerateUserAgreementArgs = {
  customerId: Scalars['ObjectId'];
  dealId: Scalars['ObjectId'];
  note: Scalars['String'];
  shopId: Scalars['ObjectId'];
  uses: Scalars['String'];
};

export type GetExistingDealCalculationArgs = {
  dealType: EDealType;
  dropoffTransportMode: ETransportMode;
  durationInDays: Scalars['Int'];
  /** This should be set to true if the calculation result need to be shown to customer. Currently we decide if the Withdrawal fee should be charged or not if the deal is ON_SELL */
  isForCustomer: Scalars['Boolean'];
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  overwrittenPayoutAmount?: InputMaybe<Scalars['Float']>;
  shouldOverwriteManualFees: Scalars['Boolean'];
  shouldOverwritePayoutAmount?: InputMaybe<Scalars['Boolean']>;
};

export type GetProductVariantArgs = {
  productVariantId: Scalars['ObjectId'];
};

export type GetProductVariantsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type GuestCustomerData = {
  __typename?: 'GuestCustomerData';
  blacklistInformation?: Maybe<BlacklistInformation>;
  email: Scalars['String'];
  iban?: Maybe<Scalars['String']>;
  paypalAddress?: Maybe<Scalars['String']>;
};

export type GuestCustomerDataArgs = {
  email: Scalars['String'];
};

export type IAddress = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<ICoordinates>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<ECountry>;
  door?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  stairway?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ICoordinates = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type ICustomerAddress = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<ICoordinates>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<ECountry>;
  door?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  isBillingAddress?: InputMaybe<Scalars['Boolean']>;
  isDeliveryAddress?: InputMaybe<Scalars['Boolean']>;
  isRegistrationAddress?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  stairway?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type IdFilter = {
  condition?: InputMaybe<EIdFilterConditions>;
  value?: InputMaybe<Scalars['ObjectId']>;
};

export type IDealCalculation = {
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  date: Scalars['DateTime'];
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  loanToValuesEntryId: Scalars['ObjectId'];
};

export type IDsFilter = {
  condition?: InputMaybe<EIdFilterConditions>;
  value?: InputMaybe<Scalars['ObjectId']>;
};

export type IStoreboxPickupAddress = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<ICoordinates>;
  country?: InputMaybe<Scalars['String']>;
  countryCode: ECountry;
  door?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  houseNumber: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  stairway?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type ImportItemNewInternalPricesArgs = {
  updateItemNewInternalPricesArgs: Array<UpdateItemNewInternalPriceArgs>;
};

export type ImportNewProductsResult = {
  __typename?: 'ImportNewProductsResult';
  addedProductsCount: Scalars['Float'];
  status?: Maybe<ERefurbedProductsImportStatus>;
};

export type ImportProductsArgs = {
  createdProducts: Array<CreateProduct>;
  updatedProducts: Array<UpdateProduct>;
};

export type InternalPriceHistory = {
  __typename?: 'InternalPriceHistory';
  date: Scalars['DateTime'];
  price: Scalars['Float'];
};

export type InternalSaleData = {
  __typename?: 'InternalSaleData';
  buyerData?: Maybe<BuyerData>;
  date?: Maybe<Scalars['DateTime']>;
  isAuctioned?: Maybe<Scalars['Boolean']>;
  isCashyPrice?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  priceHistories?: Maybe<Array<InternalPriceHistory>>;
  purchasedDirectly?: Maybe<Scalars['Boolean']>;
};

export type InternalSaleDataArgs = {
  buyerData?: InputMaybe<BuyerDataArgs>;
  date?: InputMaybe<Scalars['DateTime']>;
  isAuctioned?: InputMaybe<Scalars['Boolean']>;
  isCashyPrice?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Float']>;
  purchasedDirectly?: InputMaybe<Scalars['Boolean']>;
};

export type Item = {
  __typename?: 'Item';
  _id: Scalars['ObjectId'];
  _oldItemId?: Maybe<Scalars['String']>;
  advertiserPlatform?: Maybe<ESalesPartnerType>;
  bookingNumbers: Array<Scalars['Float']>;
  categorizedUploadedFiles?: Maybe<Array<CategorizedUploadedFile>>;
  checkedAfterAuction?: Maybe<Scalars['Boolean']>;
  checkedAt?: Maybe<Scalars['DateTime']>;
  checkedBy?: Maybe<Scalars['String']>;
  company: Company;
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  customDealId?: Maybe<Scalars['ObjectId']>;
  customRequestId?: Maybe<Scalars['ObjectId']>;
  damageCasePeriods?: Maybe<Array<TimePeriod>>;
  dealsHistory: Array<ItemDealsHistoryEntry>;
  ean?: Maybe<Scalars['String']>;
  entrupyCertificateUrl?: Maybe<Scalars['String']>;
  events?: Maybe<Array<ItemEvent>>;
  formAnswers?: Maybe<Array<FormAnswer>>;
  imei?: Maybe<Scalars['String']>;
  internalSaleData?: Maybe<InternalSaleData>;
  isContinueUsing: Scalars['Boolean'];
  isDamageCase?: Maybe<Scalars['Boolean']>;
  isForPersonalUse?: Maybe<Scalars['Boolean']>;
  isInStore: EItemSituation;
  isInvestmentGold?: Maybe<Scalars['Boolean']>;
  isItemBulky: Scalars['Boolean'];
  isValuable: Scalars['Boolean'];
  itemCategory?: Maybe<ItemCategory>;
  itemInAuctionShop: Scalars['Boolean'];
  itemNotifications: Array<EItemNotification>;
  itemSpecification?: Maybe<Scalars['String']>;
  itemValorizationCalculation?: Maybe<ItemValorizationCalculation>;
  lastBookingNumber?: Maybe<Scalars['String']>;
  manualTest?: Maybe<ItemManualTest>;
  media?: Maybe<Array<FileMetadata>>;
  note?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Note>>;
  personalUsePeriods?: Maybe<Array<TimePeriod>>;
  piceaTest?: Maybe<PiceaTest>;
  piceaUpload?: Maybe<Scalars['Upload']>;
  piceaUploadLink?: Maybe<FileMetadata>;
  policeNumber?: Maybe<Scalars['String']>;
  product?: Maybe<ProductLegacy>;
  productVariant?: Maybe<ProductVariant>;
  serialNumber?: Maybe<Scalars['String']>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  status?: Maybe<EItemStatusType>;
  storageFacility?: Maybe<StorageFacility>;
  storageFacilityId?: Maybe<Scalars['ObjectId']>;
  storageHistory?: Maybe<Array<ItemStorageHistoryEntry>>;
  storageLabel?: Maybe<Scalars['String']>;
  unconfirmedPropertyIds?: Maybe<Array<Scalars['ObjectId']>>;
  updatedAt: Scalars['DateTime'];
  uploadedFiles?: Maybe<Array<FileMetadata>>;
  usedGrade?: Maybe<EUsedGrade>;
  valorizationHistoryIds?: Maybe<Array<Scalars['ObjectId']>>;
  variantId?: Maybe<Scalars['ObjectId']>;
  vehicleData?: Maybe<VehicleData>;
};

export type ItemAnswer = {
  __typename?: 'ItemAnswer';
  questionId: Scalars['ObjectId'];
  rangeValue?: Maybe<Scalars['Float']>;
  selectedOptionIndex?: Maybe<Scalars['Float']>;
};

export type ItemAnswerArgs = {
  questionId: Scalars['ObjectId'];
  rangeValue?: InputMaybe<Scalars['Float']>;
  selectedOptionIndex?: InputMaybe<Scalars['Float']>;
};

export type ItemAuctionRevenue = {
  __typename?: 'ItemAuctionRevenue';
  finalPrice: Scalars['Float'];
  itemId: Scalars['ObjectId'];
  storageLabel: Scalars['String'];
  title: Scalars['String'];
};

export type ItemCalculation = {
  __typename?: 'ItemCalculation';
  itemValuesEntry: ItemValuesEntry;
};

export type ItemCategory = {
  __typename?: 'ItemCategory';
  _id: Scalars['ObjectId'];
  algoliaCategorySlug?: Maybe<Scalars['String']>;
  availableTransportModes: Array<ETransportMode>;
  categoryPageIds?: Maybe<Array<Scalars['ObjectId']>>;
  categoryPages?: Maybe<Array<CategoryPage>>;
  createdAt: Scalars['DateTime'];
  expectedTurnOverTime?: Maybe<Scalars['Float']>;
  helpLink?: Maybe<Scalars['String']>;
  idealoId?: Maybe<Scalars['String']>;
  isValuable?: Maybe<Scalars['Boolean']>;
  maximumPawnDuration: EMaximumPawnDuration;
  minimumItemValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  parent?: Maybe<ItemCategory>;
  parentCategories: Array<ItemCategory>;
  parentId?: Maybe<Scalars['ObjectId']>;
  recursiveMinimumItemValue?: Maybe<Scalars['Float']>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  visibleOnDomain: EVisibleOnDomain;
  warningPossiblyStolenItems?: Maybe<Scalars['Boolean']>;
};

export type ItemCategoryFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  algoliaCategorySlug?: InputMaybe<StringFilter>;
  categoryPageIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  includeHided?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
  parentId?: InputMaybe<IdFilter>;
  slug?: InputMaybe<StringFilter>;
  visibleOnDomain?: InputMaybe<EVisibleOnDomain>;
};

export type ItemCategoryFiltersArgs = {
  createdBefore: Scalars['DateTime'];
  search?: InputMaybe<Scalars['String']>;
};

export type ItemCategoryIdealoIdMapArgs = {
  idealoId?: InputMaybe<Scalars['String']>;
  itemCategoryId: Scalars['ObjectId'];
};

export type ItemCategoryOpts = {
  filter?: InputMaybe<ItemCategoryFilterArgs>;
  order?: InputMaybe<ItemCategoryOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ItemCategoryOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type ItemCategorySearchResult = {
  __typename?: 'ItemCategorySearchResult';
  fullSlug: Scalars['String'];
  icon: EItemCategorySearchIcon;
  matchedKeyword?: Maybe<Scalars['String']>;
  text: TranslatedString;
};

export type ItemDealsHistoryEntry = {
  __typename?: 'ItemDealsHistoryEntry';
  algoliaReference?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<ItemAnswer>>;
  deal: Deal;
  dealId: Scalars['ObjectId'];
  itemCategory?: Maybe<ItemCategory>;
  itemCategoryId: Scalars['ObjectId'];
  loanToValuesEntryId: Scalars['ObjectId'];
  material?: Maybe<Scalars['String']>;
  parentCategoryIds: Array<Scalars['ObjectId']>;
  questionIds?: Maybe<Array<Scalars['ObjectId']>>;
  questions?: Maybe<Array<ItemQuestion>>;
  title: Scalars['String'];
  unconfirmedPropertyIds?: Maybe<Array<Scalars['ObjectId']>>;
  values: ItemValues;
  variantId?: Maybe<Scalars['ObjectId']>;
};

export type ItemEvent = {
  __typename?: 'ItemEvent';
  createdAt: Scalars['DateTime'];
  event: EItemStatusType;
  meta?: Maybe<ItemEventMeta>;
  timestamp: Scalars['DateTime'];
};

export type ItemEventCreateArgs = {
  createdAt: Scalars['DateTime'];
  event: EItemStatusType;
  meta?: InputMaybe<ItemEventMetaArgs>;
  timestamp: Scalars['DateTime'];
};

export type ItemEventMeta = {
  __typename?: 'ItemEventMeta';
  advertisementLink?: Maybe<Array<Scalars['String']>>;
  advertiserPlatformName?: Maybe<Array<Scalars['String']>>;
  cashyEmployee?: Maybe<Employee>;
  cashyEmployeeId?: Maybe<Scalars['ObjectId']>;
  creatorId?: Maybe<Scalars['ObjectId']>;
  derecognizedReason?: Maybe<EItemDerecognizedReason>;
  description?: Maybe<Scalars['String']>;
  destinationShopId?: Maybe<Scalars['ObjectId']>;
  emailAddress?: Maybe<Scalars['String']>;
  isPrerequisites?: Maybe<Scalars['Boolean']>;
  logisticPartnerLabelFile?: Maybe<Scalars['Upload']>;
  logisticPartnerLabelFileLink?: Maybe<FileMetadata>;
  logisticPartnerName?: Maybe<Scalars['String']>;
  logisticPartnerTrackingCode?: Maybe<Scalars['String']>;
  logisticPartnerTrackingLink?: Maybe<Scalars['String']>;
  metaHistories?: Maybe<Array<ItemEventMeta>>;
  notSellableType?: Maybe<EItemNotSellableType>;
  notificationEvents?: Maybe<ItemMetaNotificationEvents>;
  offeredPrice?: Maybe<Scalars['Float']>;
  offeredPriceAt?: Maybe<Scalars['DateTime']>;
  opticalCondition?: Maybe<Scalars['String']>;
  permanentlyNotSellableReason?: Maybe<EItemNotSellablePermanentlyReason>;
  refurbedOffer?: Maybe<RefurbedOffer>;
  returnType?: Maybe<EItemReturnType>;
  salesPartnerId?: Maybe<Scalars['String']>;
  salesPartnerName?: Maybe<Scalars['String']>;
  salesPartnerTrackingLink?: Maybe<Scalars['String']>;
  sendNotification?: Maybe<Scalars['Boolean']>;
  statusReason?: Maybe<Scalars['String']>;
  temporaryNotSellableReason?: Maybe<EItemNotSellableTemporaryReason>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validUntil?: Maybe<Scalars['DateTime']>;
  valorizationEntryId?: Maybe<Scalars['ObjectId']>;
  voluntarySelfDelivery?: Maybe<VoluntarySelfDeliveryMetadata>;
};

export type ItemEventMetaArgs = {
  advertisementLink?: InputMaybe<Array<Scalars['String']>>;
  advertiserPlatformName?: InputMaybe<Array<Scalars['String']>>;
  cashyEmployeeId?: InputMaybe<Scalars['ObjectId']>;
  creatorId?: InputMaybe<Scalars['ObjectId']>;
  derecognizedReason?: InputMaybe<EItemDerecognizedReason>;
  description?: InputMaybe<Scalars['String']>;
  destinationShopId?: InputMaybe<Scalars['ObjectId']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  isPrerequisites?: InputMaybe<Scalars['Boolean']>;
  logisticPartnerLabelFile?: InputMaybe<FileTusMetadataArgs>;
  logisticPartnerName?: InputMaybe<Scalars['String']>;
  logisticPartnerTrackingCode?: InputMaybe<Scalars['String']>;
  logisticPartnerTrackingLink?: InputMaybe<Scalars['String']>;
  notSellableType?: InputMaybe<EItemNotSellableType>;
  offeredPrice?: InputMaybe<Scalars['Float']>;
  offeredPriceAt?: InputMaybe<Scalars['DateTime']>;
  permanentlyNotSellableReason?: InputMaybe<EItemNotSellablePermanentlyReason>;
  refurbedOffer?: InputMaybe<RefurbedOfferArgs>;
  returnType?: InputMaybe<EItemReturnType>;
  salesPartnerId?: InputMaybe<Scalars['String']>;
  salesPartnerName?: InputMaybe<Scalars['String']>;
  salesPartnerTrackingLink?: InputMaybe<Scalars['String']>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  statusReason?: InputMaybe<Scalars['String']>;
  temporaryNotSellableReason?: InputMaybe<EItemNotSellableTemporaryReason>;
  validFrom?: InputMaybe<Scalars['DateTime']>;
  validUntil?: InputMaybe<Scalars['DateTime']>;
  valorizationEntryId?: InputMaybe<Scalars['ObjectId']>;
  voluntarySelfDelivery?: InputMaybe<ItemVoluntarySelfDeliveryArgs>;
};

export type ItemEventUpdateArgs = {
  event: EItemStatusType;
  meta?: InputMaybe<ItemEventMetaArgs>;
};

export type ItemExtensionAnswers = {
  __typename?: 'ItemExtensionAnswers';
  answers: Array<ItemAnswer>;
  storageLabel: Scalars['String'];
};

export type ItemExtensionAnswersArgs = {
  answers: Array<ItemAnswerArgs>;
  storageLabel: Scalars['String'];
};

export type ItemFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  _oldItemId?: InputMaybe<IdFilter>;
  _oldItemIds?: InputMaybe<Array<Scalars['String']>>;
  bookingNumber?: InputMaybe<NumberFilter>;
  bookingNumbers?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<IdFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  itemStatusFilter?: InputMaybe<ItemStatusFilter>;
  storageFacilityId?: InputMaybe<IdFilter>;
  storageLabel?: InputMaybe<StringFilter>;
  storageLabels?: InputMaybe<Array<Scalars['String']>>;
  storageLvl1?: InputMaybe<IdFilter>;
  storageLvl2?: InputMaybe<IdFilter>;
  storageLvl3?: InputMaybe<IdFilter>;
  storageLvl4?: InputMaybe<IdFilter>;
  storageStatusFilter?: InputMaybe<StorageStatusFilter>;
  title?: InputMaybe<StringFilter>;
};

export type ItemManualTest = {
  __typename?: 'ItemManualTest';
  assessments: Array<ItemManualTestAssessment>;
  createdAt: Scalars['DateTime'];
  createdBy: Employee;
};

export type ItemManualTestArgs = {
  assessments: Array<ItemManualTestAssessmentArgs>;
};

export type ItemManualTestAssessment = {
  __typename?: 'ItemManualTestAssessment';
  assessment: EItemManualTestAssessment;
  passed: Scalars['Boolean'];
};

export type ItemManualTestAssessmentArgs = {
  assessment: EItemManualTestAssessment;
  passed: Scalars['Boolean'];
};

export type ItemMetaNotificationEvents = {
  __typename?: 'ItemMetaNotificationEvents';
  overtimeReadyToSell?: Maybe<Scalars['Boolean']>;
  overtimeShipBetweenShops?: Maybe<Scalars['Boolean']>;
};

export type ItemOpts = {
  filter?: InputMaybe<ItemFilterArgs>;
  order?: InputMaybe<ItemOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ItemOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  bookingNumber?: InputMaybe<EOrderBy>;
  updatedAt?: InputMaybe<EOrderBy>;
};

export type ItemPage = {
  __typename?: 'ItemPage';
  _id: Scalars['ObjectId'];
  faqKeyword: Scalars['String'];
  faqsIds: Array<Scalars['ObjectId']>;
  language: Scalars['String'];
  lvl0ContentCategory?: Maybe<Scalars['String']>;
  lvl1ContentCategory?: Maybe<Scalars['String']>;
  lvl2ContentCategory?: Maybe<Scalars['String']>;
  lvl3ContentCategory?: Maybe<Scalars['String']>;
  pageFaqsComponents: Array<ContentComponent>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type ItemPageContent = {
  __typename?: 'ItemPageContent';
  availableRegions?: Maybe<Array<ERegionCode>>;
  categoryPages: CategoryPages;
  id: Scalars['ID'];
  itemPages: ItemPages;
  itemQuestions: Array<ItemQuestion>;
  product: ProductLegacy;
};


export type ItemPageContentCategoryPagesArgs = {
  includeDrafts: Scalars['Boolean'];
  language: Scalars['String'];
};


export type ItemPageContentItemPagesArgs = {
  includeDrafts: Scalars['Boolean'];
  language: Scalars['String'];
};


export type ItemPageContentItemQuestionsArgs = {
  date: Scalars['DateTime'];
  omitInternalQuestions?: InputMaybe<Scalars['Boolean']>;
};

export type ItemPageFilterArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  lvl0ContentCategory?: InputMaybe<StringFilter>;
  lvl0ContentCategoryExists?: InputMaybe<Scalars['Boolean']>;
  lvl1ContentCategory?: InputMaybe<StringFilter>;
  lvl1ContentCategoryExists?: InputMaybe<Scalars['Boolean']>;
  lvl2ContentCategory?: InputMaybe<StringFilter>;
  lvl2ContentCategoryExists?: InputMaybe<Scalars['Boolean']>;
  lvl3ContentCategory?: InputMaybe<StringFilter>;
  lvl3ContentCategoryExists?: InputMaybe<Scalars['Boolean']>;
};

export type ItemPageOpts = {
  filter?: InputMaybe<ItemPageFilterArgs>;
  order?: InputMaybe<ItemPageOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ItemPageOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
};

export type ItemPages = {
  __typename?: 'ItemPages';
  lvl0?: Maybe<ItemPage>;
  lvl1?: Maybe<ItemPage>;
  lvl2?: Maybe<ItemPage>;
  lvl3?: Maybe<ItemPage>;
  root?: Maybe<ItemPage>;
};

export type ItemQuestion = {
  __typename?: 'ItemQuestion';
  _id: Scalars['ObjectId'];
  _oldItemQuestionIds?: Maybe<Array<Scalars['String']>>;
  infoKey?: Maybe<Scalars['String']>;
  isDeactivatedForNewProducts?: Maybe<Scalars['Boolean']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  itemCategories?: Maybe<Array<ItemCategory>>;
  itemCategoryIds: Array<Scalars['ObjectId']>;
  order: Scalars['Float'];
  predictionTag?: Maybe<EQuestionPredictionTag>;
  questionType: EQuestionType;
  rangeData?: Maybe<ItemQuestionRangeData>;
  singleChoiceOptions?: Maybe<Array<ItemQuestionOption>>;
  titleKey: Scalars['String'];
  validFrom: Scalars['DateTime'];
  validTo: Scalars['DateTime'];
  valueMode: EQuestionValueMode;
};

export type ItemQuestionFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  omitDeactivatedQuestionsForNewProducts?: InputMaybe<Scalars['Boolean']>;
  omitInternalQuestions?: InputMaybe<Scalars['Boolean']>;
  titleKey?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<DateFilter>;
  validTo?: InputMaybe<DateFilter>;
  valueMode?: InputMaybe<EQuestionValueMode>;
};

export type ItemQuestionOption = {
  __typename?: 'ItemQuestionOption';
  categoryValues?: Maybe<Scalars['JSON']>;
  conditionValue?: Maybe<EQuestionConditionValue>;
  infoKey?: Maybe<Scalars['String']>;
  isDefaultValue?: Maybe<Scalars['Boolean']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  labelKey: Scalars['String'];
};

export type ItemQuestionOptionArgs = {
  categoryValues?: InputMaybe<Scalars['JSON']>;
  conditionValue?: InputMaybe<EQuestionConditionValue>;
  infoKey?: InputMaybe<Scalars['String']>;
  isDefaultValue?: InputMaybe<Scalars['Boolean']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  labelKey?: InputMaybe<Scalars['String']>;
};

export type ItemQuestionOpts = {
  filter?: InputMaybe<ItemQuestionFilterArgs>;
  order?: InputMaybe<ItemQuestionOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ItemQuestionOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  order?: InputMaybe<EOrderBy>;
  validFrom?: InputMaybe<EOrderBy>;
  validTo?: InputMaybe<EOrderBy>;
};

export type ItemQuestionRangeData = {
  __typename?: 'ItemQuestionRangeData';
  defaultValue: Scalars['Float'];
  maxValue: Scalars['Float'];
  minValue: Scalars['Float'];
  unitKey: Scalars['String'];
  unitPrice: Scalars['Float'];
};

export type ItemQuestionRangeDataArgs = {
  defaultValue: Scalars['Float'];
  maxValue: Scalars['Float'];
  minValue: Scalars['Float'];
  unitKey: Scalars['String'];
  unitPrice: Scalars['Float'];
};

export type ItemStatusFilter = {
  itemStatus: EItemStatusType;
  statusFilterType: EStatusFilterType;
  when?: InputMaybe<DateFilter>;
};

export type ItemStorageHistoryEntry = {
  __typename?: 'ItemStorageHistoryEntry';
  createdAt: Scalars['DateTime'];
  employeeId: Scalars['ObjectId'];
  note?: Maybe<Scalars['String']>;
  storageStatus: EStorageStatus;
  storageUnits: ItemStorageUnits;
  timestamp: Scalars['DateTime'];
};

export type ItemStorageUnits = {
  __typename?: 'ItemStorageUnits';
  lvl1: Scalars['ObjectId'];
  lvl2?: Maybe<Scalars['ObjectId']>;
  lvl3?: Maybe<Scalars['ObjectId']>;
  lvl4?: Maybe<Scalars['ObjectId']>;
};

export type ItemStorageUnitsArgs = {
  lvl1: Scalars['ObjectId'];
  lvl2?: InputMaybe<Scalars['ObjectId']>;
  lvl3?: InputMaybe<Scalars['ObjectId']>;
  lvl4?: InputMaybe<Scalars['ObjectId']>;
};

export type ItemUpdateArgs = {
  _id: Scalars['ObjectId'];
  checkedAfterAuction?: InputMaybe<Scalars['Boolean']>;
  checkedAt?: InputMaybe<Scalars['DateTime']>;
  checkedBy?: InputMaybe<Scalars['String']>;
  disableCheckPiceaTest?: InputMaybe<Scalars['Boolean']>;
  entrupyCertificateUrl?: InputMaybe<Scalars['String']>;
  formAnswers?: InputMaybe<Array<UpdateFormAnswerArgs>>;
  imei?: InputMaybe<Scalars['String']>;
  isBulkyGood?: InputMaybe<Scalars['Boolean']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']>;
  itemSpecification?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']>;
  title?: InputMaybe<Scalars['String']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  usedGrade?: InputMaybe<EUsedGrade>;
  variantId?: InputMaybe<Scalars['ObjectId']>;
  vehicleData?: InputMaybe<UpdateVehicleDataArgs>;
};

export type ItemValorizationCalculation = {
  __typename?: 'ItemValorizationCalculation';
  itemValorizationValues: ItemValorizationValues;
  valorizationHistory: Array<ValorizationHistoryEntry>;
};

export type ItemValorizationValues = {
  __typename?: 'ItemValorizationValues';
  salePrice: Scalars['Float'];
  valorizationDeviation: Scalars['Float'];
  valorizationDifferenceGross: Scalars['Float'];
  valorizationDifferenceNet: Scalars['Float'];
  valorizationDifferenceTax: Scalars['Float'];
};

export type ItemValues = {
  __typename?: 'ItemValues';
  closed?: Maybe<ItemValuesEntry>;
  selected?: Maybe<ItemValuesEntry>;
  verified?: Maybe<ItemValuesEntry>;
};

export type ItemValuesEntry = {
  __typename?: 'ItemValuesEntry';
  adjustedMarketValue: Scalars['Float'];
  conditionMaxMarketValues?: Maybe<ConditionMaxMarketValues>;
  creatorId?: Maybe<Scalars['ObjectId']>;
  currentMarketValue?: Maybe<Scalars['Float']>;
  date: Scalars['DateTime'];
  durationInDays: Scalars['Float'];
  loanToValue: Scalars['Float'];
  maxMarketValue?: Maybe<Scalars['Float']>;
  payoutAmount?: Maybe<Scalars['Float']>;
  predictedMarketValue?: Maybe<Scalars['Float']>;
};

export type ItemVoluntarySelfDeliveryArgs = {
  appointment?: InputMaybe<Scalars['DateTime']>;
};

export type ItemsFilterOpticalCondition = {
  conditionAnswer: EDealItemCondition;
  usedGrade?: InputMaybe<EUsedGrade>;
};

export type ItemsFilterSalePartnerType = {
  from?: InputMaybe<Scalars['DateTime']>;
  mode: EDateFilterMode;
  names: Array<ESalesPartnerType>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type ItemsFilterStatus = {
  from?: InputMaybe<Scalars['DateTime']>;
  mode: EDateFilterMode;
  names: Array<EItemStatusType>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type ItemsFiltersArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  itemCategoryId?: InputMaybe<Scalars['ObjectId']>;
  opticalCondition?: InputMaybe<ItemsFilterOpticalCondition>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  salePartnerType?: InputMaybe<ItemsFilterSalePartnerType>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ItemsFilterStatus>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']>;
  storageUnitIdLv0?: InputMaybe<Scalars['ObjectId']>;
  storageUnitIdLv1?: InputMaybe<Scalars['ObjectId']>;
  storageUnitIdLv2?: InputMaybe<Scalars['ObjectId']>;
  storageUnitIdLv3?: InputMaybe<Scalars['ObjectId']>;
};

export type KsvAssetRecord = {
  __typename?: 'KSVAssetRecord';
  owner?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
};

export type KsvQueryHistory = {
  __typename?: 'KSVQueryHistory';
  meta?: Maybe<Scalars['JSON']>;
  queryAt: Scalars['DateTime'];
  type: EksvRequestType;
  vin: Scalars['String'];
};

export type KnpDebt = {
  __typename?: 'KnpDebt';
  amount: Scalars['Float'];
};

export type KnpOpts = {
  filenumber: Scalars['String'];
};

export type LoanToValueFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  companyId?: InputMaybe<IdFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  validFrom?: InputMaybe<DateFilter>;
  validTo?: InputMaybe<DateFilter>;
};

export type LoanToValueOpts = {
  filter?: InputMaybe<LoanToValueFilterArgs>;
  order?: InputMaybe<LoanToValueOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type LoanToValueOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  validFrom?: InputMaybe<EOrderBy>;
  validTo?: InputMaybe<EOrderBy>;
};

export type LoanToValuesEntry = {
  __typename?: 'LoanToValuesEntry';
  _id: Scalars['ObjectId'];
  categoryValues: Scalars['JSON'];
  company: Company;
  validFrom: Scalars['DateTime'];
};

export type LocationDistance = {
  __typename?: 'LocationDistance';
  distance: Scalars['Float'];
  location: Shop;
};

export type LogisticsPartnerDataArgs = {
  cashy?: InputMaybe<LogisticsPartnerDataCashyArgs>;
  logsta?: InputMaybe<LogisticsPartnerDataLogstaArgs>;
  trackingLink?: InputMaybe<Scalars['String']>;
  type: ELogisticsPartnerType;
};

export type LogisticsPartnerDataCashyArgs = {
  _placeHolder?: InputMaybe<Scalars['Boolean']>;
};

export type LogisticsPartnerDataLogstaArgs = {
  logstaNumber?: InputMaybe<Scalars['String']>;
};

export type LuxuryAppraisalComparablesIngestStats = {
  __typename?: 'LuxuryAppraisalComparablesIngestStats';
  ambiguousDeals: Scalars['Float'];
  customDealsRead: Scalars['Float'];
  inserted: Scalars['Float'];
  itemsRead: Scalars['Float'];
  llmCalls: Scalars['Float'];
  llmFailures: Scalars['Float'];
  refreshed: Scalars['Float'];
  skippedNoValue: Scalars['Float'];
  updated: Scalars['Float'];
};

export type MaintenanceWindow = {
  __typename?: 'MaintenanceWindow';
  _id: Scalars['ObjectId'];
  duration: Scalars['Float'];
  scheduledStartTime: Scalars['DateTime'];
};

export type ManualFeeDefinitionArgs = {
  amount: Scalars['Float'];
  billingPeriodType: EBillingPeriodType;
  date?: InputMaybe<Scalars['DateTime']>;
  dealType: EDealType;
  description?: InputMaybe<Scalars['String']>;
  feeType: EFeeType;
  isActive: Scalars['Boolean'];
  isManual: Scalars['Boolean'];
  level: EFeeLevel;
  mode: EFeeMode;
  storageLabel?: InputMaybe<Scalars['String']>;
  ust: Scalars['Float'];
};

export type ManualPaymentWrapper = {
  __typename?: 'ManualPaymentWrapper';
  value: EManualPaymentType;
};

export type MaterialMetric = {
  __typename?: 'MaterialMetric';
  alloy: Scalars['Float'];
  weight: Scalars['Float'];
};

export type MaterialMetricArgs = {
  alloy: Scalars['Float'];
  weight: Scalars['Float'];
};

export type MaterialPrice = {
  __typename?: 'MaterialPrice';
  _id: Scalars['ObjectId'];
  date: Scalars['DateTime'];
  material: Scalars['String'];
  mu: Scalars['Float'];
  price: Scalars['Float'];
  sigma: Scalars['Float'];
};

export type MaterialPriceFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  date?: InputMaybe<DateFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  material?: InputMaybe<StringFilter>;
  price?: InputMaybe<NumberFilter>;
};

export type MaterialPriceOpts = {
  filter?: InputMaybe<MaterialPriceFilterArgs>;
  order?: InputMaybe<MaterialPriceOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type MaterialPriceOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  date?: InputMaybe<EOrderBy>;
  material?: InputMaybe<EOrderBy>;
  mu?: InputMaybe<EOrderBy>;
  price?: InputMaybe<EOrderBy>;
  sigma?: InputMaybe<EOrderBy>;
};

export type MemorySize = {
  __typename?: 'MemorySize';
  gb?: Maybe<Array<Scalars['Float']>>;
  mb?: Maybe<Array<Scalars['Float']>>;
  tb?: Maybe<Array<Scalars['Float']>>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  _id: Scalars['ObjectId'];
  label: Scalars['String'];
  url: Scalars['String'];
  visibleOnDomain: EStrapiContentCountry;
};

export type MenuPanel = {
  __typename?: 'MenuPanel';
  _id: Scalars['ObjectId'];
  allCategoriesLabel: Scalars['String'];
  categories: Array<MenuItem>;
};


export type MenuPanelCategoriesArgs = {
  country?: InputMaybe<EStrapiContentCountry>;
};

export type MergeCustomersInput = {
  mergedCustomerId: Scalars['ObjectId'];
  primaryCustomerId: Scalars['ObjectId'];
  reason: EMergingCustomerReason;
};

export type MergedCustomer = {
  __typename?: 'MergedCustomer';
  createdAt?: Maybe<Scalars['DateTime']>;
  customDealIds?: Maybe<Array<Scalars['ObjectId']>>;
  customRequestIds?: Maybe<Array<Scalars['ObjectId']>>;
  customerId?: Maybe<Scalars['ObjectId']>;
  dealIds?: Maybe<Array<Scalars['ObjectId']>>;
  reason?: Maybe<EMergingCustomerReason>;
};

export type MergedCustomerArgs = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customDealIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  customRequestIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  dealIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  reason?: InputMaybe<EMergingCustomerReason>;
};

export type MultipleLanguageTextArgs = {
  languageCode: ELanguageCode;
  text: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateEmployee: Employee;
  addCompanyId: Employee;
  addCustomDealItem: CustomDealItemDataEntry;
  addCustomDealNote: CustomDeal;
  addDealItem: Deal;
  addDealItemsToStorageUnit: Deal;
  addDealNote: Deal;
  addDealRating: Scalars['Boolean'];
  addItemCategoryId: Shop;
  addItemNote: Item;
  addItemToStorageUnit: Item;
  addKSVAsset: Scalars['Boolean'];
  addSecondaryCustomerToDeal: Deal;
  addStorageFacilityId: Shop;
  addValorizationHistoryEntryToDealItem: Deal;
  appraiseItem: AppraisalStepResult;
  callViviVinEndpoint: ViviSequenceResponse;
  cancelCashBookCashFlow: CashBookCashFlowCancel;
  cancelDeal: Deal;
  cancelPaybackExtension: Deal;
  cancelPickupAndUpdateDeal: Deal;
  changeAuctionItemStatus: Auction;
  changeCustomerPasswordFromToken: Customer;
  changeItemStatus: Item;
  changeKSVAsset: Scalars['Boolean'];
  changeMainCustomerOfDeal: Deal;
  closeAuctionById: Auction;
  closeDeal: Deal;
  confirmExtension: Deal;
  confirmPayback: Deal;
  connectCustomerToDeal: Deal;
  convertToDeal: Scalars['Boolean'];
  createAuction: Auction;
  createCarDeal: Deal;
  createCashBookCashFlow: CashBookCashFlow;
  createCashBookCount: CashBookCount;
  createChildUnit: StorageUnit;
  createCompany: Company;
  createCustomDeal: CustomDeal;
  createCustomDealForm: CustomDealForm;
  createCustomerBlacklist: CustomerBlacklist;
  createCustomerCallRequest: Scalars['Boolean'];
  createDeal: Deal;
  createDealForCustomer: Deal;
  createEmployee: Employee;
  createFee: Array<FeeDefinition>;
  createItemCategory: ItemCategory;
  createItemQuestion: ItemQuestion;
  createLoanToValuesEntry: LoanToValuesEntry;
  createMaintenanceWindow: MaintenanceWindow;
  createMaterialPrice: MaterialPrice;
  createOrUpdateReady2OrderApiKey: Scalars['Boolean'];
  createPartner: Partner;
  createPrivateSale: PrivateSale;
  createPrivateSaleTransaction: PrivateSale;
  createProduct: Product;
  createProductLegacy: ProductLegacy;
  createProductPropertyDefinition: ProductPropertyDefinition;
  createReceiptWithoutIdentity: Deal;
  createResponseTemplate: ResponseTemplate;
  createShippingLabel: ShippingLabel;
  createShippingLabelByPageId: Deal;
  createShop: Shop;
  createStorageFacility: StorageFacility;
  createStorageUnit: StorageUnit;
  createValorizationEntry: ValorizationEntry;
  deactivateCompany: Company;
  deactivateCustomer: Scalars['Boolean'];
  deactivateEmployee: Scalars['Boolean'];
  deactivatePartner: Partner;
  deactivateStorageFacility: StorageFacility;
  declineDeal: Deal;
  deleteAuction: Auction;
  deleteCustomDeal: CustomDeal;
  deleteCustomDealForm: Scalars['Boolean'];
  deleteCustomer: Scalars['Boolean'];
  deleteCustomerBlacklist: Scalars['Boolean'];
  deleteFee: Array<FeeDefinition>;
  deleteItemCategory: Scalars['String'];
  deleteItemQuestion: Scalars['String'];
  deleteLoanToValuesEntry: Scalars['String'];
  deleteMaterialPrice: Scalars['String'];
  deletePrivateSaleTransaction: PrivateSale;
  deleteResponseTemplate: Scalars['String'];
  deleteStorageUnit: StorageUnit;
  deleteValorizationEntry: Scalars['String'];
  disablePostalCode: Scalars['Boolean'];
  employeeChangePassword: Scalars['Boolean'];
  enablePostalCodes: Array<StoreboxEnabledPostalCode>;
  exchangeDealItem: Deal;
  findKSVAssets: Scalars['Boolean'];
  generateAuctionAnnouncementPdf: Auction;
  generatePowerOfAttorney: Deal;
  generateUserAgreement: Deal;
  importItemNewInternalPrices: Scalars['Boolean'];
  importNewRefurbedProducts: Scalars['Boolean'];
  importProducts: Scalars['Boolean'];
  ingestLuxuryAppraisalComparables: LuxuryAppraisalComparablesIngestStats;
  loginCustomer: Customer;
  loginEmployee: Employee;
  mergeCustomer?: Maybe<Customer>;
  overwriteCustomDealPayoutAmountToCustomerRequested: CustomDeal;
  parsePiceaTest: Item;
  payDealSurplusAmount: Deal;
  payExtensionOnline: OnlinePaymentResult;
  qualifyLead: CustomDeal;
  reevaluateFinalPrivateSaleFinalState: Deal;
  refetchAndUpdateCarMarketValue: Deal;
  refreshAuction: Auction;
  refreshDealInAuction: Deal;
  refreshItem: Item;
  refreshItemValorizations: Deal;
  refreshShippingProfileList: Array<RefurbedShippingProfile>;
  refreshValorizationCalculationForDealItem: Deal;
  regenerateBillForDeal: Deal;
  regeneratePawnTicketForDeal: Deal;
  regenerateReceiptForDeal: Deal;
  regenerateValorizationReceipts: Array<ValorizationEntry>;
  registerCustomer: Customer;
  rejectCustomDealCounteroffer: CustomDeal;
  removeCustomDealItem: Scalars['Boolean'];
  removeDealItem: Deal;
  removeItemCategoryId: Shop;
  removeItemFromStorageUnit: Item;
  removeKSVAsset: Scalars['Boolean'];
  removeLastItemEvent: Item;
  removeSecondaryCustomerToDeal: Deal;
  removeStorageFacilityId: Array<Shop>;
  removeValorizationEntry: Scalars['Boolean'];
  reserveExtension: Deal;
  reservePayback: Deal;
  resetCustomerPasswordMail: Scalars['Boolean'];
  saveReady2OrderProductMaps: Scalars['Boolean'];
  seedAppraisalProducts: AppraisalSeedStats;
  seedElectronicsAppraisalCatalog: ElectronicsAppraisalCatalogSeedStats;
  sendReminderEmailForUploadingID?: Maybe<Customer>;
  setAllDealItemsToPurchasedDirectly: Array<Item>;
  setAuctionItemsBuyersAndGenerateSurchargeCertificate: Auction;
  setDealReceivedIdMissing: Deal;
  setDealReviewing: Deal;
  setElectronicsAppraisalCatalogVariantAnchor: ElectronicsAppraisalCatalogVariant;
  setMainStorageFacilityId: Shop;
  setOnSell: Deal;
  setPayedAndStored: Deal;
  setSoldExtern: Deal;
  startAuction: Auction;
  updateAuction: Auction;
  updateAuctionItem: Auction;
  updateCarInspection: Deal;
  updateCashBookCount: CashBookCount;
  updateCompany: Company;
  updateCurrentEmployeePreferences: Employee;
  updateCustomDeal: CustomDeal;
  updateCustomDealForm: CustomDealForm;
  updateCustomDealItem: CustomDealItemDataEntry;
  updateCustomDealNote: CustomDeal;
  updateCustomer: Customer;
  updateCustomerBlacklist: CustomerBlacklist;
  updateCustomerCategory: Deal;
  updateCustomerPassword: Customer;
  updateDealAuctioningSettings: Deal;
  updateDealItem: DealItem;
  updateDealItemAnswers: Deal;
  updateDealItemAnswersWithoutRecalculation: Deal;
  updateDealItemInternalSaleData: Deal;
  updateDealNote: Deal;
  updateDealOnlineExtensionPrevention: Deal;
  updateDealTransport: Deal;
  updateDealUploadedFiles: Deal;
  updateEmployee: Employee;
  updateEmployeePassword: Employee;
  updateEmployeeProfile: Employee;
  updateFee: Array<FeeDefinition>;
  updateInsuredAmount: Deal;
  updateInternalSaleDataForDirectlyPurchasedItems: Deal;
  updateItem: Item;
  updateItemCategorizedUploadedFiles: Item;
  updateItemCategory: ItemCategory;
  updateItemCategoryId: Item;
  updateItemCategoryIdealoIdMaps: Scalars['Boolean'];
  updateItemEvent: Item;
  updateItemManualTest: Item;
  updateItemMedia: Item;
  updateItemNote: Item;
  updateItemQuestion: ItemQuestion;
  updateItemUploadedFiles: Item;
  updateMaintenanceWindow: Scalars['Boolean'];
  updateMaterialPrice: MaterialPrice;
  updatePartialRedemption: Deal;
  updatePartner: Partner;
  updatePaybackData: Deal;
  updatePayoutData: Deal;
  updatePiceaUploadLink: Item;
  updatePreviewCalculation: Deal;
  updatePrivateSaleTransaction: PrivateSale;
  updateProduct: Product;
  updateProductLegacy: ProductLegacy;
  updateProductPrice: Product;
  updateProductPropertyDefinition: ProductPropertyDefinition;
  updateProductPublication: Product;
  updateResponseTemplate: ResponseTemplate;
  updateSavedValorizationHistoryEntry: Array<ValorizationEntry>;
  updateSecondaryPayoutData: Deal;
  updateShop: Shop;
  updateShopId: Deal;
  updateStorageFacility: StorageFacility;
  updateStorageLabelForCashBookCashFlow: CashBookCashFlow;
  updateStorageUnit: StorageUnit;
  validatePaybackOrExtendDealPersistanceCalculation: Scalars['Boolean'];
  verifyActivationEmployeeToken: VerifiedActivationEmployee;
  verifyDeal: Deal;
};


export type MutationActivateEmployeeArgs = {
  args: EmployeeActivationArgs;
};


export type MutationAddCompanyIdArgs = {
  companyId: Scalars['ObjectId'];
  employeeId: Scalars['ObjectId'];
};


export type MutationAddCustomDealItemArgs = {
  customDealId: Scalars['ObjectId'];
  customDealItemCreateArgs: CustomDealItemCreateArgs;
};


export type MutationAddCustomDealNoteArgs = {
  customDealId: Scalars['ObjectId'];
  noteCreateArgs: NoteCreateArgs;
};


export type MutationAddDealItemArgs = {
  args: DealItemCreateArgs;
  dealId: Scalars['ObjectId'];
};


export type MutationAddDealItemsToStorageUnitArgs = {
  args: AddDealItemsToStorageUnitArgs;
};


export type MutationAddDealNoteArgs = {
  dealId: Scalars['ObjectId'];
  noteCreateArgs: NoteCreateArgs;
};


export type MutationAddDealRatingArgs = {
  dealId: Scalars['ObjectId'];
  message?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
};


export type MutationAddItemCategoryIdArgs = {
  itemCategoryId: Scalars['ObjectId'];
  shopId: Scalars['ObjectId'];
};


export type MutationAddItemNoteArgs = {
  itemId: Scalars['ObjectId'];
  noteCreateArgs: NoteCreateArgs;
};


export type MutationAddItemToStorageUnitArgs = {
  itemId: Scalars['ObjectId'];
  note?: InputMaybe<Scalars['String']>;
  setDealToPayedAndStored?: InputMaybe<Scalars['Boolean']>;
  storageDate?: InputMaybe<Scalars['DateTime']>;
  storageUnits: ItemStorageUnitsArgs;
};


export type MutationAddKsvAssetArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  itemId: Scalars['ObjectId'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationAddSecondaryCustomerToDealArgs = {
  dealId: Scalars['ObjectId'];
  selectedCustomerId: Scalars['ObjectId'];
};


export type MutationAddStorageFacilityIdArgs = {
  shopId: Scalars['ObjectId'];
  storageFacilityId: Scalars['ObjectId'];
};


export type MutationAddValorizationHistoryEntryToDealItemArgs = {
  args: ValorizationEntryCreateArgs;
  dealId: Scalars['ObjectId'];
  itemId: Scalars['ObjectId'];
  shopId: Scalars['ObjectId'];
};


export type MutationAppraiseItemArgs = {
  answers?: InputMaybe<Array<AppraisalAnswerInput>>;
  companyId: Scalars['ObjectId'];
  context?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};


export type MutationCallViviVinEndpointArgs = {
  args: ViviVinRequestArgs;
};


export type MutationCancelCashBookCashFlowArgs = {
  cashBookCashFlowId: Scalars['ObjectId'];
};


export type MutationCancelDealArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationCancelPaybackExtensionArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationCancelPickupAndUpdateDealArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationChangeAuctionItemStatusArgs = {
  args: AuctionItemArgs;
  newItemStatus: EAuctionItemStatus;
};


export type MutationChangeCustomerPasswordFromTokenArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationChangeItemStatusArgs = {
  addItemToStorageUnitArgs?: InputMaybe<AddItemToStorageUnitArgs>;
  isStatusAddedManually: Scalars['Boolean'];
  itemId: Scalars['ObjectId'];
  newEvent: ItemEventCreateArgs;
  relocateItem?: InputMaybe<Scalars['Boolean']>;
  relocateNote?: InputMaybe<Scalars['String']>;
  shippingLabelCreateArgs?: InputMaybe<ShippingLabelCreateArgs>;
};


export type MutationChangeKsvAssetArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  itemId: Scalars['ObjectId'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationChangeMainCustomerOfDealArgs = {
  dealId: Scalars['ObjectId'];
  selectedCustomerId: Scalars['ObjectId'];
};


export type MutationCloseAuctionByIdArgs = {
  openAuctionId: Scalars['ObjectId'];
};


export type MutationCloseDealArgs = {
  dealId: Scalars['ObjectId'];
  removeItemsFromStorage: Scalars['Boolean'];
};


export type MutationConfirmExtensionArgs = {
  args: ConfirmExtensionArgs;
};


export type MutationConfirmPaybackArgs = {
  args: ConfirmPaybackArgs;
};


export type MutationConnectCustomerToDealArgs = {
  customerId: Scalars['ObjectId'];
  dealId: Scalars['ObjectId'];
};


export type MutationConvertToDealArgs = {
  customDealId: Scalars['ObjectId'];
  customDealUpdateArgs?: InputMaybe<CustomDealUpdateArgs>;
};


export type MutationCreateAuctionArgs = {
  args: AuctionCreateArgs;
  shouldNotifyCustomers: Scalars['Boolean'];
};


export type MutationCreateCarDealArgs = {
  companyId: Scalars['ObjectId'];
  creatorId?: InputMaybe<Scalars['ObjectId']>;
  customDealId?: InputMaybe<Scalars['ObjectId']>;
  dealCalculationId: Scalars['ObjectId'];
  dealItemsCreateArgs: Array<DealItemCreateArgs>;
  dealPartnerData?: InputMaybe<DealPartnerDataArgs>;
  employeeDeclarations?: InputMaybe<Array<Scalars['String']>>;
  guestCustomerDataArgs?: InputMaybe<GuestCustomerDataArgs>;
  iban?: InputMaybe<Scalars['String']>;
  initialShopId?: InputMaybe<Scalars['ObjectId']>;
  payoutType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']>;
  pickupData?: InputMaybe<TransportDataArgs>;
  registeredCustomerId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationCreateCashBookCashFlowArgs = {
  cashBookCashFlowArgs: CashBookCashFlowArgs;
};


export type MutationCreateCashBookCountArgs = {
  cashBookCountArgs: CashBookCountArgs;
};


export type MutationCreateChildUnitArgs = {
  capacity?: InputMaybe<Scalars['Float']>;
  isSecureLocation?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ObjectId']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationCreateCompanyArgs = {
  company: CompanyCreateArgs;
};


export type MutationCreateCustomDealArgs = {
  customDealCreateArgs: CustomDealCreateArgs;
};


export type MutationCreateCustomDealFormArgs = {
  customDealFormCreateArgs: CustomDealFormCreateArgs;
};


export type MutationCreateCustomerBlacklistArgs = {
  args: CustomerBlacklistCreateArgs;
};


export type MutationCreateCustomerCallRequestArgs = {
  args: CustomerCallRequestArgs;
};


export type MutationCreateDealArgs = {
  companyId: Scalars['ObjectId'];
  creatorId?: InputMaybe<Scalars['ObjectId']>;
  customDealId?: InputMaybe<Scalars['ObjectId']>;
  dealCalculationId: Scalars['ObjectId'];
  dealItemsCreateArgs: Array<DealItemCreateArgs>;
  dealPartnerData?: InputMaybe<DealPartnerDataArgs>;
  employeeDeclarations?: InputMaybe<Array<Scalars['String']>>;
  guestCustomerDataArgs?: InputMaybe<GuestCustomerDataArgs>;
  iban?: InputMaybe<Scalars['String']>;
  initialShopId?: InputMaybe<Scalars['ObjectId']>;
  payoutType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']>;
  pickupData?: InputMaybe<TransportDataArgs>;
  registeredCustomerId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationCreateDealForCustomerArgs = {
  customerEmail: Scalars['String'];
  dealCreateArgs: DealCreateArgs;
};


export type MutationCreateEmployeeArgs = {
  companyId: Scalars['ObjectId'];
  email: Scalars['String'];
  roles: Array<ERoles>;
};


export type MutationCreateFeeArgs = {
  feeCreateArgs: FeeCreateArgs;
};


export type MutationCreateItemCategoryArgs = {
  algoliaCategorySlug?: InputMaybe<Scalars['String']>;
  categoryPageIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  expectedTurnOverTime?: InputMaybe<Scalars['Float']>;
  helpLink?: InputMaybe<Scalars['String']>;
  maximumPawnDuration?: InputMaybe<EMaximumPawnDuration>;
  minimumItemValue?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ObjectId']>;
  storageFeeIds: Array<Scalars['ObjectId']>;
  visibleOnDomain?: InputMaybe<EVisibleOnDomain>;
};


export type MutationCreateItemQuestionArgs = {
  _oldItemQuestionIds?: InputMaybe<Array<Scalars['String']>>;
  infoKey?: InputMaybe<Scalars['String']>;
  isDeactivatedForNewProducts?: InputMaybe<Scalars['Boolean']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  itemCategoryIds: Array<Scalars['ObjectId']>;
  order: Scalars['Float'];
  predictionTag?: InputMaybe<EQuestionPredictionTag>;
  questionType: EQuestionType;
  rangeData?: InputMaybe<ItemQuestionRangeDataArgs>;
  singleChoiceOptions?: InputMaybe<Array<ItemQuestionOptionArgs>>;
  titleKey: Scalars['String'];
  validFrom: Scalars['DateTime'];
  validTo: Scalars['DateTime'];
  valueMode: EQuestionValueMode;
};


export type MutationCreateLoanToValuesEntryArgs = {
  categoryValues: Scalars['JSON'];
  companyId: Scalars['ObjectId'];
  validFrom: Scalars['DateTime'];
};


export type MutationCreateMaintenanceWindowArgs = {
  duration: Scalars['Float'];
  scheduledStartTime: Scalars['DateTime'];
};


export type MutationCreateMaterialPriceArgs = {
  date: Scalars['DateTime'];
  material: Scalars['String'];
  mu: Scalars['Float'];
  price: Scalars['Float'];
  sigma: Scalars['Float'];
};


export type MutationCreateOrUpdateReady2OrderApiKeyArgs = {
  args: CreateOrUpdateReady2OrderApiKeyArgs;
};


export type MutationCreatePartnerArgs = {
  partner: PartnerCreateArgs;
};


export type MutationCreatePrivateSaleArgs = {
  args: PrivateSaleCreateArgs;
};


export type MutationCreatePrivateSaleTransactionArgs = {
  args: PrivateSaleTransactionArgs;
  needToHandleCashbook: Scalars['Boolean'];
  privateSaleId: Scalars['ObjectId'];
};


export type MutationCreateProductArgs = {
  args: ProductCreateArgs;
};


export type MutationCreateProductLegacyArgs = {
  class?: InputMaybe<Scalars['String']>;
  conditionMaxValues?: InputMaybe<ConditionMaxMarketValuesArgs>;
  contentCategories?: InputMaybe<ContentCategoriesArgs>;
  ean?: InputMaybe<Scalars['String']>;
  gewicht?: InputMaybe<Scalars['Float']>;
  isInactive?: InputMaybe<Scalars['Boolean']>;
  isTaxFree?: InputMaybe<Scalars['Boolean']>;
  itemCategoryIds: Array<Scalars['ObjectId']>;
  karat?: InputMaybe<Scalars['Float']>;
  material?: InputMaybe<Scalars['String']>;
  maxLoanToValue?: InputMaybe<Scalars['Float']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  objectID: Scalars['String'];
  pictureFilename?: InputMaybe<Scalars['String']>;
  releaseDate?: InputMaybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};


export type MutationCreateProductPropertyDefinitionArgs = {
  args: ProductPropertyDefinitionCreateArgs;
};


export type MutationCreateReceiptWithoutIdentityArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationCreateResponseTemplateArgs = {
  responseTemplate: ResponseTemplateCreateArgs;
};


export type MutationCreateShippingLabelArgs = {
  createArgs: ShippingLabelCreateArgs;
};


export type MutationCreateShippingLabelByPageIdArgs = {
  shippingLabelPageId: Scalars['String'];
};


export type MutationCreateShopArgs = {
  address: IAddress;
  cashBoxNames?: InputMaybe<Array<Scalars['String']>>;
  companyId: Scalars['ObjectId'];
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  googleMapsLink: Scalars['String'];
  hideLocationOnWebsite?: InputMaybe<Scalars['Boolean']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  name: Scalars['String'];
  openingHours: Scalars['String'];
  partnerId?: InputMaybe<Scalars['ObjectId']>;
  phone: Scalars['String'];
  r2oProductMaps?: InputMaybe<Array<R2OProductMapArgs>>;
  ready2OrderApiKey?: InputMaybe<Scalars['String']>;
  successionShopId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationCreateStorageFacilityArgs = {
  address: IAddress;
  external: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationCreateStorageUnitArgs = {
  capacity?: InputMaybe<Scalars['Float']>;
  isSecureLocation?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ObjectId']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationCreateValorizationEntryArgs = {
  buyerBillingAddress?: InputMaybe<BuyerBillingAddressArgs>;
  buyerEmail?: InputMaybe<Scalars['String']>;
  buyerName?: InputMaybe<Scalars['String']>;
  buyerPhone?: InputMaybe<Scalars['String']>;
  buyerShippingAddress?: InputMaybe<IAddress>;
  cashflow: Scalars['Float'];
  customLabel?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  descriptionForItemStatus?: InputMaybe<Scalars['String']>;
  isItemReturned?: InputMaybe<Scalars['Boolean']>;
  isTaxFreeTransaction?: InputMaybe<Scalars['Boolean']>;
  itemsIds: Array<Scalars['ObjectId']>;
  logisticsPartnerData?: InputMaybe<LogisticsPartnerDataArgs>;
  order?: InputMaybe<Scalars['Float']>;
  paymentData?: InputMaybe<PaymentDataArgs>;
  relatedBillId?: InputMaybe<Scalars['ObjectId']>;
  returnReason?: InputMaybe<EReturnReasons>;
  returnReasonDetails?: InputMaybe<Scalars['String']>;
  salesPartnerData?: InputMaybe<SalesPartnerDataArgs>;
  sendBill?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeactivateCompanyArgs = {
  companyId: Scalars['ObjectId'];
};


export type MutationDeactivateCustomerArgs = {
  customerId: Scalars['ObjectId'];
};


export type MutationDeactivateEmployeeArgs = {
  employeeId: Scalars['ObjectId'];
};


export type MutationDeactivatePartnerArgs = {
  partnerId: Scalars['ObjectId'];
};


export type MutationDeactivateStorageFacilityArgs = {
  storageFacilityId: Scalars['ObjectId'];
};


export type MutationDeclineDealArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationDeleteAuctionArgs = {
  args: AuctionDeleteArgs;
};


export type MutationDeleteCustomDealArgs = {
  customDealId: Scalars['ObjectId'];
};


export type MutationDeleteCustomDealFormArgs = {
  customDealFormId: Scalars['ObjectId'];
};


export type MutationDeleteCustomerArgs = {
  customerId: Scalars['ObjectId'];
};


export type MutationDeleteCustomerBlacklistArgs = {
  args: CustomerBlacklistDeleteArgs;
};


export type MutationDeleteFeeArgs = {
  feeId: Scalars['ObjectId'];
};


export type MutationDeleteItemCategoryArgs = {
  itemCategoryId: Scalars['ObjectId'];
};


export type MutationDeleteItemQuestionArgs = {
  itemQuestionId: Scalars['ObjectId'];
};


export type MutationDeleteLoanToValuesEntryArgs = {
  loanToValuesEntryId: Scalars['ObjectId'];
};


export type MutationDeleteMaterialPriceArgs = {
  materialPriceId: Scalars['ObjectId'];
};


export type MutationDeletePrivateSaleTransactionArgs = {
  privateSaleId: Scalars['ObjectId'];
  transactionOrder: Scalars['Float'];
};


export type MutationDeleteResponseTemplateArgs = {
  responseTemplateId: Scalars['ObjectId'];
};


export type MutationDeleteStorageUnitArgs = {
  storageUnitId: Scalars['ObjectId'];
};


export type MutationDeleteValorizationEntryArgs = {
  valorizationEntryId: Scalars['ObjectId'];
};


export type MutationDisablePostalCodeArgs = {
  id: Scalars['ObjectId'];
};


export type MutationEmployeeChangePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationEnablePostalCodesArgs = {
  companyId: Scalars['ObjectId'];
  postalCodes: Array<Scalars['String']>;
};


export type MutationExchangeDealItemArgs = {
  dealId: Scalars['ObjectId'];
  newItemArgs: DealItemCreateArgs;
  oldItemId: Scalars['ObjectId'];
};


export type MutationFindKsvAssetsArgs = {
  itemId: Scalars['ObjectId'];
};


export type MutationGenerateAuctionAnnouncementPdfArgs = {
  auctionId: Scalars['ObjectId'];
};


export type MutationGeneratePowerOfAttorneyArgs = {
  generatePowerOfAttorneyArgs: GeneratePowerOfAttorneyArgs;
};


export type MutationGenerateUserAgreementArgs = {
  generateUserAgreementArgs: GenerateUserAgreementArgs;
};


export type MutationImportItemNewInternalPricesArgs = {
  args: ImportItemNewInternalPricesArgs;
};


export type MutationImportProductsArgs = {
  args: ImportProductsArgs;
};


export type MutationIngestLuxuryAppraisalComparablesArgs = {
  category?: InputMaybe<ELuxuryAppraisalCategory>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  renormalise?: InputMaybe<Scalars['Boolean']>;
  since?: InputMaybe<Scalars['DateTime']>;
};


export type MutationLoginCustomerArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationLoginEmployeeArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationMergeCustomerArgs = {
  input: MergeCustomersInput;
};


export type MutationOverwriteCustomDealPayoutAmountToCustomerRequestedArgs = {
  customDealId: Scalars['ObjectId'];
};


export type MutationParsePiceaTestArgs = {
  itemId: Scalars['ObjectId'];
};


export type MutationPayDealSurplusAmountArgs = {
  dealSurplusPaymentArgs: DealSurplusPaymentArgs;
};


export type MutationPayExtensionOnlineArgs = {
  onlinePaymentArgs: OnlinePaymentArgs;
};


export type MutationQualifyLeadArgs = {
  args: QualifyLeadArgs;
};


export type MutationReevaluateFinalPrivateSaleFinalStateArgs = {
  privateSaleId: Scalars['ObjectId'];
};


export type MutationRefetchAndUpdateCarMarketValueArgs = {
  itemId: Scalars['ObjectId'];
};


export type MutationRefreshAuctionArgs = {
  auctionId: Scalars['ObjectId'];
};


export type MutationRefreshDealInAuctionArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationRefreshItemArgs = {
  itemId: Scalars['ObjectId'];
};


export type MutationRefreshItemValorizationsArgs = {
  itemId: Scalars['ObjectId'];
};


export type MutationRefreshValorizationCalculationForDealItemArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationRegenerateBillForDealArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationRegeneratePawnTicketForDealArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationRegenerateReceiptForDealArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationRegenerateValorizationReceiptsArgs = {
  valorizationEntryId: Scalars['ObjectId'];
};


export type MutationRegisterCustomerArgs = {
  acquiredBy?: InputMaybe<Scalars['String']>;
  additionalInformationForCarPawn?: InputMaybe<AdditionalInformationForCarPawnArgs>;
  address?: InputMaybe<ICustomerAddress>;
  dateOfBirth: Scalars['DateTime'];
  deactivated?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  guestEmail?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  identityType?: InputMaybe<ECustomerIdentityType>;
  identityUploadLinks?: InputMaybe<Array<FileTusMetadataArgs>>;
  isNotePopup?: InputMaybe<Scalars['Boolean']>;
  isTestUser?: InputMaybe<Scalars['Boolean']>;
  lastname: Scalars['String'];
  mergedCustomers?: InputMaybe<Array<InputMaybe<MergedCustomerArgs>>>;
  note?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  paypalAddress?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  registrationId?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<ESex>;
};


export type MutationRejectCustomDealCounterofferArgs = {
  rejectCustomDealCounterofferArgs: RejectCustomDealCounterofferArgs;
};


export type MutationRemoveCustomDealItemArgs = {
  customDealRemoveItemArgs: CustomDealRemoveItemArgs;
};


export type MutationRemoveDealItemArgs = {
  dealId: Scalars['ObjectId'];
  itemId: Scalars['ObjectId'];
};


export type MutationRemoveItemCategoryIdArgs = {
  itemCategoryId: Scalars['ObjectId'];
  shopId: Scalars['ObjectId'];
};


export type MutationRemoveItemFromStorageUnitArgs = {
  itemId: Scalars['ObjectId'];
  note?: InputMaybe<Scalars['String']>;
  storageDate?: InputMaybe<Scalars['DateTime']>;
  storageUnits: ItemStorageUnitsArgs;
};


export type MutationRemoveKsvAssetArgs = {
  itemId: Scalars['ObjectId'];
};


export type MutationRemoveLastItemEventArgs = {
  isNeededToRemoveRelatedValorizationEntry: Scalars['Boolean'];
  itemId: Scalars['ObjectId'];
};


export type MutationRemoveSecondaryCustomerToDealArgs = {
  dealId: Scalars['ObjectId'];
  selectedCustomerId: Scalars['ObjectId'];
};


export type MutationRemoveStorageFacilityIdArgs = {
  shopId: Scalars['ObjectId'];
  storageFacilityId: Scalars['ObjectId'];
};


export type MutationRemoveValorizationEntryArgs = {
  valorizationHistoryId: Scalars['ObjectId'];
};


export type MutationReserveExtensionArgs = {
  args: ReserveExtensionArgs;
};


export type MutationReservePaybackArgs = {
  args: ReservePaybackArgs;
};


export type MutationResetCustomerPasswordMailArgs = {
  email: Scalars['String'];
};


export type MutationSaveReady2OrderProductMapsArgs = {
  args: SaveReady2OrderProductMapsArgs;
};


export type MutationSendReminderEmailForUploadingIdArgs = {
  customerId: Scalars['ObjectId'];
  type: ERemindUploadIdType;
};


export type MutationSetAllDealItemsToPurchasedDirectlyArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationSetAuctionItemsBuyersAndGenerateSurchargeCertificateArgs = {
  args: SetAuctionItemsBuyersAndGenerateSurchargeCertificateArgs;
};


export type MutationSetDealReceivedIdMissingArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationSetDealReviewingArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationSetElectronicsAppraisalCatalogVariantAnchorArgs = {
  anchorDate?: InputMaybe<Scalars['DateTime']>;
  anchorPrice: Scalars['Float'];
  note?: InputMaybe<Scalars['String']>;
  variantId: Scalars['ObjectId'];
};


export type MutationSetMainStorageFacilityIdArgs = {
  shopId: Scalars['ObjectId'];
  storageFacilityId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationSetOnSellArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationSetPayedAndStoredArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationSetSoldExternArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationStartAuctionArgs = {
  auctionId: Scalars['ObjectId'];
};


export type MutationUpdateAuctionArgs = {
  args: AuctionUpdateArgs;
  shouldNotifyCustomers: Scalars['Boolean'];
};


export type MutationUpdateAuctionItemArgs = {
  auctionItemArgs: AuctionItemArgs;
};


export type MutationUpdateCarInspectionArgs = {
  args: CarInspectionArgs;
};


export type MutationUpdateCashBookCountArgs = {
  cashBookCountUpdateArgs: CashBookCountUpdateArgs;
};


export type MutationUpdateCompanyArgs = {
  _id: Scalars['ObjectId'];
  accountOwner?: InputMaybe<Scalars['String']>;
  bic?: InputMaybe<Scalars['String']>;
  configuration?: InputMaybe<CompanyConfigurationArgs>;
  dpdConfiguration?: InputMaybe<DpdConfigurationArgs>;
  email?: InputMaybe<Scalars['String']>;
  fibuNumber: Scalars['String'];
  headquarter?: InputMaybe<IAddress>;
  iban?: InputMaybe<Scalars['String']>;
  jurisdiction?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  paypalEmail?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  primaryShopLocationId: Scalars['ObjectId'];
  saleSupportEmail?: InputMaybe<Scalars['String']>;
  salesConfiguration?: InputMaybe<CompanySalesConfigurationArgs>;
  successionCompanyId?: InputMaybe<Scalars['ObjectId']>;
  supportEmail?: InputMaybe<Scalars['String']>;
  uid: Scalars['String'];
  unzerConfiguration?: InputMaybe<CompanyUnzerConfigurationArgs>;
  website?: InputMaybe<Scalars['String']>;
  whatsappNumber?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCurrentEmployeePreferencesArgs = {
  preferences: EmployeePreferencesInput;
};


export type MutationUpdateCustomDealArgs = {
  customDealUpdateArgs: CustomDealUpdateArgs;
};


export type MutationUpdateCustomDealFormArgs = {
  customDealFormUpdateArgs: CustomDealFormUpdateArgs;
};


export type MutationUpdateCustomDealItemArgs = {
  customDealId: Scalars['ObjectId'];
  customDealItemUpdateArgs: CustomDealItemUpdateArgs;
};


export type MutationUpdateCustomDealNoteArgs = {
  customDealId: Scalars['ObjectId'];
  noteId: Scalars['ObjectId'];
  noteUpdateArgs: NoteUpdateArgs;
};


export type MutationUpdateCustomerArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  acquiredBy?: InputMaybe<Scalars['String']>;
  additionalInformationForCarPawn?: InputMaybe<AdditionalInformationForCarPawnArgs>;
  addresses?: InputMaybe<Array<ICustomerAddress>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  guestEmail?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  identityType?: InputMaybe<ECustomerIdentityType>;
  identityUploadLinks?: InputMaybe<Array<FileTusMetadataArgs>>;
  identityVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  identityVerifiedBy?: InputMaybe<Scalars['ObjectId']>;
  isNotePopup?: InputMaybe<Scalars['Boolean']>;
  isTestUser?: InputMaybe<Scalars['Boolean']>;
  lastname?: InputMaybe<Scalars['String']>;
  mergedCustomers?: InputMaybe<Array<InputMaybe<MergedCustomerArgs>>>;
  note?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  paypalAddress?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  registrationCertificate?: InputMaybe<FileTusMetadataArgs>;
  sex?: InputMaybe<ESex>;
  uploadedFiles?: InputMaybe<Array<FileTusMetadataArgs>>;
};


export type MutationUpdateCustomerBlacklistArgs = {
  args: CustomerBlacklistUpdateArgs;
};


export type MutationUpdateCustomerCategoryArgs = {
  customerCategoryArgs: CustomerCategoryArgs;
};


export type MutationUpdateCustomerPasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationUpdateDealAuctioningSettingsArgs = {
  args: UpdateDealAuctioningSettingsArgs;
};


export type MutationUpdateDealItemArgs = {
  args: DealItemUpdateArgs;
  dealId: Scalars['ObjectId'];
};


export type MutationUpdateDealItemAnswersArgs = {
  args: UpdateDealItemAnswersArgs;
  dealId: Scalars['ObjectId'];
};


export type MutationUpdateDealItemAnswersWithoutRecalculationArgs = {
  args: UpdateDealItemAnswersArgs;
  dealId: Scalars['ObjectId'];
};


export type MutationUpdateDealItemInternalSaleDataArgs = {
  args: InternalSaleDataArgs;
  dealId: Scalars['ObjectId'];
  itemId: Scalars['ObjectId'];
};


export type MutationUpdateDealNoteArgs = {
  dealId: Scalars['ObjectId'];
  noteId: Scalars['ObjectId'];
  noteUpdateArgs: NoteUpdateArgs;
};


export type MutationUpdateDealOnlineExtensionPreventionArgs = {
  dealId: Scalars['ObjectId'];
  isOnlineExtensionPrevented: Scalars['Boolean'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDealTransportArgs = {
  args: DealTransportUpdateArgs;
};


export type MutationUpdateDealUploadedFilesArgs = {
  dealId: Scalars['ObjectId'];
  uploadedFilesArgs: Array<FileTusMetadataArgs>;
};


export type MutationUpdateEmployeeArgs = {
  _id: Scalars['ObjectId'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  isNotePopup?: InputMaybe<Scalars['Boolean']>;
  lastname?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payoutConfigurations?: InputMaybe<PayoutConfigurationsInput>;
  phone?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<EmployeePreferencesInput>;
  roles?: InputMaybe<Array<ERoles>>;
  scheduledDeactivationAt?: InputMaybe<Scalars['DateTime']>;
  sex?: InputMaybe<ESex>;
  shopIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationUpdateEmployeePasswordArgs = {
  employeeId: Scalars['ObjectId'];
  password: Scalars['String'];
};


export type MutationUpdateEmployeeProfileArgs = {
  _id: Scalars['ObjectId'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<ESex>;
};


export type MutationUpdateFeeArgs = {
  feeUpdateArgs: FeeUpdateArgs;
};


export type MutationUpdateInsuredAmountArgs = {
  dealId: Scalars['ObjectId'];
  insuredAmount: Scalars['Float'];
};


export type MutationUpdateInternalSaleDataForDirectlyPurchasedItemsArgs = {
  dealId: Scalars['ObjectId'];
};


export type MutationUpdateItemArgs = {
  args: ItemUpdateArgs;
};


export type MutationUpdateItemCategorizedUploadedFilesArgs = {
  fileCategoryName: Scalars['String'];
  itemId: Scalars['ObjectId'];
  uploadedFilesArgs: Array<FileTusMetadataArgs>;
};


export type MutationUpdateItemCategoryArgs = {
  _id: Scalars['ObjectId'];
  algoliaCategorySlug?: InputMaybe<Scalars['String']>;
  categoryPageIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  expectedTurnOverTime?: InputMaybe<Scalars['Float']>;
  helpLink?: InputMaybe<Scalars['String']>;
  maximumPawnDuration?: InputMaybe<EMaximumPawnDuration>;
  minimumItemValue?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ObjectId']>;
  slug?: InputMaybe<Scalars['String']>;
  storageFeeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  visibleOnDomain?: InputMaybe<EVisibleOnDomain>;
};


export type MutationUpdateItemCategoryIdArgs = {
  dealId: Scalars['ObjectId'];
  itemCategoryId: Scalars['ObjectId'];
  itemId: Scalars['ObjectId'];
};


export type MutationUpdateItemCategoryIdealoIdMapsArgs = {
  args: Array<ItemCategoryIdealoIdMapArgs>;
};


export type MutationUpdateItemEventArgs = {
  itemEventUpdateArgs: ItemEventUpdateArgs;
  itemId: Scalars['ObjectId'];
};


export type MutationUpdateItemManualTestArgs = {
  args: ItemManualTestArgs;
  itemId: Scalars['ObjectId'];
};


export type MutationUpdateItemMediaArgs = {
  itemId: Scalars['ObjectId'];
  mediaArgs: Array<FileTusMetadataArgs>;
};


export type MutationUpdateItemNoteArgs = {
  itemId: Scalars['ObjectId'];
  noteId: Scalars['ObjectId'];
  noteUpdateArgs: NoteUpdateArgs;
};


export type MutationUpdateItemQuestionArgs = {
  _id: Scalars['ObjectId'];
  _oldItemQuestionIds?: InputMaybe<Array<Scalars['String']>>;
  infoKey?: InputMaybe<Scalars['String']>;
  isDeactivatedForNewProducts?: InputMaybe<Scalars['Boolean']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  order?: InputMaybe<Scalars['Float']>;
  predictionTag?: InputMaybe<EQuestionPredictionTag>;
  questionType?: InputMaybe<EQuestionType>;
  rangeData?: InputMaybe<ItemQuestionRangeDataArgs>;
  singleChoiceOptions?: InputMaybe<Array<ItemQuestionOptionArgs>>;
  titleKey?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['DateTime']>;
  validTo?: InputMaybe<Scalars['DateTime']>;
  valueMode?: InputMaybe<EQuestionValueMode>;
};


export type MutationUpdateItemUploadedFilesArgs = {
  itemId: Scalars['ObjectId'];
  uploadedFilesArgs: Array<FileTusMetadataArgs>;
};


export type MutationUpdateMaintenanceWindowArgs = {
  duration?: InputMaybe<Scalars['Float']>;
  id: Scalars['ObjectId'];
  isFinished?: InputMaybe<Scalars['Boolean']>;
  scheduledStartTime?: InputMaybe<Scalars['DateTime']>;
};


export type MutationUpdateMaterialPriceArgs = {
  _id: Scalars['ObjectId'];
  date?: InputMaybe<Scalars['DateTime']>;
  material?: InputMaybe<Scalars['String']>;
  mu?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  sigma?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdatePartialRedemptionArgs = {
  args: PartialRedemptionArgs;
};


export type MutationUpdatePartnerArgs = {
  _id: Scalars['ObjectId'];
  name?: InputMaybe<Scalars['String']>;
  partnershipTypes?: InputMaybe<PartnershipTypeArgs>;
};


export type MutationUpdatePaybackDataArgs = {
  args: PaymentDataArgs;
  dealId: Scalars['ObjectId'];
};


export type MutationUpdatePayoutDataArgs = {
  args: PaymentDataArgs;
  dealId: Scalars['ObjectId'];
};


export type MutationUpdatePiceaUploadLinkArgs = {
  itemId: Scalars['ObjectId'];
  piceaUploadLinkArgs?: InputMaybe<FileTusMetadataArgs>;
};


export type MutationUpdatePreviewCalculationArgs = {
  dealFinalValuesArgs: DealFinalValuesArgs;
  dealId: Scalars['ObjectId'];
};


export type MutationUpdatePrivateSaleTransactionArgs = {
  args: PrivateSaleTransactionArgs;
  privateSaleId: Scalars['ObjectId'];
  transactionOrder: Scalars['Float'];
};


export type MutationUpdateProductArgs = {
  args: ProductUpdateArgs;
};


export type MutationUpdateProductLegacyArgs = {
  _id: Scalars['ObjectId'];
  class?: InputMaybe<Scalars['String']>;
  conditionMaxValues?: InputMaybe<ConditionMaxMarketValuesArgs>;
  contentCategories?: InputMaybe<ContentCategoriesArgs>;
  ean?: InputMaybe<Scalars['String']>;
  gewicht?: InputMaybe<Scalars['Float']>;
  isInactive?: InputMaybe<Scalars['Boolean']>;
  isTaxFree?: InputMaybe<Scalars['Boolean']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  karat?: InputMaybe<Scalars['Float']>;
  material?: InputMaybe<Scalars['String']>;
  maxLoanToValue?: InputMaybe<Scalars['Float']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  objectID?: InputMaybe<Scalars['String']>;
  pictureFilename?: InputMaybe<Scalars['String']>;
  releaseDate?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProductPriceArgs = {
  args: ProductUpdatePriceArgs;
};


export type MutationUpdateProductPropertyDefinitionArgs = {
  args: ProductPropertyDefinitionUpdateArgs;
};


export type MutationUpdateProductPublicationArgs = {
  isPublished: Scalars['Boolean'];
  productId: Scalars['ObjectId'];
};


export type MutationUpdateResponseTemplateArgs = {
  responseTemplate: ResponseTemplateUpdateArgs;
};


export type MutationUpdateSavedValorizationHistoryEntryArgs = {
  args: ValorizationEntryUpdateArgs;
  shopId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationUpdateSecondaryPayoutDataArgs = {
  args?: InputMaybe<SecondaryPaymentDataArgs>;
  dealId: Scalars['ObjectId'];
};


export type MutationUpdateShopArgs = {
  _id: Scalars['ObjectId'];
  address?: InputMaybe<IAddress>;
  cashBoxNames?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['ObjectId']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  googleMapsLink?: InputMaybe<Scalars['String']>;
  hideLocationOnWebsite?: InputMaybe<Scalars['Boolean']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  name?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ObjectId']>;
  phone?: InputMaybe<Scalars['String']>;
  r2oProductMaps?: InputMaybe<Array<R2OProductMapArgs>>;
  ready2OrderApiKey?: InputMaybe<Scalars['String']>;
  successionShopId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationUpdateShopIdArgs = {
  dealId: Scalars['ObjectId'];
  initialShopId: Scalars['ObjectId'];
};


export type MutationUpdateStorageFacilityArgs = {
  _id: Scalars['ObjectId'];
  address?: InputMaybe<IAddress>;
  external?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateStorageLabelForCashBookCashFlowArgs = {
  cashBookCashFlowId: Scalars['ObjectId'];
  storageLabel: Scalars['String'];
};


export type MutationUpdateStorageUnitArgs = {
  _id: Scalars['ObjectId'];
  capacity?: InputMaybe<Scalars['Float']>;
  childIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  isSecureLocation?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ObjectId']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationValidatePaybackOrExtendDealPersistanceCalculationArgs = {
  args: ValidatePaybackOrExtendDealPersistanceCalculationArgs;
};


export type MutationVerifyActivationEmployeeTokenArgs = {
  token: Scalars['String'];
};


export type MutationVerifyDealArgs = {
  verifyDealArgs: VerifyDealArgs;
};

export type Note = {
  __typename?: 'Note';
  _id: Scalars['ObjectId'];
  bookingNumber?: Maybe<Scalars['Float']>;
  content: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['ObjectId']>;
  dealId?: Maybe<Scalars['ObjectId']>;
  employee?: Maybe<Employee>;
  isPopup?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NoteCreateArgs = {
  content: Scalars['String'];
  isPopup?: InputMaybe<Scalars['Boolean']>;
};

export type NoteUpdateArgs = {
  content?: InputMaybe<Scalars['String']>;
  isPopup?: InputMaybe<Scalars['Boolean']>;
};

export type NumberDefaultCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'NumberDefaultCustomDealFormQuestion';
  _id: Scalars['ObjectId'];
  info: TranslatedString;
  initialNumberAnswer?: Maybe<Scalars['Float']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type NumberFilter = {
  betweenValues?: InputMaybe<NumberFilterBetween>;
  condition?: InputMaybe<ENumberFilterConditions>;
  value?: InputMaybe<Scalars['Float']>;
};

export type NumberFilterBetween = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type NumberOptionsCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'NumberOptionsCustomDealFormQuestion';
  _id: Scalars['ObjectId'];
  allowEnterAnswer: Scalars['Boolean'];
  info: TranslatedString;
  initialOptionNumberAnswer?: Maybe<Scalars['Float']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']>;
  options: Array<CustomDealFormOption>;
  restrictions: Array<CustomDealQuestionNumberRestriction>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};


export type NumberOptionsCustomDealFormQuestionRestrictionsArgs = {
  categoryId?: InputMaybe<Scalars['ObjectId']>;
};

export type OAddress = {
  __typename?: 'OAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  coordinates?: Maybe<OCoordinates>;
  /** @deprecated Use `countryCode`. */
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<ECountry>;
  door?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  stairway?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type OCoordinates = {
  __typename?: 'OCoordinates';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type OCustomerAddress = {
  __typename?: 'OCustomerAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  coordinates?: Maybe<OCoordinates>;
  /** @deprecated Use `countryCode`. */
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<ECountry>;
  door?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  isBillingAddress?: Maybe<Scalars['Boolean']>;
  isDeliveryAddress?: Maybe<Scalars['Boolean']>;
  isRegistrationAddress?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  stairway?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ODealPartnerData = {
  __typename?: 'ODealPartnerData';
  knp?: Maybe<ODealPartnerDataKnp>;
  type: EDealPartnerType;
};

export type ODealPartnerDataKnp = {
  __typename?: 'ODealPartnerDataKnp';
  debtAmount: Scalars['Float'];
  fileReferenceNumber: Scalars['String'];
};

export type OLogisticsPartnerData = {
  __typename?: 'OLogisticsPartnerData';
  cashy?: Maybe<OLogisticsPartnerDataCashy>;
  logsta?: Maybe<OLogisticsPartnerDataLogsta>;
  trackingLink?: Maybe<Scalars['String']>;
  type: ELogisticsPartnerType;
};

export type OLogisticsPartnerDataCashy = {
  __typename?: 'OLogisticsPartnerDataCashy';
  _placeHolder?: Maybe<Scalars['Boolean']>;
};

export type OLogisticsPartnerDataLogsta = {
  __typename?: 'OLogisticsPartnerDataLogsta';
  logstaNumber?: Maybe<Scalars['String']>;
};

export type OOpeningHoursEntry = {
  __typename?: 'OOpeningHoursEntry';
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type OPayoutConfiguration = {
  __typename?: 'OPayoutConfiguration';
  carPayoutLimit?: Maybe<Scalars['Float']>;
  noLimit?: Maybe<Scalars['Boolean']>;
  payoutLimit?: Maybe<Scalars['Float']>;
};

export type OSalesPartnerData = {
  __typename?: 'OSalesPartnerData';
  baggyluxe?: Maybe<OSalesPartnerDataBaggyluxe>;
  blitzmobile?: Maybe<OSalesPartnerDataBlitzMobile>;
  cashy?: Maybe<OSalesPartnerDataCashy>;
  chrono24?: Maybe<OSalesPartnerDataChrono24>;
  ebay?: Maybe<OSalesPartnerDataEbay>;
  ebaykleinanzeigen?: Maybe<OSalesPartnerDataEbayKleinanzeigen>;
  others?: Maybe<OSalesPartnerDataOthers>;
  rebelle?: Maybe<OSalesPartnerDataRebelle>;
  refurbed?: Maybe<OSalesPartnerDataRefurbed>;
  type: ESalesPartnerType;
  vestiairecollective?: Maybe<OSalesPartnerDataVestiaireCollective>;
  willhaben?: Maybe<OSalesPartnerDataWillhaben>;
};

export type OSalesPartnerDataBaggyluxe = {
  __typename?: 'OSalesPartnerDataBaggyluxe';
  saleId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type OSalesPartnerDataBlitzMobile = {
  __typename?: 'OSalesPartnerDataBlitzMobile';
  saleId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type OSalesPartnerDataCashy = {
  __typename?: 'OSalesPartnerDataCashy';
  _placeHolder?: Maybe<Scalars['Boolean']>;
};

export type OSalesPartnerDataChrono24 = {
  __typename?: 'OSalesPartnerDataChrono24';
  saleId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type OSalesPartnerDataEbay = {
  __typename?: 'OSalesPartnerDataEbay';
  articleDescription?: Maybe<Scalars['String']>;
  ebayArticleNumber?: Maybe<Scalars['String']>;
  numberOfItems?: Maybe<Scalars['Float']>;
  paidDate?: Maybe<Scalars['DateTime']>;
  purchaseProcessingDate?: Maybe<Scalars['String']>;
  saleProtocolNumber?: Maybe<Scalars['Float']>;
  shippingCosts?: Maybe<Scalars['Float']>;
  shippingDate?: Maybe<Scalars['DateTime']>;
  shippingService?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type OSalesPartnerDataEbayKleinanzeigen = {
  __typename?: 'OSalesPartnerDataEbayKleinanzeigen';
  kleinanzeigenArticleNumber?: Maybe<Scalars['String']>;
  shippingDate?: Maybe<Scalars['DateTime']>;
};

export type OSalesPartnerDataOthers = {
  __typename?: 'OSalesPartnerDataOthers';
  saleId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type OSalesPartnerDataRebelle = {
  __typename?: 'OSalesPartnerDataRebelle';
  saleId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type OSalesPartnerDataRefurbed = {
  __typename?: 'OSalesPartnerDataRefurbed';
  ID: Scalars['Float'];
  quantity: Scalars['Float'];
  settlementBaseCommission?: Maybe<Scalars['Float']>;
  settlementDynamicCommission?: Maybe<Scalars['Float']>;
  settlementPaymentCommission?: Maybe<Scalars['Float']>;
  settlementPayoutCommission?: Maybe<Scalars['Float']>;
  settlementTotalCommission?: Maybe<Scalars['Float']>;
  settlementTotalRefunded?: Maybe<Scalars['Float']>;
  shippingCosts: Scalars['Float'];
  warranty: Scalars['String'];
};

export type OSalesPartnerDataVestiaireCollective = {
  __typename?: 'OSalesPartnerDataVestiaireCollective';
  refId?: Maybe<Scalars['String']>;
};

export type OSalesPartnerDataWillhaben = {
  __typename?: 'OSalesPartnerDataWillhaben';
  articleDescription?: Maybe<Scalars['String']>;
  numberOfItems?: Maybe<Scalars['Float']>;
  paidDate?: Maybe<Scalars['DateTime']>;
  purchaseProcessingDate?: Maybe<Scalars['String']>;
  saleProtocolNumber?: Maybe<Scalars['Float']>;
  shippingCosts?: Maybe<Scalars['Float']>;
  shippingDate?: Maybe<Scalars['DateTime']>;
  shippingService?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  willhabenArticleNumber?: Maybe<Scalars['String']>;
};

export type OnlinePaymentArgs = {
  calculationId: Scalars['ObjectId'];
  dealId: Scalars['ObjectId'];
  dropoffDataArgs: TransportDataArgs;
  language: ELanguageCode;
  unzerPaymentArgs?: InputMaybe<UnzerPaymentArgs>;
};

export type OnlinePaymentResult = {
  __typename?: 'OnlinePaymentResult';
  deal: Deal;
  paymentResult: PaymentResult;
};

export type OtherCarProperty = {
  __typename?: 'OtherCarProperty';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type OtherVehiclePropertiesArgs = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  total: Scalars['Float'];
};

export type PageInfoSkipLimit = {
  __typename?: 'PageInfoSkipLimit';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  skip?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
};

export type PaginatedAuctions = {
  __typename?: 'PaginatedAuctions';
  nodes: Array<Auction>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedCustomDeals = {
  __typename?: 'PaginatedCustomDeals';
  nodes: Array<CustomDeal>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedDeals = {
  __typename?: 'PaginatedDeals';
  nodes: Array<Deal>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedItems = {
  __typename?: 'PaginatedItems';
  nodes: Array<Item>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedPrivateSales = {
  __typename?: 'PaginatedPrivateSales';
  nodes: Array<PrivateSale>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedProductExport = {
  __typename?: 'PaginatedProductExport';
  edges: Array<ProductExportEdge>;
  pageInfo: PageInfo;
};

export type PaginatedProducts = {
  __typename?: 'PaginatedProducts';
  nodes: Array<Product>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedSkipLimitCustomerBlacklist = {
  __typename?: 'PaginatedSkipLimitCustomerBlacklist';
  nodes: Array<CustomerBlacklist>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedSkipLimitCustomers = {
  __typename?: 'PaginatedSkipLimitCustomers';
  nodes: Array<Customer>;
  pageInfo: PageInfoSkipLimit;
};

export type PartialRedemptionArgs = {
  dealId: Scalars['ObjectId'];
  itemId: Scalars['ObjectId'];
  minPartialRedemptionAmount?: InputMaybe<Scalars['Float']>;
  partialRedemptionIntervalsCount?: InputMaybe<Scalars['Float']>;
};

export type Partner = {
  __typename?: 'Partner';
  _id: Scalars['ObjectId'];
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  isDeactivated?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  partnershipTypes?: Maybe<PartnershipType>;
};

export type PartnerCreateArgs = {
  name: Scalars['String'];
  partnershipTypes?: InputMaybe<PartnershipTypeArgs>;
};

export type PartnerFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  isDeactivated?: InputMaybe<BooleanFilter>;
  isInternalSalesPartner?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PartnerOpts = {
  filter?: InputMaybe<PartnerFilterArgs>;
  order?: InputMaybe<PartnerOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PartnerOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type PartnershipType = {
  __typename?: 'PartnershipType';
  isInternalSalesPartner?: Maybe<Scalars['Boolean']>;
};

export type PartnershipTypeArgs = {
  isInternalSalesPartner?: InputMaybe<Scalars['Boolean']>;
};

export type PawnData = {
  __typename?: 'PawnData';
  billLink?: Maybe<FileMetadata>;
  billNumber?: Maybe<Scalars['String']>;
  buyBackChildId?: Maybe<Scalars['ObjectId']>;
  buyBackData?: Maybe<BuyBackData>;
  buyBackParentId?: Maybe<Scalars['ObjectId']>;
  extensionChildId?: Maybe<Scalars['ObjectId']>;
  extensionParentId?: Maybe<Scalars['ObjectId']>;
  finalMaxPawnDate?: Maybe<Scalars['DateTime']>;
  pawnNumber?: Maybe<Scalars['Float']>;
  pawnTicketLink?: Maybe<FileMetadata>;
  paybackData?: Maybe<PaymentData>;
  powerOfAttorneyDocuments?: Maybe<Array<PawnDocument>>;
  reservedPaybackData?: Maybe<ReservedPaybackData>;
  surplusCashBookCashFlowIds?: Maybe<Array<Scalars['ObjectId']>>;
  userAgreementDocuments?: Maybe<Array<PawnDocument>>;
};

export type PawnDocument = {
  __typename?: 'PawnDocument';
  customerId: Scalars['ObjectId'];
  fileMetadata: FileMetadata;
};

export type PaymentData = {
  __typename?: 'PaymentData';
  iban?: Maybe<Scalars['String']>;
  paymentType: AnyPaymentType;
  paypalAddress?: Maybe<Scalars['String']>;
  paypalTransactionId?: Maybe<Scalars['String']>;
};

export type PaymentDataArgs = {
  iban?: InputMaybe<Scalars['String']>;
  paymentType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']>;
  paypalTransactionId?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['ObjectId']>;
};

/** SuccessfulPayment | PendingPayment | FailedPayment */
export type PaymentResult = FailedPayment | PendingPayment | SuccessfulPayment;

export type PayoutConfigurationsInput = {
  carPayoutLimit?: InputMaybe<Scalars['Float']>;
  noLimit?: InputMaybe<Scalars['Boolean']>;
  payoutLimit?: InputMaybe<Scalars['Float']>;
};

export type PendingPayment = {
  __typename?: 'PendingPayment';
  id: Scalars['String'];
  redirectUrl: Scalars['String'];
};

export type PersistedDealCalculation = IDealCalculation & {
  __typename?: 'PersistedDealCalculation';
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  date: Scalars['DateTime'];
  dealCalculationId: Scalars['ObjectId'];
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  loanToValuesEntryId: Scalars['ObjectId'];
};

export type PersistedDealExtensionCalculation = {
  __typename?: 'PersistedDealExtensionCalculation';
  childDealCalculation: DealCalculation;
  dealExtensionCalculationId: Scalars['ObjectId'];
  dealId: Scalars['ObjectId'];
  dueAmount: Scalars['Float'];
  itemsExtensionAnswers: Array<ItemExtensionAnswers>;
  overwrittenPartialRedemptionAmount?: Maybe<Scalars['Float']>;
  parentDealCalculation: DealCalculation;
  partialRedemptionAmount: Scalars['Float'];
};

export type PersistedDealPaybackCalculation = {
  __typename?: 'PersistedDealPaybackCalculation';
  dealCalculation: DealCalculation;
  dealId: Scalars['ObjectId'];
  dealPaybackCalculationId: Scalars['ObjectId'];
};

export type PiceaTest = {
  __typename?: 'PiceaTest';
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Array<PiceaTestData>>;
  disable?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['Boolean']>;
};

export type PiceaTestData = {
  __typename?: 'PiceaTestData';
  label: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type PremiumShippingData = {
  __typename?: 'PremiumShippingData';
  address: OAddress;
  date: Scalars['DateTime'];
  fromHourUTC: Scalars['Float'];
  toHourUTC: Scalars['Float'];
};

export type PremiumShippingDataArgs = {
  address: IAddress;
  date: Scalars['DateTime'];
  fromHourUTC: Scalars['Int'];
  toHourUTC: Scalars['Int'];
};

export type PriceFinding = {
  __typename?: 'PriceFinding';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Employee>;
  creatorId?: Maybe<Scalars['ObjectId']>;
  platform?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
};

export type PriceFindingArgs = {
  price?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PrimaryShopLocationArgs = {
  address: IAddress;
  cashBoxNames?: InputMaybe<Array<Scalars['String']>>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  googleMapsLink: Scalars['String'];
  hideLocationOnWebsite?: InputMaybe<Scalars['Boolean']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  name: Scalars['String'];
  openingHours: Scalars['String'];
  partnerId?: InputMaybe<Scalars['ObjectId']>;
  phone: Scalars['String'];
  successionShopId?: InputMaybe<Scalars['ObjectId']>;
};

export type PrivateSale = {
  __typename?: 'PrivateSale';
  _id: Scalars['ObjectId'];
  bookingNumber: Scalars['Float'];
  carTitle?: Maybe<Scalars['String']>;
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  creationType: EPrivateSaleCreationType;
  customerFullName?: Maybe<Scalars['String']>;
  dealFinalBalance?: Maybe<Scalars['Float']>;
  dealId: Scalars['ObjectId'];
  itemId: Scalars['ObjectId'];
  privateSaleDate: Scalars['DateTime'];
  privateSaleTransactions?: Maybe<Array<PrivateSaleTransaction>>;
  status?: Maybe<EDealStatusType>;
};

export type PrivateSaleCreateArgs = {
  creationType: EPrivateSaleCreationType;
  dealId: Scalars['ObjectId'];
  itemId: Scalars['ObjectId'];
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  privateSaleDate: Scalars['DateTime'];
  transactionArgs?: InputMaybe<Array<PrivateSaleTransactionArgs>>;
};

export type PrivateSaleTransaction = {
  __typename?: 'PrivateSaleTransaction';
  amount: Scalars['Float'];
  balance?: Maybe<Scalars['Float']>;
  buyerName?: Maybe<Scalars['String']>;
  cashFlowId?: Maybe<Scalars['ObjectId']>;
  costName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['ObjectId']>;
  employeeName?: Maybe<Scalars['String']>;
  grossAmount?: Maybe<Scalars['Float']>;
  order: Scalars['Float'];
  paymentType: AnyPaymentType;
  shopId?: Maybe<Scalars['ObjectId']>;
  sortingOrder: Scalars['Float'];
  transactionFileLink?: Maybe<FileMetadata>;
  transactionType: ETransactionType;
  ust?: Maybe<Scalars['Float']>;
};

export type PrivateSaleTransactionArgs = {
  amount: Scalars['Float'];
  buyerName?: InputMaybe<Scalars['String']>;
  costName?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  grossAmount?: InputMaybe<Scalars['Float']>;
  order: Scalars['Float'];
  paymentType?: InputMaybe<EManualPaymentType>;
  regenerateBill?: InputMaybe<Scalars['Boolean']>;
  shopId?: InputMaybe<Scalars['ObjectId']>;
  transactionFileLink?: InputMaybe<FileTusMetadataArgs>;
  transactionType: ETransactionType;
  ust?: InputMaybe<Scalars['Float']>;
};

export type PrivateSalesFiltersArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['ObjectId'];
  availableProperties?: Maybe<Array<AvailablePropertyValues>>;
  category: ItemCategory;
  categoryId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  image?: Maybe<ProductImage>;
  imageId?: Maybe<Scalars['String']>;
  imageMode: EProductImageMode;
  isCrawled: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  itemQuestions: Array<ItemQuestion>;
  keywords?: Maybe<Array<Scalars['String']>>;
  manufacturer: Scalars['String'];
  name: Scalars['String'];
  overviewImage?: Maybe<ProductImage>;
  overviewImageId?: Maybe<Scalars['String']>;
  price?: Maybe<ProductPriceUnion>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variants: Array<ProductVariant>;
};


export type ProductImageArgs = {
  size?: InputMaybe<Scalars['String']>;
};


export type ProductItemQuestionsArgs = {
  date: Scalars['DateTime'];
  omitDeactivatedQuestionsForNewProducts: Scalars['Boolean'];
  omitInternalQuestions?: InputMaybe<Scalars['Boolean']>;
};


export type ProductOverviewImageArgs = {
  size?: InputMaybe<Scalars['String']>;
};


export type ProductVariantsArgs = {
  args?: InputMaybe<GetProductVariantsArgs>;
};

export type ProductAvailableBooleanProperty = ProductAvailableProperty & {
  __typename?: 'ProductAvailableBooleanProperty';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyDefinitionType: EProductPropertyType;
};

export type ProductAvailableNumberProperty = ProductAvailableProperty & {
  __typename?: 'ProductAvailableNumberProperty';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyDefinitionType: EProductPropertyType;
  values: Array<AvailablePropertyNumberOption>;
};

export type ProductAvailableProperty = {
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyDefinitionType: EProductPropertyType;
};

export type ProductAvailablePropertyArgs = {
  propertyDefinitionId: Scalars['ObjectId'];
  sortPriority: Scalars['Float'];
  values?: InputMaybe<ProductAvailablePropertyValuesArgs>;
};

export type ProductAvailablePropertyValuesArgs = {
  numberOptions?: InputMaybe<Array<Scalars['Float']>>;
  textOptions?: InputMaybe<Array<AvailablePropertyTextOptionArgs>>;
};

export type ProductAvailableTextProperty = ProductAvailableProperty & {
  __typename?: 'ProductAvailableTextProperty';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyDefinitionType: EProductPropertyType;
  values: Array<AvailablePropertyTextOption>;
};

export type ProductCreateArgs = {
  availableProperties: Array<ProductAvailablePropertyArgs>;
  categoryId: Scalars['ObjectId'];
  ephemeralImageId?: InputMaybe<Scalars['String']>;
  ephemeralOverviewImageId?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['String']>;
  imageMode: EProductImageMode;
  isPublished: Scalars['Boolean'];
  keywords?: InputMaybe<Array<Scalars['String']>>;
  manufacturer: Scalars['String'];
  name: Scalars['String'];
  overviewImageId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ProductPriceArgs>;
  variants: Array<ProductVariantArgs>;
};

export type ProductExport = {
  __typename?: 'ProductExport';
  _id: Scalars['ObjectId'];
  collectionName?: Maybe<Scalars['String']>;
  crawledPrice?: Maybe<Scalars['Float']>;
  crawledTimestamp?: Maybe<Scalars['Float']>;
  currentMarketValue?: Maybe<Scalars['Float']>;
  ean?: Maybe<Scalars['String']>;
  gewicht?: Maybe<Scalars['Float']>;
  isInactive: Scalars['Boolean'];
  isTaxFree?: Maybe<Scalars['Boolean']>;
  karat?: Maybe<Scalars['Float']>;
  lastPrice_id?: Maybe<Scalars['ObjectId']>;
  lowestMarketValue?: Maybe<Scalars['Float']>;
  lvl0Category?: Maybe<Scalars['String']>;
  lvl0ContentCategory?: Maybe<Scalars['String']>;
  lvl1Category?: Maybe<Scalars['String']>;
  lvl1ContentCategory?: Maybe<Scalars['String']>;
  lvl2Category?: Maybe<Scalars['String']>;
  lvl2ContentCategory?: Maybe<Scalars['String']>;
  lvl3ContentCategory?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['Float']>;
  objectID: Scalars['String'];
  pictureFilename?: Maybe<Scalars['String']>;
  predictionFactor?: Maybe<Scalars['Float']>;
  previouslyOverwrittenPrice?: Maybe<Scalars['Float']>;
  previouslyOverwrittenTimestamp?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  productTags: Scalars['String'];
  releaseDate: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type ProductExportEdge = {
  __typename?: 'ProductExportEdge';
  cursor: Scalars['String'];
  node: ProductExport;
};

export type ProductExportOpts = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  shouldCreateSlug?: InputMaybe<Scalars['Boolean']>;
};

export type ProductFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  categoryIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  excludeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type ProductLegacy = {
  __typename?: 'ProductLegacy';
  _id: Scalars['ObjectId'];
  class?: Maybe<Scalars['String']>;
  conditionMaxValues?: Maybe<ConditionMaxMarketValues>;
  contentCategories?: Maybe<ContentCategories>;
  ean?: Maybe<Scalars['String']>;
  gewicht?: Maybe<Scalars['Float']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  isTaxFree?: Maybe<Scalars['Boolean']>;
  itemCategory?: Maybe<ItemCategory>;
  itemCategoryId: Scalars['ObjectId'];
  karat?: Maybe<Scalars['Float']>;
  material?: Maybe<Scalars['String']>;
  maxLoanToValue?: Maybe<Scalars['Float']>;
  maxValue?: Maybe<Scalars['Float']>;
  objectID: Scalars['String'];
  picture?: Maybe<UploadFile>;
  pictureFilename?: Maybe<Scalars['String']>;
  productTags?: Maybe<Array<Scalars['String']>>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type ProductLegacyFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  contentCategories?: InputMaybe<ContentCategoriesArgs>;
  excludeInactiveProducts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  objectID?: InputMaybe<Scalars['String']>;
  objectIDs?: InputMaybe<Array<Scalars['String']>>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProductLegacyOpts = {
  filter?: InputMaybe<ProductLegacyFilterArgs>;
  order?: InputMaybe<ProductLegacyOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ProductLegacyOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  maxLoanToValue?: InputMaybe<EOrderBy>;
  title?: InputMaybe<EOrderBy>;
};

export type ProductOpts = {
  filter?: InputMaybe<ProductFilterArgs>;
  order?: InputMaybe<ProductOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ProductOrderArgs = {
  name?: InputMaybe<EOrderBy>;
};

export type ProductPrice = {
  mode: EProductPriceMode;
};

export type ProductPriceAdjustment = {
  __typename?: 'ProductPriceAdjustment';
  type: EProductPriceAdjustmentType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['ObjectId']>;
  value: Scalars['Float'];
};

export type ProductPriceAdjustmentArgs = {
  type: EProductPriceAdjustmentType;
  value: Scalars['Float'];
};

export type ProductPriceArgs = {
  basePrice?: InputMaybe<Scalars['Float']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']>;
  material?: InputMaybe<EProductMaterial>;
  mode: EProductPriceMode;
  properties?: InputMaybe<Array<ProductVariantPricePropertyArgs>>;
  variants?: InputMaybe<Array<ProductVariantPriceArgs>>;
};

export type ProductPriceCrawledMode = ProductPrice & {
  __typename?: 'ProductPriceCrawledMode';
  mode: EProductPriceMode;
  variants: Array<ProductVariantPrice>;
};

export type ProductPriceManualPreciousMetalMode = ProductPrice & {
  __typename?: 'ProductPriceManualPreciousMetalMode';
  isInvestmentGold: Scalars['Boolean'];
  material: EProductMaterial;
  mode: EProductPriceMode;
  variants: Array<ProductVariantPrice>;
};

export type ProductPriceManualPropertyMode = ProductPrice & {
  __typename?: 'ProductPriceManualPropertyMode';
  basePrice: Scalars['Float'];
  mode: EProductPriceMode;
  properties: Array<ProductVariantPriceProperty>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants: Array<ProductVariantPrice>;
};

export type ProductPriceManualVariantMode = ProductPrice & {
  __typename?: 'ProductPriceManualVariantMode';
  mode: EProductPriceMode;
  variants: Array<ProductVariantPrice>;
};

export type ProductPriceUnion = ProductPriceCrawledMode | ProductPriceManualPreciousMetalMode | ProductPriceManualPropertyMode | ProductPriceManualVariantMode;

export type ProductPropertyDefinition = {
  __typename?: 'ProductPropertyDefinition';
  _id: Scalars['ObjectId'];
  categories: Array<ItemCategory>;
  categoryIds: Array<Scalars['ObjectId']>;
  description?: Maybe<TranslatedString>;
  idealoName?: Maybe<Scalars['String']>;
  impactsLook: Scalars['Boolean'];
  info?: Maybe<TranslatedString>;
  isInUse: Scalars['Boolean'];
  key: Scalars['String'];
  name: TranslatedString;
  showOnWebsite: Scalars['Boolean'];
  sortPriority: Scalars['Float'];
  type: EProductPropertyType;
  valueFormatting?: Maybe<PropertyDefinitionValueFormatting>;
};

export type ProductPropertyDefinitionCreateArgs = {
  categoryIds: Array<Scalars['ObjectId']>;
  description?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  idealoName?: InputMaybe<Scalars['String']>;
  impactsLook: Scalars['Boolean'];
  info?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  key: Scalars['String'];
  name: Array<MultipleLanguageTextArgs>;
  showOnWebsite: Scalars['Boolean'];
  sortPriority: Scalars['Float'];
  type: EProductPropertyType;
  valueFormatting?: InputMaybe<PropertyDefinitionValueFormattingArgs>;
};

export type ProductPropertyDefinitionFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  categoryId?: InputMaybe<Scalars['ObjectId']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  text?: InputMaybe<Scalars['String']>;
};

export type ProductPropertyDefinitionOpts = {
  filter?: InputMaybe<ProductPropertyDefinitionFilterArgs>;
  order?: InputMaybe<ProductPropertyDefinitionOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ProductPropertyDefinitionOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  createdAt?: InputMaybe<EOrderBy>;
};

export type ProductPropertyDefinitionUpdateArgs = {
  _id: Scalars['ObjectId'];
  categoryIds: Array<Scalars['ObjectId']>;
  description?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  idealoName?: InputMaybe<Scalars['String']>;
  impactsLook: Scalars['Boolean'];
  info?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  key: Scalars['String'];
  name: Array<MultipleLanguageTextArgs>;
  showOnWebsite: Scalars['Boolean'];
  sortPriority: Scalars['Float'];
  type: EProductPropertyType;
  valueFormatting?: InputMaybe<PropertyDefinitionValueFormattingArgs>;
};

export type ProductUpdateArgs = {
  _id: Scalars['ObjectId'];
  availableProperties: Array<ProductAvailablePropertyArgs>;
  categoryId: Scalars['ObjectId'];
  ephemeralImageId?: InputMaybe<Scalars['String']>;
  ephemeralOverviewImageId?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['String']>;
  imageMode: EProductImageMode;
  isPublished: Scalars['Boolean'];
  keywords?: InputMaybe<Array<Scalars['String']>>;
  manufacturer: Scalars['String'];
  name: Scalars['String'];
  overviewImageId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ProductPriceArgs>;
  variants: Array<ProductVariantArgs>;
};

export type ProductUpdatePriceArgs = {
  _id: Scalars['ObjectId'];
  price: ProductPriceArgs;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  enabled: Scalars['Boolean'];
  id: Scalars['ObjectId'];
  image?: Maybe<ProductImage>;
  imageId?: Maybe<Scalars['String']>;
  isPriceValid: Scalars['Boolean'];
  name: Scalars['String'];
  product: Product;
  propertiesValues: Array<ProductVariantValue>;
  releasedAt: Scalars['DateTime'];
  unconfirmedPropertyIds: Array<Scalars['ObjectId']>;
};


export type ProductVariantImageArgs = {
  size?: InputMaybe<Scalars['String']>;
};

export type ProductVariantArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  ephemeralImageId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ObjectId']>;
  imageId?: InputMaybe<Scalars['String']>;
  propertiesValues: Array<ProductVariantValueArgs>;
  releasedAt: Scalars['DateTime'];
};

export type ProductVariantPrice = {
  __typename?: 'ProductVariantPrice';
  adjustment?: Maybe<ProductPriceAdjustment>;
  createdAt?: Maybe<Scalars['DateTime']>;
  materialMetric?: Maybe<MaterialMetric>;
  price?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variantId: Scalars['ObjectId'];
};

export type ProductVariantPriceArgs = {
  adjustment?: InputMaybe<ProductPriceAdjustmentArgs>;
  materialMetric?: InputMaybe<MaterialMetricArgs>;
  price?: InputMaybe<Scalars['Float']>;
  variantId: Scalars['ObjectId'];
};

export type ProductVariantPriceProperty = {
  __typename?: 'ProductVariantPriceProperty';
  adjustment?: Maybe<ProductPriceAdjustment>;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyValue: Scalars['String'];
};

export type ProductVariantPricePropertyArgs = {
  adjustment?: InputMaybe<ProductPriceAdjustmentArgs>;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyValue: Scalars['String'];
};

export type ProductVariantPropertyBooleanValue = ProductVariantPropertyValue & {
  __typename?: 'ProductVariantPropertyBooleanValue';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyDefinitionType: EProductPropertyType;
  value: AvailablePropertyBooleanOption;
};

export type ProductVariantPropertyNumberValue = ProductVariantPropertyValue & {
  __typename?: 'ProductVariantPropertyNumberValue';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyDefinitionType: EProductPropertyType;
  value: AvailablePropertyNumberOption;
};

export type ProductVariantPropertyTextValue = ProductVariantPropertyValue & {
  __typename?: 'ProductVariantPropertyTextValue';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyDefinitionType: EProductPropertyType;
  value: AvailablePropertyTextOption;
};

export type ProductVariantPropertyValue = {
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId'];
  propertyDefinitionType: EProductPropertyType;
};

export type ProductVariantValue = ProductVariantPropertyBooleanValue | ProductVariantPropertyNumberValue | ProductVariantPropertyTextValue;

export type ProductVariantValueArgs = {
  propertyDefinitionId: Scalars['ObjectId'];
  value: ProductVariantValueOptionArgs;
};

export type ProductVariantValueOptionArgs = {
  booleanOption?: InputMaybe<Scalars['Boolean']>;
  numberOption?: InputMaybe<Scalars['Float']>;
  textOption?: InputMaybe<AvailablePropertyTextOptionArgs>;
};

export type ProductsFiltersArgs = {
  categoryIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  createdBefore: Scalars['DateTime'];
  isCrawled?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']>;
};

export type ProductsWithPagination = {
  __typename?: 'ProductsWithPagination';
  count: Scalars['Float'];
  products: Array<ProductLegacy>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
};

export type PropertyDefinitionValueFormatting = {
  __typename?: 'PropertyDefinitionValueFormatting';
  orderBy?: Maybe<EOrderBy>;
  suffix?: Maybe<Scalars['String']>;
};

export type PropertyDefinitionValueFormattingArgs = {
  orderBy?: InputMaybe<EOrderBy>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type PurchaseData = {
  __typename?: 'PurchaseData';
  receiptLink?: Maybe<FileMetadata>;
  receiptLinkWithoutIdentity?: Maybe<FileMetadata>;
  receiptNumber?: Maybe<Scalars['String']>;
};

export type QualifyLeadArgs = {
  customDealId: Scalars['ObjectId'];
  estimatedPayoutAmount: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  callViviEndpoint: ViviSequenceResponse;
  callViviValuation: ViviValuationResponse;
  carDealCalculation: CarDealCalculation;
  carMakeModels?: Maybe<Array<Scalars['String']>>;
  checkCustomDealItemsPossiblyStolen: Scalars['Boolean'];
  checkDealItemsPossiblyStolen: Scalars['Boolean'];
  customDealCalculation: CustomDealCalculation;
  customDealPawnPurchaseCalculations: CustomDealPawnPurchaseCalculations;
  customerByPersonalData?: Maybe<Customer>;
  dealCalculation: PersistedDealCalculation;
  dealExtensionCalculation?: Maybe<PersistedDealExtensionCalculation>;
  dealPawnDurations: Array<Scalars['Float']>;
  dealPaybackCalculation?: Maybe<PersistedDealPaybackCalculation>;
  electronicsAppraisalCatalogProducts: Array<ElectronicsAppraisalCatalogProduct>;
  findItemCategory: ItemCategory;
  getActiveCompanies: Array<Company>;
  getActiveCustomers: Array<Customer>;
  getActiveEmployees: Array<Employee>;
  getActiveKSVAssetRecords: Array<KsvAssetRecord>;
  getActivePartners: Array<Partner>;
  getActiveStorageFacilities: Array<StorageFacility>;
  getAllShopPages: Array<ShopPage>;
  getAssignedStorageFeesByCategory: Array<FeeDefinition>;
  getAuctionBuybackDeals: Array<Deal>;
  getAuctionById: Auction;
  getAuctionByItemId?: Maybe<Auction>;
  getAuctionSuggestedDeals: Array<Deal>;
  getAvailableRegions: RegionData;
  getCashBookCashFlows: Array<CashBookCashFlow>;
  getCashBookCashFlowsExport: FileMetadata;
  getCashBookCount?: Maybe<CashBookCount>;
  getCashBookCounts: Array<CashBookCount>;
  getCategoryPageContent: CategoryPageContent;
  getCategoryPages: Array<CategoryPage>;
  getCompanies: Array<Company>;
  getCompany: Company;
  getCompanyByRegion: Company;
  getCompanyFeesEvaluation: CompanyFeesEvaluation;
  getCurrentCustomer: Customer;
  getCurrentEmployee: Employee;
  getCustomDealById: CustomDeal;
  getCustomDealFormByCategory?: Maybe<CustomDealFormQuestionByCategory>;
  getCustomDealFormById: CustomDealForm;
  getCustomDealForms: Array<CustomDealForm>;
  getCustomDeals: CustomDealsWithPagination;
  getCustomDealsCount: Scalars['Float'];
  getCustomRequest: CustomRequest;
  getCustomRequests: Array<CustomRequest>;
  getCustomRequestsFromCustomer: Array<CustomRequest>;
  getCustomer: Customer;
  getCustomerBlacklistById: CustomerBlacklist;
  getDeactivatedEmployees: Array<Employee>;
  getDealById: Deal;
  getDealByShippingLabelPageId: Deal;
  getDealItem: DealItem;
  getDeals: Array<Deal>;
  getDealsCount: Scalars['Float'];
  getEmployee: Employee;
  getEnabledPostalCodes: Array<StoreboxEnabledPostalCode>;
  getExistingCustomerBlacklists: Array<CustomerBlacklist>;
  getExistingDealCalculation: DealCalculation;
  getFee: FeeDefinition;
  getFees: Array<FeeDefinition>;
  getItemById: Item;
  getItemCategories: Array<ItemCategory>;
  getItemCategory: ItemCategory;
  getItemPage: ItemPage;
  getItemPageContent: ItemPageContent;
  getItemQuestion: ItemQuestion;
  getItemQuestionByTitle?: Maybe<ItemQuestion>;
  getItemQuestions: Array<ItemQuestion>;
  getItemQuestionsByCategory: Array<ItemQuestion>;
  getItemQuestionsByCategoryV2: Array<ItemQuestion>;
  getItems: Array<Item>;
  getItemsCount: Scalars['Float'];
  getKnpDebt: KnpDebt;
  getLatestCashFlowBalanceForDate: Scalars['Float'];
  getLoanToValuesEntries: Array<LoanToValuesEntry>;
  getLoanToValuesEntry: LoanToValuesEntry;
  getMaintenanceWindow?: Maybe<MaintenanceWindow>;
  getMarketingCreditNoteCashBookCashFlowsInTimeRange: Array<CashBookCashFlow>;
  getMaterialPrice: MaterialPrice;
  getMaterialPriceForDate: MaterialPrice;
  getMaterialPrices: Array<MaterialPrice>;
  getMenuPanel: MenuPanel;
  getNearestLocations: Array<LocationDistance>;
  getOpenAuction: DealInOpenAuctionArgs;
  getOtherRevenuesInTimeRange: Array<CashBookCashFlow>;
  getParentCategories: Array<ItemCategory>;
  getPartner: Partner;
  getPawnsInTimeRange: Array<Deal>;
  getPrivateSaleByDealId?: Maybe<PrivateSale>;
  getPrivateSaleById: PrivateSale;
  getPrivateSaleSuggestedDeals: Array<Deal>;
  getProduct: Product;
  getProductBySlug: Product;
  getProductLegacy: ProductLegacy;
  getProductPropertyDefinition: ProductPropertyDefinition;
  getProductPropertyDefinitions: Array<ProductPropertyDefinition>;
  getProducts: Array<Product>;
  getProductsExport: PaginatedProductExport;
  getProductsLegacy: Array<ProductLegacy>;
  getProductsLegacyWithPagination: ProductsWithPagination;
  getPurchasesInTimeRange: Array<Deal>;
  getReady2OrderProductNames: Array<Scalars['String']>;
  getRefurbedProductsByInstanceId: Array<RefurbedProduct>;
  getRefurbedProductsImportStatus: ImportNewProductsResult;
  getResponseTemplate: ResponseTemplate;
  getResponseTemplates: Array<ResponseTemplate>;
  getSearchedCustomers: Array<Customer>;
  getShipmentAddress: OAddress;
  getShippingLabels: Array<ShippingLabel>;
  getShippingProfileList: Array<RefurbedShippingProfile>;
  getShop: Shop;
  getShops: Array<Shop>;
  getShopsActiveOnWebsite: Array<Shop>;
  getShopsForCategories: Array<Shop>;
  getSimilarRefurbedProducts: Array<RefurbedProduct>;
  getStorageFacility: StorageFacility;
  getStorageUnit: StorageUnit;
  getStorageUnits: Array<StorageUnit>;
  getUpcomingPickupSlots: Array<StoreboxPickupSlot>;
  getValorizationEntries: Array<ValorizationEntry>;
  getValorizationEntriesInTimeRange: Array<ValorizationEntry>;
  getValorizationEntry: ValorizationEntry;
  getViviEntryPoint: ViviSequenceResponse;
  getViviSequenceForVin?: Maybe<ViviSequenceResponse>;
  handleCheckLoanDue: Scalars['Boolean'];
  handleCheckLoanDueNotified: Scalars['Boolean'];
  handleCheckValorizationStart: Scalars['Boolean'];
  handleTemporaryNotSellableItems: Scalars['Boolean'];
  isGuestCheckoutRegistrationTokenValid: Scalars['Boolean'];
  itemCalculation: ItemCalculation;
  productVariant: ProductVariant;
  searchAuctions: PaginatedAuctions;
  searchCashBookCashFlows: Array<CashBookCashFlow>;
  searchCustomDeals: PaginatedCustomDeals;
  searchCustomerBlacklists: PaginatedSkipLimitCustomerBlacklist;
  searchCustomers: PaginatedSkipLimitCustomers;
  searchDeals: PaginatedDeals;
  searchItemCategories: Array<ItemCategorySearchResult>;
  searchItems: PaginatedItems;
  searchPrivateSales: PaginatedPrivateSales;
  searchProducts: PaginatedProducts;
  storeboxAvailableForZipCode: Scalars['Boolean'];
  validateInitialPasswordLink: Scalars['Boolean'];
};


export type QueryCallViviEndpointArgs = {
  args: ViviRequestArgs;
};


export type QueryCallViviValuationArgs = {
  args: ViviValuationArgs;
};


export type QueryCarDealCalculationArgs = {
  args: CarDealCalculationArgs;
};


export type QueryCarMakeModelsArgs = {
  args: CarMakeModelsArgs;
};


export type QueryCheckCustomDealItemsPossiblyStolenArgs = {
  customDealId: Scalars['ObjectId'];
};


export type QueryCheckDealItemsPossiblyStolenArgs = {
  dealId: Scalars['ObjectId'];
};


export type QueryCustomDealCalculationArgs = {
  customDealCalculationArgs: CustomDealCalculationArgs;
};


export type QueryCustomDealPawnPurchaseCalculationsArgs = {
  customDealCalculationArgs: CustomDealCalculationArgs;
};


export type QueryCustomerByPersonalDataArgs = {
  args: CustomerByPersonalDataArgs;
};


export type QueryDealCalculationArgs = {
  companyId: Scalars['ObjectId'];
  customDealId?: InputMaybe<Scalars['ObjectId']>;
  date?: InputMaybe<Scalars['DateTime']>;
  dealItemsCalculationArgs: Array<DealItemCalculationArgs>;
  dealType: EDealType;
  dropoffTransportMode: ETransportMode;
  durationInDays: Scalars['Int'];
  isReversedCalculation: Scalars['Boolean'];
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  overwrittenPayoutAmount: Scalars['Float'];
  pickupTransportMode: ETransportMode;
  shouldOverwriteManualFees: Scalars['Boolean'];
  shouldOverwritePayoutAmount: Scalars['Boolean'];
};


export type QueryDealExtensionCalculationArgs = {
  args: DealExtensionCalculationArgs;
  dealId: Scalars['ObjectId'];
};


export type QueryDealPawnDurationsArgs = {
  args: DealPawnDurationsArgs;
};


export type QueryDealPaybackCalculationArgs = {
  args: DealPaybackCalculationArgs;
  dealId: Scalars['ObjectId'];
};


export type QueryElectronicsAppraisalCatalogProductsArgs = {
  category?: InputMaybe<EElectronicsAppraisalCatalogCategory>;
};


export type QueryFindItemCategoryArgs = {
  args: FindItemCategoryArgs;
};


export type QueryGetActiveCompaniesArgs = {
  opts?: InputMaybe<CompanyOpts>;
};


export type QueryGetActiveCustomersArgs = {
  opts?: InputMaybe<CustomerOpts>;
};


export type QueryGetActiveEmployeesArgs = {
  opts?: InputMaybe<EmployeeOpts>;
};


export type QueryGetActiveKsvAssetRecordsArgs = {
  vin: Scalars['String'];
};


export type QueryGetActivePartnersArgs = {
  opts?: InputMaybe<PartnerOpts>;
};


export type QueryGetActiveStorageFacilitiesArgs = {
  opts?: InputMaybe<StorageFacilityOpts>;
};


export type QueryGetAllShopPagesArgs = {
  opts?: InputMaybe<ShopPageOpts>;
};


export type QueryGetAssignedStorageFeesByCategoryArgs = {
  itemCategoryId: Scalars['ObjectId'];
};


export type QueryGetAuctionBuybackDealsArgs = {
  auctionId: Scalars['ObjectId'];
};


export type QueryGetAuctionByIdArgs = {
  auctionId: Scalars['ObjectId'];
};


export type QueryGetAuctionByItemIdArgs = {
  itemId: Scalars['ObjectId'];
};


export type QueryGetAuctionSuggestedDealsArgs = {
  companyId: Scalars['ObjectId'];
};


export type QueryGetCashBookCashFlowsArgs = {
  opts?: InputMaybe<CashBookCashFlowOpts>;
};


export type QueryGetCashBookCashFlowsExportArgs = {
  opts?: InputMaybe<CashBookCashFlowOpts>;
};


export type QueryGetCashBookCountArgs = {
  opts?: InputMaybe<CashBookCountOpts>;
};


export type QueryGetCashBookCountsArgs = {
  opts?: InputMaybe<CashBookCountOpts>;
};


export type QueryGetCategoryPageContentArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  path: Scalars['String'];
};


export type QueryGetCategoryPagesArgs = {
  opts?: InputMaybe<CategoryPageOpts>;
};


export type QueryGetCompaniesArgs = {
  opts?: InputMaybe<CompanyOpts>;
};


export type QueryGetCompanyArgs = {
  companyId: Scalars['ObjectId'];
};


export type QueryGetCompanyByRegionArgs = {
  region: ERegionCode;
};


export type QueryGetCompanyFeesEvaluationArgs = {
  businessUnit: EBusinessUnit;
  companyId: Scalars['ObjectId'];
};


export type QueryGetCustomDealByIdArgs = {
  customDealId: Scalars['ObjectId'];
};


export type QueryGetCustomDealFormByCategoryArgs = {
  categoryId: Scalars['ObjectId'];
};


export type QueryGetCustomDealFormByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryGetCustomDealsArgs = {
  opts?: InputMaybe<CustomDealOpts>;
};


export type QueryGetCustomDealsCountArgs = {
  opts?: InputMaybe<CustomDealOpts>;
};


export type QueryGetCustomRequestArgs = {
  customRequestId: Scalars['ObjectId'];
};


export type QueryGetCustomRequestsArgs = {
  opts?: InputMaybe<CustomRequestOpts>;
};


export type QueryGetCustomRequestsFromCustomerArgs = {
  customerId: Scalars['ObjectId'];
};


export type QueryGetCustomerArgs = {
  customerId: Scalars['ObjectId'];
};


export type QueryGetCustomerBlacklistByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryGetDeactivatedEmployeesArgs = {
  opts?: InputMaybe<EmployeeOpts>;
};


export type QueryGetDealByIdArgs = {
  dealId: Scalars['ObjectId'];
};


export type QueryGetDealByShippingLabelPageIdArgs = {
  shippingLabelPageId: Scalars['String'];
};


export type QueryGetDealItemArgs = {
  dealId: Scalars['ObjectId'];
  itemId: Scalars['ObjectId'];
};


export type QueryGetDealsArgs = {
  opts?: InputMaybe<DealOpts>;
};


export type QueryGetDealsCountArgs = {
  opts?: InputMaybe<DealOpts>;
};


export type QueryGetEmployeeArgs = {
  employeeId: Scalars['ObjectId'];
};


export type QueryGetEnabledPostalCodesArgs = {
  companyId: Scalars['ObjectId'];
  text?: InputMaybe<Scalars['String']>;
};


export type QueryGetExistingCustomerBlacklistsArgs = {
  args: CustomerBlacklistFiltersArgs;
};


export type QueryGetExistingDealCalculationArgs = {
  args: GetExistingDealCalculationArgs;
  dealId: Scalars['ObjectId'];
};


export type QueryGetFeeArgs = {
  feeId: Scalars['ObjectId'];
};


export type QueryGetFeesArgs = {
  opts?: InputMaybe<FeeOpts>;
};


export type QueryGetItemByIdArgs = {
  itemId: Scalars['ObjectId'];
};


export type QueryGetItemCategoriesArgs = {
  opts?: InputMaybe<ItemCategoryOpts>;
};


export type QueryGetItemCategoryArgs = {
  itemCategoryId: Scalars['ObjectId'];
};


export type QueryGetItemPageArgs = {
  opts: ItemPageOpts;
};


export type QueryGetItemPageContentArgs = {
  slug: Scalars['String'];
};


export type QueryGetItemQuestionArgs = {
  itemQuestionId: Scalars['ObjectId'];
};


export type QueryGetItemQuestionByTitleArgs = {
  itemCategoryId?: InputMaybe<Scalars['ObjectId']>;
  titleKey: Scalars['String'];
};


export type QueryGetItemQuestionsArgs = {
  opts?: InputMaybe<ItemQuestionOpts>;
};


export type QueryGetItemQuestionsByCategoryArgs = {
  date: Scalars['DateTime'];
  isCustomItem: Scalars['Boolean'];
  itemCategoryId: Scalars['ObjectId'];
  omitDeactivatedQuestionsForNewProducts: Scalars['Boolean'];
};


export type QueryGetItemQuestionsByCategoryV2Args = {
  date: Scalars['DateTime'];
  itemCategoryId: Scalars['ObjectId'];
  omitDeactivatedQuestionsForNewProducts: Scalars['Boolean'];
  omitInternalQuestions?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetItemsArgs = {
  opts?: InputMaybe<ItemOpts>;
};


export type QueryGetItemsCountArgs = {
  opts?: InputMaybe<ItemOpts>;
};


export type QueryGetKnpDebtArgs = {
  opts: KnpOpts;
};


export type QueryGetLatestCashFlowBalanceForDateArgs = {
  filterArgs?: InputMaybe<CashBookCashFlowLatestBalanceFilterArgs>;
};


export type QueryGetLoanToValuesEntriesArgs = {
  opts?: InputMaybe<LoanToValueOpts>;
};


export type QueryGetLoanToValuesEntryArgs = {
  loanToValuesEntryId: Scalars['ObjectId'];
};


export type QueryGetMarketingCreditNoteCashBookCashFlowsInTimeRangeArgs = {
  month: Scalars['Int'];
  shopId?: InputMaybe<Scalars['ObjectId']>;
  year: Scalars['Int'];
};


export type QueryGetMaterialPriceArgs = {
  materialPriceId: Scalars['ObjectId'];
};


export type QueryGetMaterialPriceForDateArgs = {
  date: Scalars['DateTime'];
  material: Scalars['String'];
};


export type QueryGetMaterialPricesArgs = {
  opts?: InputMaybe<MaterialPriceOpts>;
};


export type QueryGetNearestLocationsArgs = {
  lat: Scalars['Float'];
  limit: Scalars['Float'];
  lng: Scalars['Float'];
};


export type QueryGetOpenAuctionArgs = {
  dealId: Scalars['ObjectId'];
};


export type QueryGetOtherRevenuesInTimeRangeArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']>;
  month: Scalars['Int'];
  shopId?: InputMaybe<Scalars['ObjectId']>;
  year: Scalars['Int'];
};


export type QueryGetParentCategoriesArgs = {
  itemCategoryId: Scalars['ObjectId'];
};


export type QueryGetPartnerArgs = {
  partnerId: Scalars['ObjectId'];
};


export type QueryGetPawnsInTimeRangeArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']>;
  events: Array<EDealStatusType>;
  month: Scalars['Int'];
  shopId?: InputMaybe<Scalars['ObjectId']>;
  year: Scalars['Int'];
};


export type QueryGetPrivateSaleByDealIdArgs = {
  dealId: Scalars['ObjectId'];
};


export type QueryGetPrivateSaleByIdArgs = {
  privateSaleId: Scalars['ObjectId'];
};


export type QueryGetProductArgs = {
  productId: Scalars['ObjectId'];
};


export type QueryGetProductBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryGetProductLegacyArgs = {
  opts: ProductLegacyOpts;
};


export type QueryGetProductPropertyDefinitionArgs = {
  productPropertyDefinitionId: Scalars['ObjectId'];
};


export type QueryGetProductPropertyDefinitionsArgs = {
  opts?: InputMaybe<ProductPropertyDefinitionOpts>;
};


export type QueryGetProductsArgs = {
  opts?: InputMaybe<ProductOpts>;
};


export type QueryGetProductsExportArgs = {
  opts: ProductExportOpts;
};


export type QueryGetProductsLegacyArgs = {
  opts: ProductLegacyOpts;
};


export type QueryGetProductsLegacyWithPaginationArgs = {
  opts: ProductLegacyOpts;
};


export type QueryGetPurchasesInTimeRangeArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']>;
  events: Array<EDealStatusType>;
  month: Scalars['Int'];
  shopId?: InputMaybe<Scalars['ObjectId']>;
  year: Scalars['Int'];
};


export type QueryGetReady2OrderProductNamesArgs = {
  shopId: Scalars['ObjectId'];
};


export type QueryGetRefurbedProductsByInstanceIdArgs = {
  instanceId: Scalars['String'];
};


export type QueryGetResponseTemplateArgs = {
  responseTemplateId: Scalars['ObjectId'];
};


export type QueryGetResponseTemplatesArgs = {
  opts?: InputMaybe<ResponseTemplateOpts>;
};


export type QueryGetSearchedCustomersArgs = {
  opts: CustomerSearchOpts;
};


export type QueryGetShipmentAddressArgs = {
  companyId: Scalars['ObjectId'];
};


export type QueryGetShippingLabelsArgs = {
  args: ShippingLabelFilterArgs;
};


export type QueryGetShopArgs = {
  shopId: Scalars['ObjectId'];
};


export type QueryGetShopsArgs = {
  opts?: InputMaybe<ShopOpts>;
};


export type QueryGetShopsActiveOnWebsiteArgs = {
  opts?: InputMaybe<ShopOpts>;
};


export type QueryGetShopsForCategoriesArgs = {
  itemCategoryIds: Array<Scalars['ObjectId']>;
  opts?: InputMaybe<ShopOpts>;
};


export type QueryGetSimilarRefurbedProductsArgs = {
  opts: RefurbedProductSearchArgs;
};


export type QueryGetStorageFacilityArgs = {
  storageFacilityId: Scalars['ObjectId'];
};


export type QueryGetStorageUnitArgs = {
  storageUnitId: Scalars['ObjectId'];
};


export type QueryGetStorageUnitsArgs = {
  opts?: InputMaybe<StorageUnitOpts>;
};


export type QueryGetUpcomingPickupSlotsArgs = {
  args: StoreboxUpcomingPickupSlotsArgs;
};


export type QueryGetValorizationEntriesArgs = {
  opts?: InputMaybe<ValorizationEntryOpts>;
};


export type QueryGetValorizationEntriesInTimeRangeArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']>;
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetValorizationEntryArgs = {
  valorizationEntryId: Scalars['ObjectId'];
};


export type QueryGetViviSequenceForVinArgs = {
  vin: Scalars['String'];
};


export type QueryIsGuestCheckoutRegistrationTokenValidArgs = {
  token: Scalars['String'];
};


export type QueryItemCalculationArgs = {
  algoliaReference?: InputMaybe<Scalars['String']>;
  answers: Array<ItemAnswerArgs>;
  companyId: Scalars['ObjectId'];
  customPayoutAmount?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['DateTime']>;
  durationInDays: Scalars['Int'];
  existingCurrentMarketValue?: InputMaybe<Scalars['Float']>;
  existingPredictedMarketValue?: InputMaybe<Scalars['Float']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']>;
  itemCategoryId: Scalars['ObjectId'];
  material?: InputMaybe<Scalars['String']>;
  skipPredictionTags?: InputMaybe<Scalars['Boolean']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  useOldValuesOfPrediction?: InputMaybe<Scalars['Boolean']>;
  variantId?: InputMaybe<Scalars['ObjectId']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};


export type QueryProductVariantArgs = {
  args: GetProductVariantArgs;
};


export type QuerySearchAuctionsArgs = {
  args: AuctionsFiltersArgs;
};


export type QuerySearchCashBookCashFlowsArgs = {
  cashFlowNumber: Scalars['String'];
};


export type QuerySearchCustomDealsArgs = {
  args: CustomDealsFiltersArgs;
};


export type QuerySearchCustomerBlacklistsArgs = {
  args: CustomerBlacklistsFiltersArgs;
};


export type QuerySearchCustomersArgs = {
  args?: InputMaybe<CustomersFiltersArgs>;
};


export type QuerySearchDealsArgs = {
  args: DealsFiltersArgs;
};


export type QuerySearchItemCategoriesArgs = {
  args: ItemCategoryFiltersArgs;
};


export type QuerySearchItemsArgs = {
  args?: InputMaybe<ItemsFiltersArgs>;
};


export type QuerySearchPrivateSalesArgs = {
  args: PrivateSalesFiltersArgs;
};


export type QuerySearchProductsArgs = {
  args: ProductsFiltersArgs;
};


export type QueryStoreboxAvailableForZipCodeArgs = {
  companyId: Scalars['ObjectId'];
  zipCode: Scalars['String'];
};


export type QueryValidateInitialPasswordLinkArgs = {
  token: Scalars['String'];
};

export type QueryFieldFilter = {
  betweenValues?: InputMaybe<NumberFilterBetween>;
  condition?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<StringFilterOptions>;
  path: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type R2OProductMap = {
  __typename?: 'R2OProductMap';
  paymentReference: Scalars['String'];
  productName?: Maybe<Scalars['String']>;
};

export type R2OProductMapArgs = {
  paymentReference: Scalars['String'];
  productName?: InputMaybe<Scalars['String']>;
};

export type RefurbedBuyBox = {
  __typename?: 'RefurbedBuyBox';
  marketCode?: Maybe<ECountry>;
  sitePrice?: Maybe<Scalars['String']>;
  state?: Maybe<ERefurbedBuyBoxState>;
};

export type RefurbedBuyBoxArgs = {
  marketCode?: InputMaybe<ECountry>;
  sitePrice?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<ERefurbedBuyBoxState>;
};

export type RefurbedOffer = {
  __typename?: 'RefurbedOffer';
  bestBuyBox?: Maybe<RefurbedBuyBox>;
  currencyCode?: Maybe<ECurrencyCode>;
  grading?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  lowestPrice?: Maybe<Scalars['Float']>;
  offeredPrice?: Maybe<Scalars['Float']>;
  productName?: Maybe<Scalars['String']>;
  shippingProfileId?: Maybe<Scalars['String']>;
  shippingProfileName?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Float']>;
  taxation?: Maybe<ERefurbedTaxation>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warranty?: Maybe<Scalars['String']>;
};

export type RefurbedOfferArgs = {
  bestBuyBox?: InputMaybe<RefurbedBuyBoxArgs>;
  currencyCode?: InputMaybe<ECurrencyCode>;
  grading?: InputMaybe<Scalars['String']>;
  instanceId?: InputMaybe<Scalars['String']>;
  lowestPrice?: InputMaybe<Scalars['Float']>;
  offeredPrice?: InputMaybe<Scalars['Float']>;
  productName?: InputMaybe<Scalars['String']>;
  shippingProfileId?: InputMaybe<Scalars['String']>;
  shippingProfileName?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['Float']>;
  taxation?: InputMaybe<ERefurbedTaxation>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  warranty?: InputMaybe<Scalars['String']>;
};

export type RefurbedProduct = {
  __typename?: 'RefurbedProduct';
  _id: Scalars['ObjectId'];
  instanceId: Scalars['String'];
  name: Scalars['String'];
  nameDe: Scalars['String'];
  searchTags: Array<Scalars['String']>;
  storageSizes?: Maybe<MemorySize>;
};

export type RefurbedProductSearchArgs = {
  keyword: Scalars['String'];
};

export type RefurbedShippingProfile = {
  __typename?: 'RefurbedShippingProfile';
  _id: Scalars['ObjectId'];
  destinations: Array<ShippingDestination>;
  name: Scalars['String'];
  profileId: Scalars['String'];
  sourceCountryMarketCode: Scalars['String'];
  sourceCountryMarketName: Scalars['String'];
};

export type RefurbedStaggeredMargin = {
  __typename?: 'RefurbedStaggeredMargin';
  expectedMargin: Scalars['Float'];
  from: Scalars['Float'];
  minimumMargin: Scalars['Float'];
};

export type Region = {
  __typename?: 'Region';
  code: ECountry;
  domain: Scalars['String'];
  name: Scalars['String'];
};

export type RegionData = {
  __typename?: 'RegionData';
  availableRegions: Array<Region>;
  currentRegion?: Maybe<Region>;
};

export type RejectCustomDealCounterofferArgs = {
  _id: Scalars['ObjectId'];
};

export type ReserveExtensionArgs = {
  dealExtensionCalculationId: Scalars['ObjectId'];
  dealId: Scalars['ObjectId'];
  paymentType: EManualPaymentType;
};

export type ReservePaybackArgs = {
  dealId: Scalars['ObjectId'];
  dealPaybackCalculationId: Scalars['ObjectId'];
  paymentType: EManualPaymentType;
};

export type ReservedPaybackData = {
  __typename?: 'ReservedPaybackData';
  date: Scalars['DateTime'];
  dueAmount: Scalars['Float'];
  feeAmount: Scalars['Float'];
  isExtension: Scalars['Boolean'];
  partialRedemptionAmount: Scalars['Float'];
  paymentType: EManualPaymentType;
};

export type ResponseTemplate = {
  __typename?: 'ResponseTemplate';
  _id: Scalars['ObjectId'];
  closingText: Scalars['String'];
  editableText: Scalars['String'];
  name: Scalars['String'];
  openingText: Scalars['String'];
  subject: Scalars['String'];
};

export type ResponseTemplateCreateArgs = {
  closingText: Scalars['String'];
  editableText: Scalars['String'];
  name: Scalars['String'];
  openingText: Scalars['String'];
  subject: Scalars['String'];
};

export type ResponseTemplateFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  name?: InputMaybe<StringFilter>;
};

export type ResponseTemplateOpts = {
  filter?: InputMaybe<ResponseTemplateFilterArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ResponseTemplateUpdateArgs = {
  _id: Scalars['ObjectId'];
  closingText?: InputMaybe<Scalars['String']>;
  editableText?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  openingText?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type SalesPartnerDataArgs = {
  baggyluxe?: InputMaybe<SalesPartnerDataBaggyluxeArgs>;
  blitzmobile?: InputMaybe<SalesPartnerDataBlitzMobileArgs>;
  cashy?: InputMaybe<SalesPartnerDataCashyArgs>;
  chrono24?: InputMaybe<SalesPartnerDataChrono24Args>;
  ebay?: InputMaybe<SalesPartnerDataEbayArgs>;
  ebaykleinanzeigen?: InputMaybe<SalesPartnerDataEbayKleinanzeigenArgs>;
  others?: InputMaybe<SalesPartnerDataOthersArgs>;
  rebelle?: InputMaybe<SalesPartnerDataRebelleArgs>;
  refurbed?: InputMaybe<SalesPartnerDataRefurbedArgs>;
  type: ESalesPartnerType;
  vestiairecollective?: InputMaybe<SalesPartnerDataVestiaireCollectiveArgs>;
  willhaben?: InputMaybe<SalesPartnerDataWillhabenArgs>;
};

export type SalesPartnerDataBaggyluxeArgs = {
  saleId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type SalesPartnerDataBlitzMobileArgs = {
  saleId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type SalesPartnerDataCashyArgs = {
  _placeHolder?: InputMaybe<Scalars['Boolean']>;
};

export type SalesPartnerDataChrono24Args = {
  saleId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type SalesPartnerDataEbayArgs = {
  articleDescription?: InputMaybe<Scalars['String']>;
  ebayArticleNumber?: InputMaybe<Scalars['String']>;
  numberOfItems?: InputMaybe<Scalars['Float']>;
  paidDate?: InputMaybe<Scalars['DateTime']>;
  purchaseProcessingDate?: InputMaybe<Scalars['String']>;
  saleProtocolNumber?: InputMaybe<Scalars['Float']>;
  shippingCosts?: InputMaybe<Scalars['Float']>;
  shippingDate?: InputMaybe<Scalars['DateTime']>;
  shippingService?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type SalesPartnerDataEbayKleinanzeigenArgs = {
  kleinanzeigenArticleNumber?: InputMaybe<Scalars['String']>;
  shippingDate?: InputMaybe<Scalars['DateTime']>;
};

export type SalesPartnerDataOthersArgs = {
  saleId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type SalesPartnerDataRebelleArgs = {
  saleId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type SalesPartnerDataRefurbedArgs = {
  ID: Scalars['Float'];
  quantity: Scalars['Float'];
  shippingCosts: Scalars['Float'];
  warranty: Scalars['String'];
};

export type SalesPartnerDataVestiaireCollectiveArgs = {
  refId?: InputMaybe<Scalars['String']>;
};

export type SalesPartnerDataWillhabenArgs = {
  articleDescription?: InputMaybe<Scalars['String']>;
  numberOfItems?: InputMaybe<Scalars['Float']>;
  paidDate?: InputMaybe<Scalars['DateTime']>;
  purchaseProcessingDate?: InputMaybe<Scalars['String']>;
  saleProtocolNumber?: InputMaybe<Scalars['Float']>;
  shippingCosts?: InputMaybe<Scalars['Float']>;
  shippingDate?: InputMaybe<Scalars['DateTime']>;
  shippingService?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  willhabenArticleNumber?: InputMaybe<Scalars['String']>;
};

export type SaveReady2OrderProductMapsArgs = {
  r2oProductMaps: Array<R2OProductMapArgs>;
  shopId: Scalars['ObjectId'];
};

export type SecondaryPaymentData = {
  __typename?: 'SecondaryPaymentData';
  amount: Scalars['Float'];
  iban?: Maybe<Scalars['String']>;
  paymentType: AnyPaymentType;
  paypalAddress?: Maybe<Scalars['String']>;
  paypalTransactionId?: Maybe<Scalars['String']>;
};

export type SecondaryPaymentDataArgs = {
  amount: Scalars['Float'];
  iban?: InputMaybe<Scalars['String']>;
  paymentType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']>;
  paypalTransactionId?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['ObjectId']>;
};

export type SetAuctionItemsBuyersAndGenerateSurchargeCertificateArgs = {
  auctionId: Scalars['ObjectId'];
  employeeId: Scalars['ObjectId'];
  items: Array<AuctionItemArgs>;
};

export type ShippingDestination = {
  __typename?: 'ShippingDestination';
  currencyCode: Scalars['String'];
  isSiteMarket: Scalars['String'];
  marketCode: Scalars['String'];
  marketName: Scalars['String'];
  maxDeliveryDays: Scalars['Float'];
  minDeliveryDays: Scalars['Float'];
  shippingCosts: Scalars['String'];
  siteMarketCurrencyCode: Scalars['String'];
  siteMarketShippingCosts: Scalars['String'];
};

export type ShippingLabel = {
  __typename?: 'ShippingLabel';
  direction: EShippingLabelDirection;
  isCODPayment?: Maybe<Scalars['Boolean']>;
  labelCreateDate: Scalars['DateTime'];
  labelFile: FileMetadata;
  receiverAddress: OAddress;
  receiverCompanyName: Scalars['String'];
  receiverName: Scalars['String'];
  senderAddress: OAddress;
  senderCompanyName: Scalars['String'];
  senderName: Scalars['String'];
  shippingPartner: EStandardShipmentType;
  trackingCode: Scalars['String'];
  trackingLink: Scalars['String'];
};

export type ShippingLabelCreateArgs = {
  additionalInfo?: InputMaybe<AdditionalInfoShippingLabel>;
  customerEmailAddress?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['ObjectId']>;
  direction: EShippingLabelDirection;
  entity: EShippingLabelEntity;
  isCODPayment?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['ObjectId']>;
  labelFile?: InputMaybe<FileTusMetadataArgs>;
  /** Either receiverAddress or receiverShopId should be available */
  receiverAddress?: InputMaybe<IAddress>;
  receiverCompanyName?: InputMaybe<Scalars['String']>;
  receiverName: Scalars['String'];
  /** Either receiverAddress or receiverShopId should be available */
  receiverShopId?: InputMaybe<Scalars['ObjectId']>;
  /** Either senderAddress or senderShopId should be available */
  senderAddress?: InputMaybe<IAddress>;
  senderCompanyName?: InputMaybe<Scalars['String']>;
  senderName: Scalars['String'];
  /** Either senderAddress or senderShopId should be available */
  senderShopId?: InputMaybe<Scalars['ObjectId']>;
  shippingLabelFileSource: EShippingLabelFileSource;
  shippingPartner: EStandardShipmentType;
  trackingCode?: InputMaybe<Scalars['String']>;
  trackingLink?: InputMaybe<Scalars['String']>;
};

export type ShippingLabelFilterArgs = {
  dealId?: InputMaybe<Scalars['ObjectId']>;
  itemId?: InputMaybe<Scalars['ObjectId']>;
};

export type Shop = {
  __typename?: 'Shop';
  _id: Scalars['ObjectId'];
  address: OAddress;
  cashBoxNames?: Maybe<Array<Scalars['String']>>;
  company: Company;
  companyId: Scalars['ObjectId'];
  disabled?: Maybe<Scalars['Boolean']>;
  disabledAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  googleMapsLink: Scalars['String'];
  hideLocationOnWebsite?: Maybe<Scalars['Boolean']>;
  itemCategories?: Maybe<Array<ItemCategory>>;
  itemCategoryIds?: Maybe<Array<Scalars['ObjectId']>>;
  mainStorageFacility?: Maybe<StorageFacility>;
  mainStorageFacilityId?: Maybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  openingHours: Scalars['String'];
  partnerId?: Maybe<Scalars['ObjectId']>;
  phone: Scalars['String'];
  r2oProductMaps?: Maybe<Array<R2OProductMap>>;
  ready2OrderApiKey?: Maybe<Scalars['String']>;
  ready2OrderApiKeyStored?: Maybe<Scalars['Boolean']>;
  shopPagePath?: Maybe<Scalars['String']>;
  storageFacilities: Array<StorageFacility>;
  storageFacilityIds?: Maybe<Array<Scalars['ObjectId']>>;
  successionShop?: Maybe<Shop>;
  successionShopId?: Maybe<Scalars['ObjectId']>;
};


export type ShopItemCategoriesArgs = {
  opts?: InputMaybe<ItemCategoryOpts>;
};


export type ShopStorageFacilitiesArgs = {
  opts?: InputMaybe<StorageFacilityOpts>;
};

export type ShopFilterArgs = {
  activeOnWebsite?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<IdFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  regionCode?: InputMaybe<ERegionCode>;
  storageFacilityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  successionShopId?: InputMaybe<IdFilter>;
};

export type ShopOpts = {
  filter?: InputMaybe<ShopFilterArgs>;
  order?: InputMaybe<ShopOrderArgs>;
};

export type ShopOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type ShopPage = {
  __typename?: 'ShopPage';
  _id: Scalars['ObjectId'];
  country?: Maybe<EStrapiContentCountry>;
  detailedContentComponents: Array<ContentComponent>;
  headerComponents: Array<ContentComponent>;
  metaDescription?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pageTitle?: Maybe<Scalars['String']>;
  path: Scalars['String'];
};

export type ShopPageFilterArgs = {
  country?: InputMaybe<EStrapiContentCountry>;
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
};

export type ShopPageOpts = {
  filter?: InputMaybe<ShopPageFilterArgs>;
  order?: InputMaybe<ShopPageOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ShopPageOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
};

export type StandardShippingData = {
  __typename?: 'StandardShippingData';
  address: OAddress;
  sentShippingLabels?: Maybe<Array<ShippingLabel>>;
  shippingType?: Maybe<EStandardShipmentType>;
};

export type StandardShippingDataArgs = {
  address: IAddress;
};

export type StorageFacility = {
  __typename?: 'StorageFacility';
  _id: Scalars['ObjectId'];
  address: OAddress;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  external: Scalars['Boolean'];
  isDeactivated?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  shopIds: Array<Scalars['ObjectId']>;
  shops: Array<Shop>;
  storageUnitIds: Array<Scalars['ObjectId']>;
  storageUnits: Array<StorageUnit>;
};


export type StorageFacilityShopsArgs = {
  opts?: InputMaybe<ShopOpts>;
};


export type StorageFacilityStorageUnitsArgs = {
  opts?: InputMaybe<StorageUnitOpts>;
};

export type StorageFacilityFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  isDeactivated?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<Scalars['String']>;
  shopIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type StorageFacilityOpts = {
  filter?: InputMaybe<StorageFacilityFilterArgs>;
  order?: InputMaybe<StorageFacilityOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type StorageFacilityOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type StorageStatusFilter = {
  status: EStorageStatus;
  when?: InputMaybe<DateFilter>;
};

export type StorageUnit = {
  __typename?: 'StorageUnit';
  _id: Scalars['ObjectId'];
  capacity?: Maybe<Scalars['Float']>;
  childIds?: Maybe<Array<Scalars['ObjectId']>>;
  childUnits?: Maybe<Array<StorageUnit>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSecureLocation: Scalars['Boolean'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['ObjectId']>;
  storageFacilityId: Scalars['ObjectId'];
};


export type StorageUnitChildUnitsArgs = {
  opts?: InputMaybe<StorageUnitOpts>;
};

export type StorageUnitFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type StorageUnitOpts = {
  filter?: InputMaybe<StorageUnitFilterArgs>;
  order?: InputMaybe<StorageUnitOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type StorageUnitOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type StoreboxData = {
  __typename?: 'StoreboxData';
  address: StoreboxPickupAddress;
  bookedAt?: Maybe<Scalars['DateTime']>;
  slot: StoreboxPickupSlot;
};

export type StoreboxDataArgs = {
  address: IStoreboxPickupAddress;
  slot: StoreboxPickupSlotArgs;
};

export type StoreboxEnabledPostalCode = {
  __typename?: 'StoreboxEnabledPostalCode';
  _id: Scalars['ObjectId'];
  companyId: Scalars['ObjectId'];
  country: ECountry;
  postalCode: Scalars['String'];
  postalName: Scalars['String'];
};

export type StoreboxPickupAddress = {
  __typename?: 'StoreboxPickupAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  coordinates?: Maybe<OCoordinates>;
  /** @deprecated Use `countryCode`. */
  country?: Maybe<Scalars['String']>;
  countryCode: ECountry;
  door?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  houseNumber: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  stairway?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type StoreboxPickupSlot = {
  __typename?: 'StoreboxPickupSlot';
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type StoreboxPickupSlotArgs = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type StoreboxUpcomingPickupSlotsArgs = {
  country: ECountry;
};

export type StoredFeeDefinition = {
  __typename?: 'StoredFeeDefinition';
  amount: Scalars['Float'];
  billingPeriodType: EBillingPeriodType;
  companyId: Scalars['ObjectId'];
  dealTypes: Array<EDealType>;
  feeIntervals?: Maybe<Array<FeeInterval>>;
  feeType: EFeeType;
  intervalSelectedIndex?: Maybe<Scalars['Float']>;
  isActive: Scalars['Boolean'];
  itemQuestionTitle?: Maybe<Scalars['String']>;
  itemQuestionValidAnswer?: Maybe<Scalars['String']>;
  level: EFeeLevel;
  mode: EFeeMode;
  onlyWhenInAuction?: Maybe<Scalars['Boolean']>;
  priority: Scalars['Float'];
  transportMode?: Maybe<ETransportMode>;
  withdrawalFeeIntervals?: Maybe<Array<WithdrawalFeeInterval>>;
};

export type StringFilter = {
  condition?: InputMaybe<EStringFilterConditions>;
  options?: InputMaybe<StringFilterOptions>;
  value: Scalars['String'];
};

export type StringFilterOptions = {
  caseSensitive?: InputMaybe<Scalars['Boolean']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  customDealAdded: CustomDeal;
  dealAdded: Deal;
  onlinePaymentSucceeded: Deal;
};

export type SuccessfulPayment = {
  __typename?: 'SuccessfulPayment';
  id: Scalars['String'];
};

export type SurplusPaymentData = {
  __typename?: 'SurplusPaymentData';
  cashBookCashFlowId: Scalars['ObjectId'];
  cashBookLocation: Scalars['String'];
  cashBookType: ECashBookType;
  cashFlowNumber: Scalars['Float'];
  date: Scalars['DateTime'];
  employee: Employee;
  outFlow: Scalars['Float'];
  paymentReference: ECashBookPaymentReference;
};

export type SystemOperation = {
  __typename?: 'SystemOperation';
  name: Scalars['String'];
};

export type TextDefaultCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'TextDefaultCustomDealFormQuestion';
  _id: Scalars['ObjectId'];
  info: TranslatedString;
  initialTextAnswer?: Maybe<Scalars['String']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type TextMultilineCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'TextMultilineCustomDealFormQuestion';
  _id: Scalars['ObjectId'];
  info: TranslatedString;
  initialMultilineTextAnswer?: Maybe<Scalars['String']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type TextOptionsCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'TextOptionsCustomDealFormQuestion';
  _id: Scalars['ObjectId'];
  allowEnterAnswer: Scalars['Boolean'];
  info: TranslatedString;
  initialOptionTextAnswer?: Maybe<Scalars['String']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']>;
  options: Array<CustomDealFormTextOption>;
  showOnIssuanceCertificate: Scalars['Boolean'];
  showOnSalesBill: Scalars['Boolean'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type TimePeriod = {
  __typename?: 'TimePeriod';
  from: Scalars['DateTime'];
  to?: Maybe<Scalars['DateTime']>;
};

export type TranslatedString = {
  __typename?: 'TranslatedString';
  allTranslations: Array<TranslationItem>;
  text: Scalars['String'];
};


export type TranslatedStringTextArgs = {
  languageCode: ELanguageCode;
};

export type TranslationItem = {
  __typename?: 'TranslationItem';
  languageCode: ELanguageCode;
  text: Scalars['String'];
};

export type TransportData = {
  __typename?: 'TransportData';
  premiumShippingData?: Maybe<PremiumShippingData>;
  standardShippingData?: Maybe<StandardShippingData>;
  storeboxData?: Maybe<StoreboxData>;
  transportMode: ETransportMode;
};

export type TransportDataArgs = {
  note?: InputMaybe<Scalars['String']>;
  premiumShippingDataArgs?: InputMaybe<PremiumShippingDataArgs>;
  standardShippingDataArgs?: InputMaybe<StandardShippingDataArgs>;
  storeboxDataArgs?: InputMaybe<StoreboxDataArgs>;
  transportMode: ETransportMode;
};

export type UnzerPaymentArgs = {
  creditcardPaymentData?: InputMaybe<CreditcardPaymentArgs>;
  paymentType: EAutomaticPaymentType;
};

export type UnzerTransaction = {
  __typename?: 'UnzerTransaction';
  paymentId: Scalars['String'];
  traceId?: Maybe<Scalars['String']>;
  typeId: Scalars['String'];
};

export type UpdateDealAuctioningSettingsArgs = {
  auctioningAllowed: Scalars['Boolean'];
  dealId: Scalars['ObjectId'];
};

export type UpdateDealItemAnswersArgs = {
  answers: Array<ItemAnswerArgs>;
  itemId: Scalars['ObjectId'];
};

export type UpdateFormAnswerArgs = {
  booleanAnswer?: InputMaybe<Scalars['Boolean']>;
  numberAnswer?: InputMaybe<Scalars['Float']>;
  optionNumberAnswer?: InputMaybe<Scalars['Float']>;
  optionTextAnswer?: InputMaybe<Scalars['String']>;
  textAnswer?: InputMaybe<Scalars['String']>;
  textMultilineAnswer?: InputMaybe<Scalars['String']>;
};

export type UpdateItemNewInternalPriceArgs = {
  itemId: Scalars['ObjectId'];
  price: Scalars['Float'];
};

export type UpdateProduct = {
  _id: Scalars['ObjectId'];
  collectionName?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  gewicht?: InputMaybe<Scalars['Float']>;
  isInactive?: InputMaybe<Scalars['Boolean']>;
  isTaxFree?: InputMaybe<Scalars['Boolean']>;
  karat?: InputMaybe<Scalars['Float']>;
  lastPrice_id?: InputMaybe<Scalars['ObjectId']>;
  lvl0Category?: InputMaybe<Scalars['String']>;
  lvl0ContentCategory?: InputMaybe<Scalars['String']>;
  lvl1Category?: InputMaybe<Scalars['String']>;
  lvl1ContentCategory?: InputMaybe<Scalars['String']>;
  lvl2Category?: InputMaybe<Scalars['String']>;
  lvl2ContentCategory?: InputMaybe<Scalars['String']>;
  lvl3ContentCategory?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  pictureFilename?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productTags?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateVehicleDataArgs = {
  carPriceLastFetched?: InputMaybe<Scalars['DateTime']>;
  has57aGutachten?: InputMaybe<Scalars['Boolean']>;
  has57aGutachtenDue?: InputMaybe<Scalars['DateTime']>;
  hasApprovalCertificate?: InputMaybe<Scalars['Boolean']>;
  hasSaleContract?: InputMaybe<Scalars['Boolean']>;
  hasSecondKey?: InputMaybe<Scalars['Boolean']>;
  hasTypeCertificate?: InputMaybe<Scalars['Boolean']>;
  indicataId?: InputMaybe<Scalars['String']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  spareTireCount?: InputMaybe<Scalars['Float']>;
  vehicleProperties?: InputMaybe<UpdateVehiclePropertiesArgs>;
  vin?: InputMaybe<Scalars['String']>;
  vinLastFetched?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateVehiclePropertiesArgs = {
  body?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<Scalars['String']>;
  facelift?: InputMaybe<Scalars['String']>;
  fuel?: InputMaybe<Scalars['String']>;
  horsePower?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['Float']>;
  regdate?: InputMaybe<Scalars['String']>;
  seats?: InputMaybe<Scalars['String']>;
  transmission?: InputMaybe<Scalars['String']>;
  trim?: InputMaybe<Scalars['String']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  _id: Scalars['ObjectId'];
  alternativeText: Scalars['String'];
  caption: Scalars['String'];
  createdAt: Scalars['DateTime'];
  ext: Scalars['String'];
  formats?: Maybe<UploadFileFormats>;
  hash: Scalars['String'];
  height: Scalars['Int'];
  mime: Scalars['String'];
  name: Scalars['String'];
  provider: Scalars['String'];
  size: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type UploadFileFormat = {
  __typename?: 'UploadFileFormat';
  ext: Scalars['String'];
  hash: Scalars['String'];
  height: Scalars['Int'];
  mime: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  size: Scalars['Float'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type UploadFileFormats = {
  __typename?: 'UploadFileFormats';
  large?: Maybe<UploadFileFormat>;
  medium?: Maybe<UploadFileFormat>;
  product_small?: Maybe<UploadFileFormat>;
  product_thumbnail?: Maybe<UploadFileFormat>;
  small?: Maybe<UploadFileFormat>;
  thumbnail: UploadFileFormat;
};

export type UsedFeeDefinition = {
  __typename?: 'UsedFeeDefinition';
  calculatedFeeDefinitions: Array<CalculatedFeeDefinition>;
  feeWeight: Scalars['Float'];
  itemCategoryId: Scalars['ObjectId'];
  storageLabel?: Maybe<Scalars['String']>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  _id: Scalars['ObjectId'];
  userPermissions?: Maybe<Array<Scalars['String']>>;
};

export type ValidatePaybackOrExtendDealPersistanceCalculationArgs = {
  dealExtensionCalculationId?: InputMaybe<Scalars['ObjectId']>;
  dealId: Scalars['ObjectId'];
  dealPaybackCalculationId?: InputMaybe<Scalars['ObjectId']>;
};

export type ValorizationEntry = {
  __typename?: 'ValorizationEntry';
  _id: Scalars['ObjectId'];
  buyerBillingAddress?: Maybe<BuyerBillingAddress>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerPhone?: Maybe<Scalars['String']>;
  buyerShippingAddress?: Maybe<OAddress>;
  canBeFinalized?: Maybe<Scalars['Boolean']>;
  cashFlowId?: Maybe<Scalars['ObjectId']>;
  cashflow: Scalars['Float'];
  companyId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  createdBy: ValorizationEntryCreator;
  customLabel?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  isItemReturned?: Maybe<Scalars['Boolean']>;
  isTaxFreeTransaction?: Maybe<Scalars['Boolean']>;
  itemsIds: Array<Scalars['ObjectId']>;
  logisticsPartnerData?: Maybe<OLogisticsPartnerData>;
  order?: Maybe<Scalars['Float']>;
  paymentData?: Maybe<PaymentData>;
  relatedBillId?: Maybe<Scalars['ObjectId']>;
  returnReason?: Maybe<EReturnReasons>;
  returnReasonDetails?: Maybe<Scalars['String']>;
  salesPartnerData?: Maybe<OSalesPartnerData>;
  sendBill?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
  valorizationBillLink?: Maybe<FileMetadata>;
  valorizationBillNumber?: Maybe<Scalars['String']>;
  valorizationCreditNoteLink?: Maybe<FileMetadata>;
  valorizationCreditNoteNumber?: Maybe<Scalars['String']>;
};

export type ValorizationEntryCreateArgs = {
  buyerBillingAddress?: InputMaybe<BuyerBillingAddressArgs>;
  buyerEmail?: InputMaybe<Scalars['String']>;
  buyerName?: InputMaybe<Scalars['String']>;
  buyerPhone?: InputMaybe<Scalars['String']>;
  buyerShippingAddress?: InputMaybe<IAddress>;
  cashflow: Scalars['Float'];
  customLabel?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  descriptionForItemStatus?: InputMaybe<Scalars['String']>;
  isItemReturned?: InputMaybe<Scalars['Boolean']>;
  isTaxFreeTransaction?: InputMaybe<Scalars['Boolean']>;
  itemsIds: Array<Scalars['ObjectId']>;
  logisticsPartnerData?: InputMaybe<LogisticsPartnerDataArgs>;
  order?: InputMaybe<Scalars['Float']>;
  paymentData?: InputMaybe<PaymentDataArgs>;
  relatedBillId?: InputMaybe<Scalars['ObjectId']>;
  returnReason?: InputMaybe<EReturnReasons>;
  returnReasonDetails?: InputMaybe<Scalars['String']>;
  salesPartnerData?: InputMaybe<SalesPartnerDataArgs>;
  sendBill?: InputMaybe<Scalars['Boolean']>;
};

/** Employee | SystemOperation */
export type ValorizationEntryCreator = Employee | SystemOperation;

export type ValorizationEntryFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  buyerName?: InputMaybe<StringFilter>;
  cashflow?: InputMaybe<NumberFilter>;
  date?: InputMaybe<DateFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  itemsIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  valorizationBillNumber?: InputMaybe<StringFilter>;
  valorizationCreditNoteNumber?: InputMaybe<StringFilter>;
};

export type ValorizationEntryOpts = {
  filter?: InputMaybe<ValorizationEntryFilterArgs>;
  order?: InputMaybe<ValorizationEntryOrderArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ValorizationEntryOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  buyerName?: InputMaybe<EOrderBy>;
  cashflow?: InputMaybe<EOrderBy>;
  date?: InputMaybe<EOrderBy>;
};

export type ValorizationEntryUpdateArgs = {
  _id: Scalars['ObjectId'];
  paymentData?: InputMaybe<PaymentDataArgs>;
};

export type ValorizationHistoryEntry = {
  __typename?: 'ValorizationHistoryEntry';
  _id: Scalars['ObjectId'];
  buyerBillingAddress?: Maybe<BuyerBillingAddress>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerPhone?: Maybe<Scalars['String']>;
  buyerShippingAddress?: Maybe<OAddress>;
  canBeFinalized?: Maybe<Scalars['Boolean']>;
  cashFlowId?: Maybe<Scalars['ObjectId']>;
  cashflow: Scalars['Float'];
  companyId: Scalars['ObjectId'];
  costOfGoodsSold: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  createdBy: ValorizationEntryCreator;
  cumulatedCashflow: Scalars['Float'];
  customLabel?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  deltaDifferenceTax: Scalars['Float'];
  deviation: Scalars['Float'];
  differenceGross: Scalars['Float'];
  differenceNet: Scalars['Float'];
  differenceTax: Scalars['Float'];
  externalSalePriceGross: Scalars['Float'];
  externalSalePriceGrossDeduction: Scalars['Float'];
  externalSalePriceNet: Scalars['Float'];
  externalSalePriceNetDeduction: Scalars['Float'];
  grossProfit: Scalars['Float'];
  isItemReturned?: Maybe<Scalars['Boolean']>;
  isTaxFreeTransaction?: Maybe<Scalars['Boolean']>;
  itemsIds: Array<Scalars['ObjectId']>;
  logisticsPartnerData?: Maybe<OLogisticsPartnerData>;
  order?: Maybe<Scalars['Float']>;
  paymentData?: Maybe<PaymentData>;
  relatedBillId?: Maybe<Scalars['ObjectId']>;
  returnReason?: Maybe<EReturnReasons>;
  returnReasonDetails?: Maybe<Scalars['String']>;
  salesPartnerData?: Maybe<OSalesPartnerData>;
  sendBill?: Maybe<Scalars['Boolean']>;
  taxableAmount: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  valorizationBillLink?: Maybe<FileMetadata>;
  valorizationBillNumber?: Maybe<Scalars['String']>;
  valorizationCreditNoteLink?: Maybe<FileMetadata>;
  valorizationCreditNoteNumber?: Maybe<Scalars['String']>;
  valorizationResult: Scalars['Float'];
};

export type VehicleData = {
  __typename?: 'VehicleData';
  carPriceLastFetched?: Maybe<Scalars['DateTime']>;
  has57aGutachten?: Maybe<Scalars['Boolean']>;
  has57aGutachtenDue?: Maybe<Scalars['DateTime']>;
  hasApprovalCertificate?: Maybe<Scalars['Boolean']>;
  hasSaleContract?: Maybe<Scalars['Boolean']>;
  hasSecondKey?: Maybe<Scalars['Boolean']>;
  hasTypeCertificate?: Maybe<Scalars['Boolean']>;
  indicataId?: Maybe<Scalars['String']>;
  ksvQueryHistories?: Maybe<Array<KsvQueryHistory>>;
  licensePlate?: Maybe<Scalars['String']>;
  spareTireCount?: Maybe<Scalars['Float']>;
  vehicleProperties: VehicleProperties;
  vin?: Maybe<Scalars['String']>;
  vinLastFetched?: Maybe<Scalars['DateTime']>;
};

export type VehicleDataArgs = {
  carPriceLastFetched?: InputMaybe<Scalars['DateTime']>;
  has57aGutachtenDue?: InputMaybe<Scalars['DateTime']>;
  hasSecondKey?: InputMaybe<Scalars['Boolean']>;
  indicataId?: InputMaybe<Scalars['String']>;
  vehicleProperties: VehiclePropertiesArgs;
  vin?: InputMaybe<Scalars['String']>;
  vinLastFetched?: InputMaybe<Scalars['DateTime']>;
};

export type VehicleProperties = {
  __typename?: 'VehicleProperties';
  body?: Maybe<Scalars['String']>;
  engine?: Maybe<Scalars['String']>;
  facelift?: Maybe<Scalars['String']>;
  fuel?: Maybe<Scalars['String']>;
  horsePower?: Maybe<Scalars['String']>;
  make: Scalars['String'];
  model?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['Float']>;
  otherVehicleProperties?: Maybe<Array<OtherCarProperty>>;
  regdate?: Maybe<Scalars['String']>;
  seats?: Maybe<Scalars['String']>;
  transmission?: Maybe<Scalars['String']>;
  trim?: Maybe<Scalars['String']>;
};

export type VehiclePropertiesArgs = {
  body?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<Scalars['String']>;
  facelift?: InputMaybe<Scalars['String']>;
  fuel?: InputMaybe<Scalars['String']>;
  horsePower?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['Float']>;
  otherVehicleProperties?: InputMaybe<Array<OtherVehiclePropertiesArgs>>;
  regdate?: InputMaybe<Scalars['String']>;
  seats?: InputMaybe<Scalars['String']>;
  transmission?: InputMaybe<Scalars['String']>;
  trim?: InputMaybe<Scalars['String']>;
};

export type VerifiedActivationEmployee = {
  __typename?: 'VerifiedActivationEmployee';
  email: Scalars['String'];
};

export type VerifyDealArgs = {
  dealId: Scalars['ObjectId'];
  finalMaxPawnDate?: InputMaybe<Scalars['DateTime']>;
  isOnlineExtensionPrevented: Scalars['Boolean'];
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  onlineExtensionBanNote?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['ObjectId']>;
  shouldOverwriteManualFees: Scalars['Boolean'];
};

export type ViviDescription = {
  __typename?: 'ViviDescription';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type ViviRequestArgs = {
  href: Scalars['String'];
};

export type ViviSequenceOption = {
  __typename?: 'ViviSequenceOption';
  description: Array<ViviDescription>;
  href: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  rel: Scalars['String'];
  summary: Scalars['String'];
  templated: Scalars['Boolean'];
  type: Scalars['String'];
};

export type ViviSequenceResponse = {
  __typename?: 'ViviSequenceResponse';
  lastStepHref?: Maybe<Scalars['String']>;
  nextStep: Array<ViviSequenceOption>;
  valuation?: Maybe<Scalars['Float']>;
  vehicleProperties: Array<OtherCarProperty>;
};


export type ViviSequenceResponseValuationArgs = {
  odometer?: InputMaybe<Scalars['Int']>;
};

export type ViviValuationArgs = {
  condition?: InputMaybe<Scalars['Float']>;
  href: Scalars['String'];
  odometer?: InputMaybe<Scalars['Float']>;
};

export type ViviValuationResponse = {
  __typename?: 'ViviValuationResponse';
  amount: Scalars['Float'];
  competitiveVehiclesForSale: Scalars['Float'];
  vehicleProperties: Array<OtherCarProperty>;
};

export type ViviVinRequestArgs = {
  condition?: InputMaybe<Scalars['Float']>;
  odometer?: InputMaybe<Scalars['Float']>;
  vin: Scalars['String'];
};

export type VoluntarySelfDeliveryMetadata = {
  __typename?: 'VoluntarySelfDeliveryMetadata';
  appointment?: Maybe<Scalars['DateTime']>;
  notifiedToEmployee?: Maybe<Scalars['Boolean']>;
};

export type WithdrawalFeeInterval = {
  __typename?: 'WithdrawalFeeInterval';
  factor: Scalars['Float'];
  from: Scalars['Float'];
};

export type WithdrawalFeeIntervalArgs = {
  factor: Scalars['Float'];
  from: Scalars['Float'];
};

export type WithdrawnDeal = {
  __typename?: 'WithdrawnDeal';
  deal: Deal;
  dealId: Scalars['ObjectId'];
  paymentType: AnyPaymentType;
  shop: Shop;
  shopId: Scalars['ObjectId'];
  withdrawalDate: Scalars['DateTime'];
  withdrawalReason: Scalars['String'];
};

export type YearlyCompanyCounterEntry = {
  __typename?: 'YearlyCompanyCounterEntry';
  counter: Scalars['Int'];
  year: Scalars['Int'];
};

export type EmployeeShop_QueryQueryVariables = Exact<{
  opts?: InputMaybe<ShopOpts>;
}>;


export type EmployeeShop_QueryQuery = { __typename?: 'Query', getShops: Array<{ __typename?: 'Shop', _id: any, name: string, cashBoxNames?: Array<string> | null }> };

export type EmployeeShopSelect_ShopsFragment = { __typename?: 'Shop', _id: any, name: string, cashBoxNames?: Array<string> | null };

export type GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQueryVariables = Exact<{
  month: Scalars['Int'];
  year: Scalars['Int'];
  shopId?: InputMaybe<Scalars['ObjectId']>;
}>;


export type GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery = { __typename?: 'Query', getMarketingCreditNoteCashBookCashFlowsInTimeRange: Array<{ __typename?: 'CashBookCashFlow', _id: any, cashFlowNumber: number, attachment?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null }> };

export type GetOtherRevenuesInTimeRangeQueryVariables = Exact<{
  month: Scalars['Int'];
  year: Scalars['Int'];
  companyId?: InputMaybe<Scalars['ObjectId']>;
  shopId?: InputMaybe<Scalars['ObjectId']>;
}>;


export type GetOtherRevenuesInTimeRangeQuery = { __typename?: 'Query', getOtherRevenuesInTimeRange: Array<{ __typename?: 'CashBookCashFlow', _id: any, cashFlowNumber: number, attachment?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null }> };

export type GetPawnsInTimeRangeQueryVariables = Exact<{
  month: Scalars['Int'];
  year: Scalars['Int'];
  events: Array<EDealStatusType> | EDealStatusType;
  companyId?: InputMaybe<Scalars['ObjectId']>;
  shopId?: InputMaybe<Scalars['ObjectId']>;
}>;


export type GetPawnsInTimeRangeQuery = { __typename?: 'Query', getPawnsInTimeRange: Array<{ __typename?: 'Deal', _id: any, bookingNumber: number, pawnData?: { __typename?: 'PawnData', billNumber?: string | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null } | null }> };

export type GetProductsExportQueryVariables = Exact<{
  opts: ProductExportOpts;
}>;


export type GetProductsExportQuery = { __typename?: 'Query', getProductsExport: { __typename?: 'PaginatedProductExport', edges: Array<{ __typename?: 'ProductExportEdge', node: { __typename?: 'ProductExport', _id: any, lastPrice_id?: any | null, collectionName?: string | null, objectID: string, title?: string | null, lvl0Category?: string | null, lvl1Category?: string | null, lvl2Category?: string | null, lvl0ContentCategory?: string | null, lvl1ContentCategory?: string | null, lvl2ContentCategory?: string | null, lvl3ContentCategory?: string | null, slug?: string | null, productTags: string, pictureFilename?: string | null, maxValue?: number | null, currentMarketValue?: number | null, predictionFactor?: number | null, lowestMarketValue?: number | null, crawledPrice?: number | null, previouslyOverwrittenPrice?: number | null, price?: number | null, timestamp?: number | null, crawledTimestamp?: number | null, previouslyOverwrittenTimestamp?: number | null, isInactive: boolean, releaseDate: string, gewicht?: number | null, karat?: number | null, material?: string | null, ean?: string | null, isTaxFree?: boolean | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null } } };

export type GetPurchasesInTimeRangeQueryVariables = Exact<{
  month: Scalars['Int'];
  year: Scalars['Int'];
  events: Array<EDealStatusType> | EDealStatusType;
  companyId?: InputMaybe<Scalars['ObjectId']>;
  shopId?: InputMaybe<Scalars['ObjectId']>;
}>;


export type GetPurchasesInTimeRangeQuery = { __typename?: 'Query', getPurchasesInTimeRange: Array<{ __typename?: 'Deal', _id: any, purchaseData?: { __typename?: 'PurchaseData', receiptNumber?: string | null, receiptLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null, filename?: string | null } | null } | null }> };

export type GetValorizationEntriesInTimeRangeQueryVariables = Exact<{
  month: Scalars['Int'];
  year: Scalars['Int'];
  companyId?: InputMaybe<Scalars['ObjectId']>;
}>;


export type GetValorizationEntriesInTimeRangeQuery = { __typename?: 'Query', getValorizationEntriesInTimeRange: Array<{ __typename?: 'ValorizationEntry', _id: any, valorizationBillNumber?: string | null, valorizationCreditNoteNumber?: string | null, valorizationBillLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, valorizationCreditNoteLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null }> };

export type ImportItemNewInternalPricesMutationVariables = Exact<{
  args: ImportItemNewInternalPricesArgs;
}>;


export type ImportItemNewInternalPricesMutation = { __typename?: 'Mutation', importItemNewInternalPrices: boolean };

export type ImportProductsMutationVariables = Exact<{
  args: ImportProductsArgs;
}>;


export type ImportProductsMutation = { __typename?: 'Mutation', importProducts: boolean };

export type CompanyDropdown_CompaniesFragment = { __typename?: 'Company', _id: any, name: string };

export type GetProductVariantForUpdateCustomItemQueryVariables = Exact<{
  args: GetProductVariantArgs;
}>;


export type GetProductVariantForUpdateCustomItemQuery = { __typename?: 'Query', productVariant: { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, sortPriority: number, key: string, description?: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } | null, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, sortPriority: number, key: string, description?: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } | null, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, sortPriority: number, key: string, description?: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } | null, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', id: any, translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> } };

export type CreateCustomerBlacklistMutationVariables = Exact<{
  args: CustomerBlacklistCreateArgs;
}>;


export type CreateCustomerBlacklistMutation = { __typename?: 'Mutation', createCustomerBlacklist: { __typename?: 'CustomerBlacklist', _id: any } };

export type UpdateCustomerBlacklistMutationVariables = Exact<{
  args: CustomerBlacklistUpdateArgs;
}>;


export type UpdateCustomerBlacklistMutation = { __typename?: 'Mutation', updateCustomerBlacklist: { __typename?: 'CustomerBlacklist', _id: any } };

export type DeleteCustomerBlacklistMutationVariables = Exact<{
  args: CustomerBlacklistDeleteArgs;
}>;


export type DeleteCustomerBlacklistMutation = { __typename?: 'Mutation', deleteCustomerBlacklist: boolean };

export type GetActiveCustomersQueryVariables = Exact<{
  opts?: InputMaybe<CustomerOpts>;
}>;


export type GetActiveCustomersQuery = { __typename?: 'Query', getActiveCustomers: Array<{ __typename?: 'Customer', _id: any, email: string, firstname: string, lastname: string, dateOfBirth?: any | null }> };

export type GetExistingCustomerBlacklistsQueryVariables = Exact<{
  args: CustomerBlacklistFiltersArgs;
}>;


export type GetExistingCustomerBlacklistsQuery = { __typename?: 'Query', getExistingCustomerBlacklists: Array<{ __typename?: 'CustomerBlacklist', _id: any }> };

export type SearchCustomerBlacklistsQueryVariables = Exact<{
  args: CustomerBlacklistsFiltersArgs;
}>;


export type SearchCustomerBlacklistsQuery = { __typename?: 'Query', searchCustomerBlacklists: { __typename?: 'PaginatedSkipLimitCustomerBlacklist', nodes: Array<{ __typename?: 'CustomerBlacklist', _id: any, email?: string | null, firstname: string, lastname: string, dateOfBirth?: any | null, reason: string, createdAt: any, customers?: Array<{ __typename?: 'Customer', _id: any, firstname: string, lastname: string }> | null, employee?: { __typename?: 'Employee', _id: any, firstname: string, lastname: string } | null }>, pageInfo: { __typename?: 'PageInfoSkipLimit', limit?: number | null, skip?: number | null, hasPrevPage?: boolean | null, hasNextPage?: boolean | null, total: number } } };

export type CustomerBlacklistFragment = { __typename?: 'CustomerBlacklist', _id: any, email?: string | null, firstname: string, lastname: string, dateOfBirth?: any | null, reason: string, createdAt: any, customers?: Array<{ __typename?: 'Customer', _id: any, firstname: string, lastname: string }> | null, employee?: { __typename?: 'Employee', _id: any, firstname: string, lastname: string } | null };

export type GetCustomerBlacklistByIdQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type GetCustomerBlacklistByIdQuery = { __typename?: 'Query', getCustomerBlacklistById: { __typename?: 'CustomerBlacklist', _id: any, email?: string | null, firstname: string, lastname: string, dateOfBirth?: any | null, reason: string, createdAt: any, customers?: Array<{ __typename?: 'Customer', _id: any, firstname: string, lastname: string }> | null, employee?: { __typename?: 'Employee', _id: any, firstname: string, lastname: string } | null } };

export type AddSecondaryCustomerToDealMutationVariables = Exact<{
  dealId: Scalars['ObjectId'];
  selectedCustomerId: Scalars['ObjectId'];
}>;


export type AddSecondaryCustomerToDealMutation = { __typename?: 'Mutation', addSecondaryCustomerToDeal: { __typename?: 'Deal', _id: any, secondaryCustomers?: Array<{ __typename?: 'Customer', _id: any, firstname: string, lastname: string, email: string }> | null } };

export type ChangeMainCustomerOfDealMutationVariables = Exact<{
  dealId: Scalars['ObjectId'];
  selectedCustomerId: Scalars['ObjectId'];
}>;


export type ChangeMainCustomerOfDealMutation = { __typename?: 'Mutation', changeMainCustomerOfDeal: { __typename?: 'Deal', _id: any, customer: { __typename?: 'Customer', _id: any, firstname: string, lastname: string, email: string } | { __typename?: 'GuestCustomerData' } } };

export type ConnectCustomerToDealMutationVariables = Exact<{
  dealId: Scalars['ObjectId'];
  customerId: Scalars['ObjectId'];
}>;


export type ConnectCustomerToDealMutation = { __typename?: 'Mutation', connectCustomerToDeal: { __typename?: 'Deal', _id: any, customer: { __typename?: 'Customer', _id: any, firstname: string, lastname: string, email: string } | { __typename?: 'GuestCustomerData' } } };

export type RemoveSecondaryCustomerToDealMutationVariables = Exact<{
  dealId: Scalars['ObjectId'];
  selectedCustomerId: Scalars['ObjectId'];
}>;


export type RemoveSecondaryCustomerToDealMutation = { __typename?: 'Mutation', removeSecondaryCustomerToDeal: { __typename?: 'Deal', _id: any, secondaryCustomers?: Array<{ __typename?: 'Customer', _id: any, firstname: string, lastname: string, email: string }> | null } };

export type Menubar_QueryQueryVariables = Exact<{
  opts?: InputMaybe<CompanyOpts>;
}>;


export type Menubar_QueryQuery = { __typename?: 'Query', getActiveCompanies: Array<{ __typename?: 'Company', _id: any, name: string }> };

export type UpdateItemCategoryIdealoIdMapsMutationVariables = Exact<{
  args: Array<ItemCategoryIdealoIdMapArgs> | ItemCategoryIdealoIdMapArgs;
}>;


export type UpdateItemCategoryIdealoIdMapsMutation = { __typename?: 'Mutation', updateItemCategoryIdealoIdMaps: boolean };

export type CrawlerConfig_ItemCategoriesFragment = { __typename?: 'ItemCategory', _id: any, idealoId?: string | null, name: string, algoliaCategorySlug?: string | null };

export type CreateOrUpdateReady2OrderApiKeyMutationVariables = Exact<{
  args: CreateOrUpdateReady2OrderApiKeyArgs;
}>;


export type CreateOrUpdateReady2OrderApiKeyMutation = { __typename?: 'Mutation', createOrUpdateReady2OrderApiKey: boolean };

export type SaveReady2OrderProductMapsMutationVariables = Exact<{
  args: SaveReady2OrderProductMapsArgs;
}>;


export type SaveReady2OrderProductMapsMutation = { __typename?: 'Mutation', saveReady2OrderProductMaps: boolean };

export type GetReady2OrderProductNamesQueryVariables = Exact<{
  shopId: Scalars['ObjectId'];
}>;


export type GetReady2OrderProductNamesQuery = { __typename?: 'Query', getReady2OrderProductNames: Array<string> };

export type ProductConfigurator_QueryQueryVariables = Exact<{
  opts?: InputMaybe<ItemCategoryOpts>;
}>;


export type ProductConfigurator_QueryQuery = { __typename?: 'Query', getItemCategories: Array<{ __typename?: 'ItemCategory', _id: any, idealoId?: string | null, name: string, algoliaCategorySlug?: string | null }> };

export type LoginEmployeeMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginEmployeeMutation = { __typename?: 'Mutation', loginEmployee: { __typename?: 'Employee', token?: string | null, email: string, firstname: string, lastname: string, roles: Array<ERoles>, _id: any, company: { __typename?: 'Company', _id: any }, preferences?: { __typename?: 'EmployeePreferences', defaultShopId?: any | null } | null } };

export const EmployeeShopSelect_ShopsFragmentDoc = gql`
    fragment EmployeeShopSelect_Shops on Shop {
  _id
  name
  cashBoxNames
}
    `;
export const CompanyDropdown_CompaniesFragmentDoc = gql`
    fragment CompanyDropdown_Companies on Company {
  _id
  name
}
    `;
export const CustomerBlacklistFragmentDoc = gql`
    fragment CustomerBlacklist on CustomerBlacklist {
  _id
  email
  firstname
  lastname
  dateOfBirth
  reason
  createdAt
  customers {
    _id
    firstname
    lastname
  }
  employee {
    _id
    firstname
    lastname
  }
}
    `;
export const CrawlerConfig_ItemCategoriesFragmentDoc = gql`
    fragment CrawlerConfig_ItemCategories on ItemCategory {
  _id
  idealoId
  name
  algoliaCategorySlug
}
    `;
export const EmployeeShop_QueryDocument = gql`
    query EmployeeShop_Query($opts: ShopOpts) {
  getShops(opts: $opts) {
    _id
    name
    ...EmployeeShopSelect_Shops
  }
}
    ${EmployeeShopSelect_ShopsFragmentDoc}`;

/**
 * __useEmployeeShop_QueryQuery__
 *
 * To run a query within a React component, call `useEmployeeShop_QueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeShop_QueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeShop_QueryQuery({
 *   variables: {
 *      opts: // value for 'opts'
 *   },
 * });
 */
export function useEmployeeShop_QueryQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeShop_QueryQuery, EmployeeShop_QueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeShop_QueryQuery, EmployeeShop_QueryQueryVariables>(EmployeeShop_QueryDocument, options);
      }
export function useEmployeeShop_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeShop_QueryQuery, EmployeeShop_QueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeShop_QueryQuery, EmployeeShop_QueryQueryVariables>(EmployeeShop_QueryDocument, options);
        }
export type EmployeeShop_QueryQueryHookResult = ReturnType<typeof useEmployeeShop_QueryQuery>;
export type EmployeeShop_QueryLazyQueryHookResult = ReturnType<typeof useEmployeeShop_QueryLazyQuery>;
export type EmployeeShop_QueryQueryResult = Apollo.QueryResult<EmployeeShop_QueryQuery, EmployeeShop_QueryQueryVariables>;
export const GetMarketingCreditNoteCashBookCashFlowsInTimeRangeDocument = gql`
    query getMarketingCreditNoteCashBookCashFlowsInTimeRange($month: Int!, $year: Int!, $shopId: ObjectId) {
  getMarketingCreditNoteCashBookCashFlowsInTimeRange(
    month: $month
    year: $year
    shopId: $shopId
  ) {
    _id
    attachment {
      url
      contentType
    }
    cashFlowNumber
  }
}
    `;

/**
 * __useGetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useGetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery, GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery, GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQueryVariables>(GetMarketingCreditNoteCashBookCashFlowsInTimeRangeDocument, options);
      }
export function useGetMarketingCreditNoteCashBookCashFlowsInTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery, GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery, GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQueryVariables>(GetMarketingCreditNoteCashBookCashFlowsInTimeRangeDocument, options);
        }
export type GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQueryHookResult = ReturnType<typeof useGetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery>;
export type GetMarketingCreditNoteCashBookCashFlowsInTimeRangeLazyQueryHookResult = ReturnType<typeof useGetMarketingCreditNoteCashBookCashFlowsInTimeRangeLazyQuery>;
export type GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQueryResult = Apollo.QueryResult<GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQuery, GetMarketingCreditNoteCashBookCashFlowsInTimeRangeQueryVariables>;
export const GetOtherRevenuesInTimeRangeDocument = gql`
    query getOtherRevenuesInTimeRange($month: Int!, $year: Int!, $companyId: ObjectId, $shopId: ObjectId) {
  getOtherRevenuesInTimeRange(
    month: $month
    year: $year
    companyId: $companyId
    shopId: $shopId
  ) {
    _id
    attachment {
      url
      contentType
    }
    cashFlowNumber
  }
}
    `;

/**
 * __useGetOtherRevenuesInTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetOtherRevenuesInTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherRevenuesInTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherRevenuesInTimeRangeQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *      companyId: // value for 'companyId'
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useGetOtherRevenuesInTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetOtherRevenuesInTimeRangeQuery, GetOtherRevenuesInTimeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtherRevenuesInTimeRangeQuery, GetOtherRevenuesInTimeRangeQueryVariables>(GetOtherRevenuesInTimeRangeDocument, options);
      }
export function useGetOtherRevenuesInTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtherRevenuesInTimeRangeQuery, GetOtherRevenuesInTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtherRevenuesInTimeRangeQuery, GetOtherRevenuesInTimeRangeQueryVariables>(GetOtherRevenuesInTimeRangeDocument, options);
        }
export type GetOtherRevenuesInTimeRangeQueryHookResult = ReturnType<typeof useGetOtherRevenuesInTimeRangeQuery>;
export type GetOtherRevenuesInTimeRangeLazyQueryHookResult = ReturnType<typeof useGetOtherRevenuesInTimeRangeLazyQuery>;
export type GetOtherRevenuesInTimeRangeQueryResult = Apollo.QueryResult<GetOtherRevenuesInTimeRangeQuery, GetOtherRevenuesInTimeRangeQueryVariables>;
export const GetPawnsInTimeRangeDocument = gql`
    query getPawnsInTimeRange($month: Int!, $year: Int!, $events: [EDealStatusType!]!, $companyId: ObjectId, $shopId: ObjectId) {
  getPawnsInTimeRange(
    month: $month
    year: $year
    events: $events
    companyId: $companyId
    shopId: $shopId
  ) {
    _id
    bookingNumber
    pawnData {
      billLink {
        url
        contentType
      }
      billNumber
      pawnTicketLink {
        url
        contentType
      }
    }
  }
}
    `;

/**
 * __useGetPawnsInTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetPawnsInTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPawnsInTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPawnsInTimeRangeQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *      events: // value for 'events'
 *      companyId: // value for 'companyId'
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useGetPawnsInTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetPawnsInTimeRangeQuery, GetPawnsInTimeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPawnsInTimeRangeQuery, GetPawnsInTimeRangeQueryVariables>(GetPawnsInTimeRangeDocument, options);
      }
export function useGetPawnsInTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPawnsInTimeRangeQuery, GetPawnsInTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPawnsInTimeRangeQuery, GetPawnsInTimeRangeQueryVariables>(GetPawnsInTimeRangeDocument, options);
        }
export type GetPawnsInTimeRangeQueryHookResult = ReturnType<typeof useGetPawnsInTimeRangeQuery>;
export type GetPawnsInTimeRangeLazyQueryHookResult = ReturnType<typeof useGetPawnsInTimeRangeLazyQuery>;
export type GetPawnsInTimeRangeQueryResult = Apollo.QueryResult<GetPawnsInTimeRangeQuery, GetPawnsInTimeRangeQueryVariables>;
export const GetProductsExportDocument = gql`
    query getProductsExport($opts: ProductExportOpts!) {
  getProductsExport(opts: $opts) {
    edges {
      node {
        _id
        lastPrice_id
        collectionName
        objectID
        title
        lvl0Category
        lvl1Category
        lvl2Category
        lvl0ContentCategory
        lvl1ContentCategory
        lvl2ContentCategory
        lvl3ContentCategory
        slug
        productTags
        pictureFilename
        maxValue
        currentMarketValue
        predictionFactor
        lowestMarketValue
        crawledPrice
        previouslyOverwrittenPrice
        price
        timestamp
        crawledTimestamp
        previouslyOverwrittenTimestamp
        isInactive
        releaseDate
        gewicht
        karat
        material
        ean
        isTaxFree
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetProductsExportQuery__
 *
 * To run a query within a React component, call `useGetProductsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsExportQuery({
 *   variables: {
 *      opts: // value for 'opts'
 *   },
 * });
 */
export function useGetProductsExportQuery(baseOptions: Apollo.QueryHookOptions<GetProductsExportQuery, GetProductsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsExportQuery, GetProductsExportQueryVariables>(GetProductsExportDocument, options);
      }
export function useGetProductsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsExportQuery, GetProductsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsExportQuery, GetProductsExportQueryVariables>(GetProductsExportDocument, options);
        }
export type GetProductsExportQueryHookResult = ReturnType<typeof useGetProductsExportQuery>;
export type GetProductsExportLazyQueryHookResult = ReturnType<typeof useGetProductsExportLazyQuery>;
export type GetProductsExportQueryResult = Apollo.QueryResult<GetProductsExportQuery, GetProductsExportQueryVariables>;
export const GetPurchasesInTimeRangeDocument = gql`
    query getPurchasesInTimeRange($month: Int!, $year: Int!, $events: [EDealStatusType!]!, $companyId: ObjectId, $shopId: ObjectId) {
  getPurchasesInTimeRange(
    month: $month
    year: $year
    events: $events
    companyId: $companyId
    shopId: $shopId
  ) {
    _id
    purchaseData {
      receiptNumber
      receiptLink {
        url
        contentType
        filename
      }
    }
  }
}
    `;

/**
 * __useGetPurchasesInTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetPurchasesInTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchasesInTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchasesInTimeRangeQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *      events: // value for 'events'
 *      companyId: // value for 'companyId'
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useGetPurchasesInTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetPurchasesInTimeRangeQuery, GetPurchasesInTimeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchasesInTimeRangeQuery, GetPurchasesInTimeRangeQueryVariables>(GetPurchasesInTimeRangeDocument, options);
      }
export function useGetPurchasesInTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchasesInTimeRangeQuery, GetPurchasesInTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchasesInTimeRangeQuery, GetPurchasesInTimeRangeQueryVariables>(GetPurchasesInTimeRangeDocument, options);
        }
export type GetPurchasesInTimeRangeQueryHookResult = ReturnType<typeof useGetPurchasesInTimeRangeQuery>;
export type GetPurchasesInTimeRangeLazyQueryHookResult = ReturnType<typeof useGetPurchasesInTimeRangeLazyQuery>;
export type GetPurchasesInTimeRangeQueryResult = Apollo.QueryResult<GetPurchasesInTimeRangeQuery, GetPurchasesInTimeRangeQueryVariables>;
export const GetValorizationEntriesInTimeRangeDocument = gql`
    query getValorizationEntriesInTimeRange($month: Int!, $year: Int!, $companyId: ObjectId) {
  getValorizationEntriesInTimeRange(
    month: $month
    year: $year
    companyId: $companyId
  ) {
    _id
    valorizationBillNumber
    valorizationBillLink {
      url
      contentType
    }
    valorizationCreditNoteLink {
      url
      contentType
    }
    valorizationCreditNoteNumber
  }
}
    `;

/**
 * __useGetValorizationEntriesInTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetValorizationEntriesInTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValorizationEntriesInTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValorizationEntriesInTimeRangeQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetValorizationEntriesInTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetValorizationEntriesInTimeRangeQuery, GetValorizationEntriesInTimeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValorizationEntriesInTimeRangeQuery, GetValorizationEntriesInTimeRangeQueryVariables>(GetValorizationEntriesInTimeRangeDocument, options);
      }
export function useGetValorizationEntriesInTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValorizationEntriesInTimeRangeQuery, GetValorizationEntriesInTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValorizationEntriesInTimeRangeQuery, GetValorizationEntriesInTimeRangeQueryVariables>(GetValorizationEntriesInTimeRangeDocument, options);
        }
export type GetValorizationEntriesInTimeRangeQueryHookResult = ReturnType<typeof useGetValorizationEntriesInTimeRangeQuery>;
export type GetValorizationEntriesInTimeRangeLazyQueryHookResult = ReturnType<typeof useGetValorizationEntriesInTimeRangeLazyQuery>;
export type GetValorizationEntriesInTimeRangeQueryResult = Apollo.QueryResult<GetValorizationEntriesInTimeRangeQuery, GetValorizationEntriesInTimeRangeQueryVariables>;
export const ImportItemNewInternalPricesDocument = gql`
    mutation importItemNewInternalPrices($args: ImportItemNewInternalPricesArgs!) {
  importItemNewInternalPrices(args: $args)
}
    `;
export type ImportItemNewInternalPricesMutationFn = Apollo.MutationFunction<ImportItemNewInternalPricesMutation, ImportItemNewInternalPricesMutationVariables>;

/**
 * __useImportItemNewInternalPricesMutation__
 *
 * To run a mutation, you first call `useImportItemNewInternalPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportItemNewInternalPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importItemNewInternalPricesMutation, { data, loading, error }] = useImportItemNewInternalPricesMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useImportItemNewInternalPricesMutation(baseOptions?: Apollo.MutationHookOptions<ImportItemNewInternalPricesMutation, ImportItemNewInternalPricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportItemNewInternalPricesMutation, ImportItemNewInternalPricesMutationVariables>(ImportItemNewInternalPricesDocument, options);
      }
export type ImportItemNewInternalPricesMutationHookResult = ReturnType<typeof useImportItemNewInternalPricesMutation>;
export type ImportItemNewInternalPricesMutationResult = Apollo.MutationResult<ImportItemNewInternalPricesMutation>;
export type ImportItemNewInternalPricesMutationOptions = Apollo.BaseMutationOptions<ImportItemNewInternalPricesMutation, ImportItemNewInternalPricesMutationVariables>;
export const ImportProductsDocument = gql`
    mutation importProducts($args: ImportProductsArgs!) {
  importProducts(args: $args)
}
    `;
export type ImportProductsMutationFn = Apollo.MutationFunction<ImportProductsMutation, ImportProductsMutationVariables>;

/**
 * __useImportProductsMutation__
 *
 * To run a mutation, you first call `useImportProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importProductsMutation, { data, loading, error }] = useImportProductsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useImportProductsMutation(baseOptions?: Apollo.MutationHookOptions<ImportProductsMutation, ImportProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportProductsMutation, ImportProductsMutationVariables>(ImportProductsDocument, options);
      }
export type ImportProductsMutationHookResult = ReturnType<typeof useImportProductsMutation>;
export type ImportProductsMutationResult = Apollo.MutationResult<ImportProductsMutation>;
export type ImportProductsMutationOptions = Apollo.BaseMutationOptions<ImportProductsMutation, ImportProductsMutationVariables>;
export const GetProductVariantForUpdateCustomItemDocument = gql`
    query getProductVariantForUpdateCustomItem($args: GetProductVariantArgs!) {
  productVariant(args: $args) {
    id
    isPriceValid
    name
    propertiesValues {
      ... on ProductVariantPropertyTextValue {
        propertyDefinitionId
        propertyDefinition {
          _id
          type
          impactsLook
          sortPriority
          description {
            allTranslations {
              text
              languageCode
            }
          }
          name {
            allTranslations {
              text
              languageCode
            }
          }
          key
          valueFormatting {
            suffix
          }
        }
        value {
          id
          translation {
            allTranslations {
              text
              languageCode
            }
          }
        }
      }
      ... on ProductVariantPropertyNumberValue {
        propertyDefinitionId
        propertyDefinition {
          _id
          type
          impactsLook
          sortPriority
          description {
            allTranslations {
              text
              languageCode
            }
          }
          name {
            allTranslations {
              text
              languageCode
            }
          }
          key
          valueFormatting {
            suffix
          }
        }
        value {
          numberValue
        }
      }
      ... on ProductVariantPropertyBooleanValue {
        propertyDefinitionId
        propertyDefinition {
          _id
          type
          impactsLook
          sortPriority
          description {
            allTranslations {
              text
              languageCode
            }
          }
          name {
            allTranslations {
              text
              languageCode
            }
          }
          key
          valueFormatting {
            suffix
          }
        }
        value {
          booleanValue
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductVariantForUpdateCustomItemQuery__
 *
 * To run a query within a React component, call `useGetProductVariantForUpdateCustomItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductVariantForUpdateCustomItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductVariantForUpdateCustomItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetProductVariantForUpdateCustomItemQuery(baseOptions: Apollo.QueryHookOptions<GetProductVariantForUpdateCustomItemQuery, GetProductVariantForUpdateCustomItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductVariantForUpdateCustomItemQuery, GetProductVariantForUpdateCustomItemQueryVariables>(GetProductVariantForUpdateCustomItemDocument, options);
      }
export function useGetProductVariantForUpdateCustomItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductVariantForUpdateCustomItemQuery, GetProductVariantForUpdateCustomItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductVariantForUpdateCustomItemQuery, GetProductVariantForUpdateCustomItemQueryVariables>(GetProductVariantForUpdateCustomItemDocument, options);
        }
export type GetProductVariantForUpdateCustomItemQueryHookResult = ReturnType<typeof useGetProductVariantForUpdateCustomItemQuery>;
export type GetProductVariantForUpdateCustomItemLazyQueryHookResult = ReturnType<typeof useGetProductVariantForUpdateCustomItemLazyQuery>;
export type GetProductVariantForUpdateCustomItemQueryResult = Apollo.QueryResult<GetProductVariantForUpdateCustomItemQuery, GetProductVariantForUpdateCustomItemQueryVariables>;
export const CreateCustomerBlacklistDocument = gql`
    mutation createCustomerBlacklist($args: CustomerBlacklistCreateArgs!) {
  createCustomerBlacklist(args: $args) {
    _id
  }
}
    `;
export type CreateCustomerBlacklistMutationFn = Apollo.MutationFunction<CreateCustomerBlacklistMutation, CreateCustomerBlacklistMutationVariables>;

/**
 * __useCreateCustomerBlacklistMutation__
 *
 * To run a mutation, you first call `useCreateCustomerBlacklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerBlacklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerBlacklistMutation, { data, loading, error }] = useCreateCustomerBlacklistMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCreateCustomerBlacklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerBlacklistMutation, CreateCustomerBlacklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerBlacklistMutation, CreateCustomerBlacklistMutationVariables>(CreateCustomerBlacklistDocument, options);
      }
export type CreateCustomerBlacklistMutationHookResult = ReturnType<typeof useCreateCustomerBlacklistMutation>;
export type CreateCustomerBlacklistMutationResult = Apollo.MutationResult<CreateCustomerBlacklistMutation>;
export type CreateCustomerBlacklistMutationOptions = Apollo.BaseMutationOptions<CreateCustomerBlacklistMutation, CreateCustomerBlacklistMutationVariables>;
export const UpdateCustomerBlacklistDocument = gql`
    mutation updateCustomerBlacklist($args: CustomerBlacklistUpdateArgs!) {
  updateCustomerBlacklist(args: $args) {
    _id
  }
}
    `;
export type UpdateCustomerBlacklistMutationFn = Apollo.MutationFunction<UpdateCustomerBlacklistMutation, UpdateCustomerBlacklistMutationVariables>;

/**
 * __useUpdateCustomerBlacklistMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerBlacklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerBlacklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerBlacklistMutation, { data, loading, error }] = useUpdateCustomerBlacklistMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUpdateCustomerBlacklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerBlacklistMutation, UpdateCustomerBlacklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerBlacklistMutation, UpdateCustomerBlacklistMutationVariables>(UpdateCustomerBlacklistDocument, options);
      }
export type UpdateCustomerBlacklistMutationHookResult = ReturnType<typeof useUpdateCustomerBlacklistMutation>;
export type UpdateCustomerBlacklistMutationResult = Apollo.MutationResult<UpdateCustomerBlacklistMutation>;
export type UpdateCustomerBlacklistMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerBlacklistMutation, UpdateCustomerBlacklistMutationVariables>;
export const DeleteCustomerBlacklistDocument = gql`
    mutation deleteCustomerBlacklist($args: CustomerBlacklistDeleteArgs!) {
  deleteCustomerBlacklist(args: $args)
}
    `;
export type DeleteCustomerBlacklistMutationFn = Apollo.MutationFunction<DeleteCustomerBlacklistMutation, DeleteCustomerBlacklistMutationVariables>;

/**
 * __useDeleteCustomerBlacklistMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerBlacklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerBlacklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerBlacklistMutation, { data, loading, error }] = useDeleteCustomerBlacklistMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useDeleteCustomerBlacklistMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerBlacklistMutation, DeleteCustomerBlacklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerBlacklistMutation, DeleteCustomerBlacklistMutationVariables>(DeleteCustomerBlacklistDocument, options);
      }
export type DeleteCustomerBlacklistMutationHookResult = ReturnType<typeof useDeleteCustomerBlacklistMutation>;
export type DeleteCustomerBlacklistMutationResult = Apollo.MutationResult<DeleteCustomerBlacklistMutation>;
export type DeleteCustomerBlacklistMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerBlacklistMutation, DeleteCustomerBlacklistMutationVariables>;
export const GetActiveCustomersDocument = gql`
    query getActiveCustomers($opts: CustomerOpts) {
  getActiveCustomers(opts: $opts) {
    _id
    email
    firstname
    lastname
    dateOfBirth
  }
}
    `;

/**
 * __useGetActiveCustomersQuery__
 *
 * To run a query within a React component, call `useGetActiveCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCustomersQuery({
 *   variables: {
 *      opts: // value for 'opts'
 *   },
 * });
 */
export function useGetActiveCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveCustomersQuery, GetActiveCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCustomersQuery, GetActiveCustomersQueryVariables>(GetActiveCustomersDocument, options);
      }
export function useGetActiveCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCustomersQuery, GetActiveCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCustomersQuery, GetActiveCustomersQueryVariables>(GetActiveCustomersDocument, options);
        }
export type GetActiveCustomersQueryHookResult = ReturnType<typeof useGetActiveCustomersQuery>;
export type GetActiveCustomersLazyQueryHookResult = ReturnType<typeof useGetActiveCustomersLazyQuery>;
export type GetActiveCustomersQueryResult = Apollo.QueryResult<GetActiveCustomersQuery, GetActiveCustomersQueryVariables>;
export const GetExistingCustomerBlacklistsDocument = gql`
    query getExistingCustomerBlacklists($args: CustomerBlacklistFiltersArgs!) {
  getExistingCustomerBlacklists(args: $args) {
    _id
  }
}
    `;

/**
 * __useGetExistingCustomerBlacklistsQuery__
 *
 * To run a query within a React component, call `useGetExistingCustomerBlacklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingCustomerBlacklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingCustomerBlacklistsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetExistingCustomerBlacklistsQuery(baseOptions: Apollo.QueryHookOptions<GetExistingCustomerBlacklistsQuery, GetExistingCustomerBlacklistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExistingCustomerBlacklistsQuery, GetExistingCustomerBlacklistsQueryVariables>(GetExistingCustomerBlacklistsDocument, options);
      }
export function useGetExistingCustomerBlacklistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExistingCustomerBlacklistsQuery, GetExistingCustomerBlacklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExistingCustomerBlacklistsQuery, GetExistingCustomerBlacklistsQueryVariables>(GetExistingCustomerBlacklistsDocument, options);
        }
export type GetExistingCustomerBlacklistsQueryHookResult = ReturnType<typeof useGetExistingCustomerBlacklistsQuery>;
export type GetExistingCustomerBlacklistsLazyQueryHookResult = ReturnType<typeof useGetExistingCustomerBlacklistsLazyQuery>;
export type GetExistingCustomerBlacklistsQueryResult = Apollo.QueryResult<GetExistingCustomerBlacklistsQuery, GetExistingCustomerBlacklistsQueryVariables>;
export const SearchCustomerBlacklistsDocument = gql`
    query searchCustomerBlacklists($args: CustomerBlacklistsFiltersArgs!) {
  searchCustomerBlacklists(args: $args) {
    nodes {
      ...CustomerBlacklist
    }
    pageInfo {
      limit
      skip
      hasPrevPage
      hasNextPage
      total
    }
  }
}
    ${CustomerBlacklistFragmentDoc}`;

/**
 * __useSearchCustomerBlacklistsQuery__
 *
 * To run a query within a React component, call `useSearchCustomerBlacklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomerBlacklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomerBlacklistsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSearchCustomerBlacklistsQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomerBlacklistsQuery, SearchCustomerBlacklistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomerBlacklistsQuery, SearchCustomerBlacklistsQueryVariables>(SearchCustomerBlacklistsDocument, options);
      }
export function useSearchCustomerBlacklistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomerBlacklistsQuery, SearchCustomerBlacklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomerBlacklistsQuery, SearchCustomerBlacklistsQueryVariables>(SearchCustomerBlacklistsDocument, options);
        }
export type SearchCustomerBlacklistsQueryHookResult = ReturnType<typeof useSearchCustomerBlacklistsQuery>;
export type SearchCustomerBlacklistsLazyQueryHookResult = ReturnType<typeof useSearchCustomerBlacklistsLazyQuery>;
export type SearchCustomerBlacklistsQueryResult = Apollo.QueryResult<SearchCustomerBlacklistsQuery, SearchCustomerBlacklistsQueryVariables>;
export const GetCustomerBlacklistByIdDocument = gql`
    query getCustomerBlacklistById($id: ObjectId!) {
  getCustomerBlacklistById(id: $id) {
    ...CustomerBlacklist
  }
}
    ${CustomerBlacklistFragmentDoc}`;

/**
 * __useGetCustomerBlacklistByIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerBlacklistByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerBlacklistByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerBlacklistByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerBlacklistByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerBlacklistByIdQuery, GetCustomerBlacklistByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerBlacklistByIdQuery, GetCustomerBlacklistByIdQueryVariables>(GetCustomerBlacklistByIdDocument, options);
      }
export function useGetCustomerBlacklistByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerBlacklistByIdQuery, GetCustomerBlacklistByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerBlacklistByIdQuery, GetCustomerBlacklistByIdQueryVariables>(GetCustomerBlacklistByIdDocument, options);
        }
export type GetCustomerBlacklistByIdQueryHookResult = ReturnType<typeof useGetCustomerBlacklistByIdQuery>;
export type GetCustomerBlacklistByIdLazyQueryHookResult = ReturnType<typeof useGetCustomerBlacklistByIdLazyQuery>;
export type GetCustomerBlacklistByIdQueryResult = Apollo.QueryResult<GetCustomerBlacklistByIdQuery, GetCustomerBlacklistByIdQueryVariables>;
export const AddSecondaryCustomerToDealDocument = gql`
    mutation addSecondaryCustomerToDeal($dealId: ObjectId!, $selectedCustomerId: ObjectId!) {
  addSecondaryCustomerToDeal(
    dealId: $dealId
    selectedCustomerId: $selectedCustomerId
  ) {
    _id
    secondaryCustomers {
      _id
      firstname
      lastname
      email
    }
  }
}
    `;
export type AddSecondaryCustomerToDealMutationFn = Apollo.MutationFunction<AddSecondaryCustomerToDealMutation, AddSecondaryCustomerToDealMutationVariables>;

/**
 * __useAddSecondaryCustomerToDealMutation__
 *
 * To run a mutation, you first call `useAddSecondaryCustomerToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSecondaryCustomerToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSecondaryCustomerToDealMutation, { data, loading, error }] = useAddSecondaryCustomerToDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      selectedCustomerId: // value for 'selectedCustomerId'
 *   },
 * });
 */
export function useAddSecondaryCustomerToDealMutation(baseOptions?: Apollo.MutationHookOptions<AddSecondaryCustomerToDealMutation, AddSecondaryCustomerToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSecondaryCustomerToDealMutation, AddSecondaryCustomerToDealMutationVariables>(AddSecondaryCustomerToDealDocument, options);
      }
export type AddSecondaryCustomerToDealMutationHookResult = ReturnType<typeof useAddSecondaryCustomerToDealMutation>;
export type AddSecondaryCustomerToDealMutationResult = Apollo.MutationResult<AddSecondaryCustomerToDealMutation>;
export type AddSecondaryCustomerToDealMutationOptions = Apollo.BaseMutationOptions<AddSecondaryCustomerToDealMutation, AddSecondaryCustomerToDealMutationVariables>;
export const ChangeMainCustomerOfDealDocument = gql`
    mutation changeMainCustomerOfDeal($dealId: ObjectId!, $selectedCustomerId: ObjectId!) {
  changeMainCustomerOfDeal(
    dealId: $dealId
    selectedCustomerId: $selectedCustomerId
  ) {
    _id
    customer {
      ... on Customer {
        _id
        firstname
        lastname
        email
      }
    }
  }
}
    `;
export type ChangeMainCustomerOfDealMutationFn = Apollo.MutationFunction<ChangeMainCustomerOfDealMutation, ChangeMainCustomerOfDealMutationVariables>;

/**
 * __useChangeMainCustomerOfDealMutation__
 *
 * To run a mutation, you first call `useChangeMainCustomerOfDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMainCustomerOfDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMainCustomerOfDealMutation, { data, loading, error }] = useChangeMainCustomerOfDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      selectedCustomerId: // value for 'selectedCustomerId'
 *   },
 * });
 */
export function useChangeMainCustomerOfDealMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMainCustomerOfDealMutation, ChangeMainCustomerOfDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMainCustomerOfDealMutation, ChangeMainCustomerOfDealMutationVariables>(ChangeMainCustomerOfDealDocument, options);
      }
export type ChangeMainCustomerOfDealMutationHookResult = ReturnType<typeof useChangeMainCustomerOfDealMutation>;
export type ChangeMainCustomerOfDealMutationResult = Apollo.MutationResult<ChangeMainCustomerOfDealMutation>;
export type ChangeMainCustomerOfDealMutationOptions = Apollo.BaseMutationOptions<ChangeMainCustomerOfDealMutation, ChangeMainCustomerOfDealMutationVariables>;
export const ConnectCustomerToDealDocument = gql`
    mutation connectCustomerToDeal($dealId: ObjectId!, $customerId: ObjectId!) {
  connectCustomerToDeal(dealId: $dealId, customerId: $customerId) {
    _id
    customer {
      ... on Customer {
        _id
        firstname
        lastname
        email
      }
    }
  }
}
    `;
export type ConnectCustomerToDealMutationFn = Apollo.MutationFunction<ConnectCustomerToDealMutation, ConnectCustomerToDealMutationVariables>;

/**
 * __useConnectCustomerToDealMutation__
 *
 * To run a mutation, you first call `useConnectCustomerToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectCustomerToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectCustomerToDealMutation, { data, loading, error }] = useConnectCustomerToDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useConnectCustomerToDealMutation(baseOptions?: Apollo.MutationHookOptions<ConnectCustomerToDealMutation, ConnectCustomerToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectCustomerToDealMutation, ConnectCustomerToDealMutationVariables>(ConnectCustomerToDealDocument, options);
      }
export type ConnectCustomerToDealMutationHookResult = ReturnType<typeof useConnectCustomerToDealMutation>;
export type ConnectCustomerToDealMutationResult = Apollo.MutationResult<ConnectCustomerToDealMutation>;
export type ConnectCustomerToDealMutationOptions = Apollo.BaseMutationOptions<ConnectCustomerToDealMutation, ConnectCustomerToDealMutationVariables>;
export const RemoveSecondaryCustomerToDealDocument = gql`
    mutation removeSecondaryCustomerToDeal($dealId: ObjectId!, $selectedCustomerId: ObjectId!) {
  removeSecondaryCustomerToDeal(
    dealId: $dealId
    selectedCustomerId: $selectedCustomerId
  ) {
    _id
    secondaryCustomers {
      _id
      firstname
      lastname
      email
    }
  }
}
    `;
export type RemoveSecondaryCustomerToDealMutationFn = Apollo.MutationFunction<RemoveSecondaryCustomerToDealMutation, RemoveSecondaryCustomerToDealMutationVariables>;

/**
 * __useRemoveSecondaryCustomerToDealMutation__
 *
 * To run a mutation, you first call `useRemoveSecondaryCustomerToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSecondaryCustomerToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSecondaryCustomerToDealMutation, { data, loading, error }] = useRemoveSecondaryCustomerToDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      selectedCustomerId: // value for 'selectedCustomerId'
 *   },
 * });
 */
export function useRemoveSecondaryCustomerToDealMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSecondaryCustomerToDealMutation, RemoveSecondaryCustomerToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSecondaryCustomerToDealMutation, RemoveSecondaryCustomerToDealMutationVariables>(RemoveSecondaryCustomerToDealDocument, options);
      }
export type RemoveSecondaryCustomerToDealMutationHookResult = ReturnType<typeof useRemoveSecondaryCustomerToDealMutation>;
export type RemoveSecondaryCustomerToDealMutationResult = Apollo.MutationResult<RemoveSecondaryCustomerToDealMutation>;
export type RemoveSecondaryCustomerToDealMutationOptions = Apollo.BaseMutationOptions<RemoveSecondaryCustomerToDealMutation, RemoveSecondaryCustomerToDealMutationVariables>;
export const Menubar_QueryDocument = gql`
    query Menubar_Query($opts: CompanyOpts) {
  getActiveCompanies(opts: $opts) {
    ...CompanyDropdown_Companies
  }
}
    ${CompanyDropdown_CompaniesFragmentDoc}`;

/**
 * __useMenubar_QueryQuery__
 *
 * To run a query within a React component, call `useMenubar_QueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenubar_QueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenubar_QueryQuery({
 *   variables: {
 *      opts: // value for 'opts'
 *   },
 * });
 */
export function useMenubar_QueryQuery(baseOptions?: Apollo.QueryHookOptions<Menubar_QueryQuery, Menubar_QueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Menubar_QueryQuery, Menubar_QueryQueryVariables>(Menubar_QueryDocument, options);
      }
export function useMenubar_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Menubar_QueryQuery, Menubar_QueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Menubar_QueryQuery, Menubar_QueryQueryVariables>(Menubar_QueryDocument, options);
        }
export type Menubar_QueryQueryHookResult = ReturnType<typeof useMenubar_QueryQuery>;
export type Menubar_QueryLazyQueryHookResult = ReturnType<typeof useMenubar_QueryLazyQuery>;
export type Menubar_QueryQueryResult = Apollo.QueryResult<Menubar_QueryQuery, Menubar_QueryQueryVariables>;
export const UpdateItemCategoryIdealoIdMapsDocument = gql`
    mutation updateItemCategoryIdealoIdMaps($args: [ItemCategoryIdealoIdMapArgs!]!) {
  updateItemCategoryIdealoIdMaps(args: $args)
}
    `;
export type UpdateItemCategoryIdealoIdMapsMutationFn = Apollo.MutationFunction<UpdateItemCategoryIdealoIdMapsMutation, UpdateItemCategoryIdealoIdMapsMutationVariables>;

/**
 * __useUpdateItemCategoryIdealoIdMapsMutation__
 *
 * To run a mutation, you first call `useUpdateItemCategoryIdealoIdMapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemCategoryIdealoIdMapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemCategoryIdealoIdMapsMutation, { data, loading, error }] = useUpdateItemCategoryIdealoIdMapsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUpdateItemCategoryIdealoIdMapsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemCategoryIdealoIdMapsMutation, UpdateItemCategoryIdealoIdMapsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemCategoryIdealoIdMapsMutation, UpdateItemCategoryIdealoIdMapsMutationVariables>(UpdateItemCategoryIdealoIdMapsDocument, options);
      }
export type UpdateItemCategoryIdealoIdMapsMutationHookResult = ReturnType<typeof useUpdateItemCategoryIdealoIdMapsMutation>;
export type UpdateItemCategoryIdealoIdMapsMutationResult = Apollo.MutationResult<UpdateItemCategoryIdealoIdMapsMutation>;
export type UpdateItemCategoryIdealoIdMapsMutationOptions = Apollo.BaseMutationOptions<UpdateItemCategoryIdealoIdMapsMutation, UpdateItemCategoryIdealoIdMapsMutationVariables>;
export const CreateOrUpdateReady2OrderApiKeyDocument = gql`
    mutation createOrUpdateReady2OrderApiKey($args: CreateOrUpdateReady2OrderApiKeyArgs!) {
  createOrUpdateReady2OrderApiKey(args: $args)
}
    `;
export type CreateOrUpdateReady2OrderApiKeyMutationFn = Apollo.MutationFunction<CreateOrUpdateReady2OrderApiKeyMutation, CreateOrUpdateReady2OrderApiKeyMutationVariables>;

/**
 * __useCreateOrUpdateReady2OrderApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateReady2OrderApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateReady2OrderApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateReady2OrderApiKeyMutation, { data, loading, error }] = useCreateOrUpdateReady2OrderApiKeyMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCreateOrUpdateReady2OrderApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateReady2OrderApiKeyMutation, CreateOrUpdateReady2OrderApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateReady2OrderApiKeyMutation, CreateOrUpdateReady2OrderApiKeyMutationVariables>(CreateOrUpdateReady2OrderApiKeyDocument, options);
      }
export type CreateOrUpdateReady2OrderApiKeyMutationHookResult = ReturnType<typeof useCreateOrUpdateReady2OrderApiKeyMutation>;
export type CreateOrUpdateReady2OrderApiKeyMutationResult = Apollo.MutationResult<CreateOrUpdateReady2OrderApiKeyMutation>;
export type CreateOrUpdateReady2OrderApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateReady2OrderApiKeyMutation, CreateOrUpdateReady2OrderApiKeyMutationVariables>;
export const SaveReady2OrderProductMapsDocument = gql`
    mutation saveReady2OrderProductMaps($args: SaveReady2OrderProductMapsArgs!) {
  saveReady2OrderProductMaps(args: $args)
}
    `;
export type SaveReady2OrderProductMapsMutationFn = Apollo.MutationFunction<SaveReady2OrderProductMapsMutation, SaveReady2OrderProductMapsMutationVariables>;

/**
 * __useSaveReady2OrderProductMapsMutation__
 *
 * To run a mutation, you first call `useSaveReady2OrderProductMapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReady2OrderProductMapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReady2OrderProductMapsMutation, { data, loading, error }] = useSaveReady2OrderProductMapsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSaveReady2OrderProductMapsMutation(baseOptions?: Apollo.MutationHookOptions<SaveReady2OrderProductMapsMutation, SaveReady2OrderProductMapsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReady2OrderProductMapsMutation, SaveReady2OrderProductMapsMutationVariables>(SaveReady2OrderProductMapsDocument, options);
      }
export type SaveReady2OrderProductMapsMutationHookResult = ReturnType<typeof useSaveReady2OrderProductMapsMutation>;
export type SaveReady2OrderProductMapsMutationResult = Apollo.MutationResult<SaveReady2OrderProductMapsMutation>;
export type SaveReady2OrderProductMapsMutationOptions = Apollo.BaseMutationOptions<SaveReady2OrderProductMapsMutation, SaveReady2OrderProductMapsMutationVariables>;
export const GetReady2OrderProductNamesDocument = gql`
    query getReady2OrderProductNames($shopId: ObjectId!) {
  getReady2OrderProductNames(shopId: $shopId)
}
    `;

/**
 * __useGetReady2OrderProductNamesQuery__
 *
 * To run a query within a React component, call `useGetReady2OrderProductNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReady2OrderProductNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReady2OrderProductNamesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useGetReady2OrderProductNamesQuery(baseOptions: Apollo.QueryHookOptions<GetReady2OrderProductNamesQuery, GetReady2OrderProductNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReady2OrderProductNamesQuery, GetReady2OrderProductNamesQueryVariables>(GetReady2OrderProductNamesDocument, options);
      }
export function useGetReady2OrderProductNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReady2OrderProductNamesQuery, GetReady2OrderProductNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReady2OrderProductNamesQuery, GetReady2OrderProductNamesQueryVariables>(GetReady2OrderProductNamesDocument, options);
        }
export type GetReady2OrderProductNamesQueryHookResult = ReturnType<typeof useGetReady2OrderProductNamesQuery>;
export type GetReady2OrderProductNamesLazyQueryHookResult = ReturnType<typeof useGetReady2OrderProductNamesLazyQuery>;
export type GetReady2OrderProductNamesQueryResult = Apollo.QueryResult<GetReady2OrderProductNamesQuery, GetReady2OrderProductNamesQueryVariables>;
export const ProductConfigurator_QueryDocument = gql`
    query ProductConfigurator_Query($opts: ItemCategoryOpts) {
  getItemCategories(opts: $opts) {
    ...CrawlerConfig_ItemCategories
  }
}
    ${CrawlerConfig_ItemCategoriesFragmentDoc}`;

/**
 * __useProductConfigurator_QueryQuery__
 *
 * To run a query within a React component, call `useProductConfigurator_QueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductConfigurator_QueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductConfigurator_QueryQuery({
 *   variables: {
 *      opts: // value for 'opts'
 *   },
 * });
 */
export function useProductConfigurator_QueryQuery(baseOptions?: Apollo.QueryHookOptions<ProductConfigurator_QueryQuery, ProductConfigurator_QueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductConfigurator_QueryQuery, ProductConfigurator_QueryQueryVariables>(ProductConfigurator_QueryDocument, options);
      }
export function useProductConfigurator_QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductConfigurator_QueryQuery, ProductConfigurator_QueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductConfigurator_QueryQuery, ProductConfigurator_QueryQueryVariables>(ProductConfigurator_QueryDocument, options);
        }
export type ProductConfigurator_QueryQueryHookResult = ReturnType<typeof useProductConfigurator_QueryQuery>;
export type ProductConfigurator_QueryLazyQueryHookResult = ReturnType<typeof useProductConfigurator_QueryLazyQuery>;
export type ProductConfigurator_QueryQueryResult = Apollo.QueryResult<ProductConfigurator_QueryQuery, ProductConfigurator_QueryQueryVariables>;
export const LoginEmployeeDocument = gql`
    mutation loginEmployee($username: String!, $password: String!) {
  loginEmployee(username: $username, password: $password) {
    token
    email
    firstname
    lastname
    roles
    _id
    company {
      _id
    }
    preferences {
      defaultShopId
    }
  }
}
    `;
export type LoginEmployeeMutationFn = Apollo.MutationFunction<LoginEmployeeMutation, LoginEmployeeMutationVariables>;

/**
 * __useLoginEmployeeMutation__
 *
 * To run a mutation, you first call `useLoginEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginEmployeeMutation, { data, loading, error }] = useLoginEmployeeMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<LoginEmployeeMutation, LoginEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginEmployeeMutation, LoginEmployeeMutationVariables>(LoginEmployeeDocument, options);
      }
export type LoginEmployeeMutationHookResult = ReturnType<typeof useLoginEmployeeMutation>;
export type LoginEmployeeMutationResult = Apollo.MutationResult<LoginEmployeeMutation>;
export type LoginEmployeeMutationOptions = Apollo.BaseMutationOptions<LoginEmployeeMutation, LoginEmployeeMutationVariables>;